import * as React from "react";
import type { SVGProps } from "react";
const SvgBolivia = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>
        {
          ".Bolivia_svg__cls-11{fill:#007934}.Bolivia_svg__cls-13{fill:#ffe000}.Bolivia_svg__cls-12{fill:#d52b1e}.Bolivia_svg__cls-4{fill:#a05a2c}.Bolivia_svg__cls-10,.Bolivia_svg__cls-11,.Bolivia_svg__cls-12,.Bolivia_svg__cls-13,.Bolivia_svg__cls-14,.Bolivia_svg__cls-15,.Bolivia_svg__cls-16,.Bolivia_svg__cls-17,.Bolivia_svg__cls-18,.Bolivia_svg__cls-19,.Bolivia_svg__cls-20,.Bolivia_svg__cls-21,.Bolivia_svg__cls-23,.Bolivia_svg__cls-29,.Bolivia_svg__cls-32,.Bolivia_svg__cls-4,.Bolivia_svg__cls-5,.Bolivia_svg__cls-6,.Bolivia_svg__cls-7,.Bolivia_svg__cls-8,.Bolivia_svg__cls-9{stroke:#000}.Bolivia_svg__cls-10,.Bolivia_svg__cls-11,.Bolivia_svg__cls-12,.Bolivia_svg__cls-13,.Bolivia_svg__cls-14,.Bolivia_svg__cls-15,.Bolivia_svg__cls-16,.Bolivia_svg__cls-17,.Bolivia_svg__cls-18,.Bolivia_svg__cls-19,.Bolivia_svg__cls-20,.Bolivia_svg__cls-21,.Bolivia_svg__cls-23,.Bolivia_svg__cls-31,.Bolivia_svg__cls-32,.Bolivia_svg__cls-38,.Bolivia_svg__cls-4,.Bolivia_svg__cls-5,.Bolivia_svg__cls-6,.Bolivia_svg__cls-7,.Bolivia_svg__cls-8,.Bolivia_svg__cls-9{stroke-width:.5px}.Bolivia_svg__cls-19,.Bolivia_svg__cls-5{fill:#e7e7e7}.Bolivia_svg__cls-6{fill:#00e519}.Bolivia_svg__cls-7{fill:#ffe533}.Bolivia_svg__cls-31,.Bolivia_svg__cls-38,.Bolivia_svg__cls-8,.Bolivia_svg__cls-9{fill:none}.Bolivia_svg__cls-31,.Bolivia_svg__cls-8{stroke-linecap:round}.Bolivia_svg__cls-10{fill:#cce5e5}.Bolivia_svg__cls-14{fill:#f7e214}.Bolivia_svg__cls-15{fill:#007a3d}.Bolivia_svg__cls-16,.Bolivia_svg__cls-29,.Bolivia_svg__cls-32{fill:#e8a30e}.Bolivia_svg__cls-17{fill:#005000}.Bolivia_svg__cls-18,.Bolivia_svg__cls-36{fill:#fff}.Bolivia_svg__cls-19,.Bolivia_svg__cls-31,.Bolivia_svg__cls-32{stroke-linejoin:round}.Bolivia_svg__cls-20{fill:#cccccf}.Bolivia_svg__cls-22,.Bolivia_svg__cls-23{fill:#452c25}.Bolivia_svg__cls-29{stroke-width:.1px}.Bolivia_svg__cls-31{stroke:#e7e7e7}.Bolivia_svg__cls-32{stroke-linecap:square}.Bolivia_svg__cls-33{fill:#bd8759}.Bolivia_svg__cls-34{fill:#dcddde}.Bolivia_svg__cls-35{fill:#d9c0b9}.Bolivia_svg__cls-38{stroke:#939598}.Bolivia_svg__cls-40{fill:#7a2e26}.Bolivia_svg__cls-41{fill:#5e3f17}.Bolivia_svg__cls-42{fill:#842116}"
        }
      </style>
    </defs>
    <g id="Bolivia_svg__Bolivia">
      <path
        id="Bolivia_svg__rect4"
        d="M0 0h1280v720H0z"
        style={{
          fill: "#007934",
        }}
      />
      <path
        id="Bolivia_svg__rect6"
        d="M0 0h1280v480H0z"
        style={{
          fill: "#ffe000",
        }}
      />
      <path
        id="Bolivia_svg__rect8"
        d="M0 0h1280v240H0z"
        style={{
          fill: "#d52b1e",
        }}
      />
      <g id="Bolivia_svg__g14699">
        <g id="Bolivia_svg__g46545">
          <g id="Bolivia_svg__g46547">
            <path
              id="Bolivia_svg__path46549"
              d="M711.87 316.07c-.87.83-146.38 146.17-147 146.81-.5-.38-1.47-1.12-1.94-1.46.6-.61 146.18-145.89 147-146.77-.37-.43 2.62 1.83 1.93 1.42Z"
              className="Bolivia_svg__cls-4"
            />
            <path
              id="Bolivia_svg__path46551"
              d="M721 306.8c-.54 1-2.14 3.67-1.52 5.63-1.18-.77-1.78-1.35-2.92-2.19.77 1.34.54 2.12-.19 2.61-.48.63-2.11.48-3.16.29a8.65 8.65 0 0 0 3.66 1.43c1.44.14 2 .06 2.83.15a19.6 19.6 0 0 1-4.8 1.5 5.94 5.94 0 0 1-3.06-.15c-.87.83-2.78-.54-1.93-1.42a3.8 3.8 0 0 1-.51-2 8.77 8.77 0 0 1 1-4.54 12 12 0 0 0 .73 2.55 7.3 7.3 0 0 0 1.66 2.14 2.22 2.22 0 0 1 .15-2.63 2.58 2.58 0 0 1 2.94-.38c-.94-.73-1.65-1.16-2.78-2a21.4 21.4 0 0 0 6.14-2.19c1.23-.73 5.14-3.83 7.34-5.7a81 81 0 0 0-5.58 6.9Z"
              className="Bolivia_svg__cls-5"
            />
          </g>
          <g id="Bolivia_svg__g46553">
            <path
              id="Bolivia_svg__path46555"
              d="M739.54 334.18c-1.1.6-187.7 105.92-188.52 106.38-.36-.49-1-1.42-1.4-1.86.77-.45 187.38-105.7 188.52-106.34-.22-.5 1.93 2.38 1.4 1.82Z"
              className="Bolivia_svg__cls-4"
            />
            <path
              id="Bolivia_svg__path46557"
              d="M751.32 327.43c-.84.87-3.23 3-3.26 5.06-.9-1-1.28-1.72-2.11-2.8.31 1.48-.16 2.17-1 2.47-.66.49-2.19 0-3.13-.47a7.66 7.66 0 0 0 3.05 2.24c1.35.48 1.86.52 2.68.81a20.3 20.3 0 0 1-5.1.31 5.6 5.6 0 0 1-2.89-.87c-1.1.6-2.5-1.17-1.4-1.82a3.7 3.7 0 0 1 .17-2.09 9.5 9.5 0 0 1 2.41-4.13 12 12 0 0 0-.12 2.62 6.6 6.6 0 0 0 .91 2.46 2.33 2.33 0 0 1 1-2.5 2.59 2.59 0 0 1 2.94.33c-.66-.92-1.21-1.5-2-2.56a22.7 22.7 0 0 0 6.6-.65c1.43-.42 6.18-2.47 8.9-3.75a91 91 0 0 0-7.59 5.34Z"
              className="Bolivia_svg__cls-5"
            />
          </g>
          <g id="Bolivia_svg__g46559">
            <path
              id="Bolivia_svg__path46561"
              d="M723.48 326.22c-1 .73-168.68 127.29-169.41 127.84-.44-.43-1.28-1.28-1.69-1.67.69-.54 168.44-127 169.42-127.8-.3-.47 2.3 2.13 1.68 1.63Z"
              className="Bolivia_svg__cls-4"
            />
            <path
              id="Bolivia_svg__path46563"
              d="M734.06 318.14c-.7.95-2.72 3.39-2.41 5.39-1.06-.9-1.55-1.55-2.54-2.52.54 1.43.18 2.18-.62 2.57-.57.57-2.17.23-3.17-.09a8.26 8.26 0 0 0 3.38 1.86c1.41.31 1.93.29 2.79.48a20.5 20.5 0 0 1-5 .91 5.7 5.7 0 0 1-3-.52c-1 .73-2.66-.86-1.68-1.63a3.7 3.7 0 0 1-.17-2.09 9 9 0 0 1 1.72-4.37 11 11 0 0 0 .31 2.61 7.1 7.1 0 0 0 1.29 2.32 2.26 2.26 0 0 1 .58-2.59 2.6 2.6 0 0 1 3 0c-.81-.83-1.44-1.34-2.43-2.29a22.2 22.2 0 0 0 6.43-1.43c1.34-.59 5.72-3.19 8.2-4.78a85 85 0 0 0-6.64 6.2Z"
              className="Bolivia_svg__cls-5"
            />
          </g>
        </g>
        <g id="Bolivia_svg__g38441">
          <g id="Bolivia_svg__g3476">
            <path
              id="Bolivia_svg__path1717"
              d="M566.13 316.07c.87.83 146.38 146.17 147 146.81.5-.38 1.47-1.12 1.94-1.46-.6-.61-146.18-145.89-147-146.77.37-.43-2.62 1.83-1.93 1.42Z"
              className="Bolivia_svg__cls-4"
            />
            <path
              id="Bolivia_svg__path3474"
              d="M557 306.8c.54 1 2.14 3.67 1.52 5.63 1.18-.77 1.78-1.35 2.92-2.19-.77 1.34-.54 2.12.19 2.61.48.63 2.11.48 3.16.29a8.65 8.65 0 0 1-3.66 1.43c-1.44.14-2 .06-2.83.15a19.6 19.6 0 0 0 4.8 1.5 5.94 5.94 0 0 0 3.06-.15c.87.83 2.78-.54 1.93-1.42a3.8 3.8 0 0 0 .51-2 8.77 8.77 0 0 0-1-4.54 12 12 0 0 1-.73 2.55 7.3 7.3 0 0 1-1.66 2.14 2.22 2.22 0 0 0-.15-2.63 2.58 2.58 0 0 0-2.94-.38c.94-.73 1.65-1.16 2.78-2a21.4 21.4 0 0 1-6.14-2.19c-1.23-.73-5.14-3.83-7.34-5.7a81 81 0 0 1 5.58 6.9Z"
              className="Bolivia_svg__cls-5"
            />
          </g>
          <g id="Bolivia_svg__g1737">
            <path
              id="Bolivia_svg__path1739"
              d="M538.46 334.18c1.1.6 187.7 105.92 188.52 106.38.36-.49 1-1.42 1.4-1.86-.77-.45-187.38-105.7-188.52-106.34.22-.5-1.93 2.38-1.4 1.82Z"
              className="Bolivia_svg__cls-4"
            />
            <path
              id="Bolivia_svg__path1741"
              d="M526.68 327.43c.84.87 3.23 3 3.26 5.06.9-1 1.28-1.72 2.11-2.8-.31 1.48.16 2.17 1 2.47.66.49 2.19 0 3.13-.47a7.66 7.66 0 0 1-3.05 2.24c-1.35.48-1.86.52-2.68.81a20.3 20.3 0 0 0 5.1.31 5.6 5.6 0 0 0 2.89-.87c1.1.6 2.5-1.17 1.4-1.82a3.7 3.7 0 0 0-.17-2.09 9.5 9.5 0 0 0-2.41-4.13 12 12 0 0 1 .12 2.62 6.6 6.6 0 0 1-.91 2.46 2.33 2.33 0 0 0-1-2.5 2.59 2.59 0 0 0-2.94.33c.66-.92 1.21-1.5 2-2.56a22.7 22.7 0 0 1-6.6-.65c-1.43-.42-6.18-2.47-8.9-3.75a91 91 0 0 1 7.59 5.34Z"
              className="Bolivia_svg__cls-5"
            />
          </g>
          <g id="Bolivia_svg__g1731">
            <path
              id="Bolivia_svg__path1733"
              d="M554.52 326.22c1 .73 168.68 127.29 169.41 127.84.44-.43 1.28-1.28 1.69-1.67-.69-.54-168.44-127-169.42-127.8.3-.47-2.3 2.13-1.68 1.63Z"
              className="Bolivia_svg__cls-4"
            />
            <path
              id="Bolivia_svg__path1735"
              d="M543.94 318.14c.7.95 2.72 3.39 2.41 5.39 1.06-.9 1.55-1.55 2.54-2.52-.54 1.43-.18 2.18.62 2.57.57.57 2.17.23 3.17-.09a8.26 8.26 0 0 1-3.38 1.86c-1.41.31-1.93.29-2.79.48a20.5 20.5 0 0 0 5 .91 5.7 5.7 0 0 0 3-.52c1 .73 2.66-.86 1.68-1.63a3.7 3.7 0 0 0 .17-2.09 9 9 0 0 0-1.72-4.37 11 11 0 0 1-.31 2.61 7.1 7.1 0 0 1-1.29 2.32 2.26 2.26 0 0 0-.58-2.59 2.6 2.6 0 0 0-3 0c.81-.83 1.44-1.34 2.43-2.29a22.2 22.2 0 0 1-6.43-1.43c-1.34-.59-5.72-3.19-8.2-4.78a85 85 0 0 1 6.64 6.2Z"
              className="Bolivia_svg__cls-5"
            />
          </g>
        </g>
        <g id="Bolivia_svg__g2373">
          <path
            id="Bolivia_svg__path2375"
            d="M609.21 425.18c5.87-4 22.63-6.09 25-5.43-11.92 9.07-23.96 9.4-25 5.43Z"
            className="Bolivia_svg__cls-6"
          />
          <path
            id="Bolivia_svg__path2377"
            d="M609.27 425.21c1 4 13 3.61 24.9-5.41-12.72 3.85-23.47 6.08-24.9 5.41Z"
            className="Bolivia_svg__cls-7"
          />
          <path
            id="Bolivia_svg__path2379"
            d="M609.27 425.21c1 4 13 3.61 24.9-5.41-12.72 3.85-23.47 6.08-24.9 5.41Z"
            className="Bolivia_svg__cls-8"
          />
          <path
            id="Bolivia_svg__path2381"
            d="M609.23 425.13c6.26-4.25 23.52-5.88 25-5.45-11.93 9-24 9.42-25 5.45Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2383"
            d="m680.34 330.25-38.2 78.48c-1.89 1.47-3.47-.51-4-.29-2.29 2.57-5.44 3.1-6.11 3.7-2.65 3.62-1.19 6.56-1 6.8 2 2.69-2.35 5.3-2.18 6.12-.85 1.51-4 1.17-4.7 3-.15-.21-6.51 12.49-7.18 13.84-.95.74-5.47 9.19-5.47 9.19-3.17-.05-15.35-7.82-15.59-7.7 6.85-10.95 23.26-27.75 22.93-28.83 4.61-7.81 12-16.27 15.15-16.21 4.5-2.37 6.69-8.45 5.82-9.86a8.68 8.68 0 0 0 5.57-2.25l28.2-56.36c2.35-.78 2 .18 2.75 1.54 0 0 1.51-1.8 1.41-2 1.33-.65 2.63.27 2.64.86Z"
            className="Bolivia_svg__cls-4"
          />
          <path
            id="Bolivia_svg__path2390"
            d="M681.82 313.12c-.73 1.55.4 1.56.79 1.77l1.62.44c1.84 0 2.8 1 2.82 1.56l-44.91 91.84c-1.89 1.47-3.71-.38-4.29-.15l30.79-62.75s11.86-22.05 15-28.18l-4.07-1.74c-1.27-.3-1.65-1.15-1.09-2.43l18.86-32.43-15.2 31.48-.28.59"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path2392"
            d="M681.82 313.12c-.73 1.55.4 1.56.79 1.77l1.62.44c1.84 0 2.8 1 2.82 1.56l-44.91 91.84c-1.89 1.47-3.71-.38-4.29-.15l30.79-62.75s11.86-22.05 15-28.18l-4.07-1.74c-1.27-.3-1.65-1.15-1.09-2.43l18.86-32.43-15.2 31.48-.28.59"
            className="Bolivia_svg__cls-5"
          />
          <path
            id="Bolivia_svg__path2394"
            d="M622.21 408.66c-4.41-.19-6.89 3.07-4 7"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2396"
            d="M620.27 412.13a2 2 0 0 1-2.58-.5"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2398"
            d="M640.56 392c-2.33 8.41-6.57 14-7.42 15.7-3.24 3.31-5.92 10.82-5.43 12.13l-12.15 20"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2400"
            d="M641.94 409.05c-2-.7-8.55-6.81-15-5.75-4.92 5.72-7.86 11.54-8.74 12.34a74.6 74.6 0 0 0 11.42 8.15 5 5 0 0 0 1.48-2.3 1.77 1.77 0 0 0-.29-2.61c.17-3.69 2.85-6.26 5.57-6.44 3.42-.28 2.46-.56 2.89-.57a8.7 8.7 0 0 0 2.67-2.82Z"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path2402"
            d="M641.94 409.05c-2-.7-8.55-6.81-15-5.75-4.92 5.72-7.86 11.54-8.74 12.34a74.6 74.6 0 0 0 11.42 8.15 5 5 0 0 0 1.48-2.3 1.77 1.77 0 0 0-.29-2.61c.17-3.69 2.85-6.26 5.57-6.44 3.42-.28 2.46-.56 2.89-.57a8.7 8.7 0 0 0 2.67-2.82Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2404"
            d="M635.41 409.17c-3-.06-6.11 1.38-7.13 3.95l7.13-3.95"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path2406"
            d="M635.41 409.17c-3-.06-6.11 1.38-7.13 3.95"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2408"
            d="M622.89 414.14a1.47 1.47 0 0 0 1.8.71 1.18 1.18 0 0 0 .81-1.57 1.47 1.47 0 0 0-1.82-.67 1.12 1.12 0 0 0-.79 1.53Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2410"
            d="M626.64 409a1.52 1.52 0 0 0 1.84.7 1.14 1.14 0 0 0 .78-1.56 1.42 1.42 0 0 0-1.78-.68 1.15 1.15 0 0 0-.84 1.54Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2412"
            d="M677 339.17a2.14 2.14 0 0 0 1.14-3l-7-2.54a2.76 2.76 0 0 0-1.53 1.09 1.33 1.33 0 0 0 .25 1.78l7.17 2.71"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path2414"
            d="M677 339.17a2.14 2.14 0 0 0 1.14-3l-7-2.54a2.76 2.76 0 0 0-1.53 1.09 1.33 1.33 0 0 0 .25 1.78l7.17 2.71"
            className="Bolivia_svg__cls-9"
          />
        </g>
        <g id="Bolivia_svg__g3429">
          <path
            id="Bolivia_svg__path3431"
            d="M600.8 429.09c5.79-4.09 22.5-6.44 24.87-5.81-11.67 9.25-23.76 9.72-24.87 5.81Z"
            className="Bolivia_svg__cls-6"
          />
          <path
            id="Bolivia_svg__path3433"
            d="M600.86 429.11c1.11 3.95 13.09 3.42 24.79-5.78-12.65 4.04-23.35 6.43-24.79 5.78Z"
            className="Bolivia_svg__cls-7"
          />
          <path
            id="Bolivia_svg__path3435"
            d="M600.86 429.11c1.11 3.95 13.09 3.42 24.79-5.78-12.65 4.04-23.35 6.43-24.79 5.78Z"
            className="Bolivia_svg__cls-8"
          />
          <path
            id="Bolivia_svg__path3437"
            d="M600.82 429c6.17-4.35 23.39-6.23 24.92-5.83-11.74 9.25-23.8 9.83-24.92 5.83Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3439"
            d="m670 333.1-36.6 79c-1.86 1.5-3.48-.45-4-.22-2.24 2.6-5.38 3.18-6 3.79-2.58 3.66-1.06 6.57-.89 6.81 2 2.66-2.24 5.33-2.05 6.16-.82 1.51-4 1.22-4.65 3.05-.15-.2-6.25 12.58-6.89 13.95-.93.75-5.28 9.27-5.28 9.27-3.17 0-15.51-7.59-15.75-7.47 6.63-11.05 22.7-28.1 22.34-29.16 4.46-7.88 11.65-16.45 14.82-16.45 4.45-2.43 6.51-8.54 5.61-9.93a8.72 8.72 0 0 0 5.53-2.34l27-56.77c2.34-.82 2 .15 2.78 1.5 0 0 1.47-1.83 1.37-2.05 1.31-.67 2.63.24 2.66.82Z"
            className="Bolivia_svg__cls-4"
          />
          <path
            id="Bolivia_svg__path3442"
            d="m670 333.1-36.6 79c-1.86 1.5-3.48-.45-4-.22-2.24 2.6-5.38 3.18-6 3.79-2.58 3.66-1.06 6.57-.89 6.81 2 2.66-2.24 5.33-2.05 6.16-.82 1.51-4 1.22-4.65 3.05-.15-.2-6.25 12.58-6.89 13.95-.93.75-5.28 9.27-5.28 9.27-3.17 0-15.51-7.59-15.75-7.47 6.63-11.05 22.7-28.1 22.34-29.16 4.46-7.88 11.65-16.45 14.82-16.45 4.45-2.43 6.51-8.54 5.61-9.93a8.72 8.72 0 0 0 5.53-2.34l27-56.77c2.34-.82 2 .15 2.78 1.5 0 0 1.47-1.83 1.37-2.05 1.31-.67 2.63.24 2.66.82Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3446"
            d="M671.12 316c-.7 1.56.43 1.55.82 1.75l1.63.42c1.84 0 2.82.93 2.85 1.52l-43 92.49c-1.86 1.5-3.71-.32-4.29-.08l29.51-63.2S670 326.63 673 320.46l-4.11-1.68c-1.27-.29-1.67-1.13-1.14-2.42l18.2-32.7-14.56 31.7-.26.6"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3448"
            d="M671.12 316c-.7 1.56.43 1.55.82 1.75l1.63.42c1.84 0 2.82.93 2.85 1.52l-43 92.49c-1.86 1.5-3.71-.32-4.29-.08l29.51-63.2S670 326.63 673 320.46l-4.11-1.68c-1.27-.29-1.67-1.13-1.14-2.42l18.2-32.7-14.56 31.7-.26.6"
            className="Bolivia_svg__cls-5"
          />
          <path
            id="Bolivia_svg__path3450"
            d="M613.46 412.37c-4.42-.12-6.82 3.17-3.86 7"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3452"
            d="M611.59 415.87a2 2 0 0 1-2.59-.46"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3454"
            d="M631.47 395.46c-2.16 8.45-6.28 14.08-7.1 15.81-3.17 3.35-5.7 10.91-5.18 12.21l-11.74 20.14"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3456"
            d="M633.2 412.46c-2-.66-8.69-6.68-15.12-5.51-4.8 5.78-7.63 11.65-8.48 12.46a75 75 0 0 0 11.58 8 5 5 0 0 0 1.43-2.33 1.77 1.77 0 0 0-.34-2.6c.09-3.69 2.72-6.3 5.44-6.52 3.41-.33 2.44-.59 2.88-.61a8.7 8.7 0 0 0 2.61-2.87Z"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3458"
            d="M633.2 412.46c-2-.66-8.69-6.68-15.12-5.51-4.8 5.78-7.63 11.65-8.48 12.46a75 75 0 0 0 11.58 8 5 5 0 0 0 1.43-2.33 1.77 1.77 0 0 0-.34-2.6c.09-3.69 2.72-6.3 5.44-6.52 3.41-.33 2.44-.59 2.88-.61a8.7 8.7 0 0 0 2.61-2.87Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3460"
            d="M626.67 412.69c-3 0-6.09 1.47-7 4.05l7-4.05"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3462"
            d="M626.67 412.69c-3 0-6.09 1.47-7 4.05"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3464"
            d="M614.25 417.84a1.47 1.47 0 0 0 1.81.69 1.18 1.18 0 0 0 .79-1.59 1.5 1.5 0 0 0-1.84-.64 1.12 1.12 0 0 0-.76 1.54Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3466"
            d="M617.9 412.66a1.52 1.52 0 0 0 1.85.68 1.14 1.14 0 0 0 .75-1.58 1.45 1.45 0 0 0-1.8-.65 1.15 1.15 0 0 0-.8 1.55Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3468"
            d="M666.79 342.07a2.14 2.14 0 0 0 1.09-3.05l-7.09-2.44a2.68 2.68 0 0 0-1.5 1.12 1.32 1.32 0 0 0 .29 1.77l7.21 2.6"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3470"
            d="M666.79 342.07a2.14 2.14 0 0 0 1.09-3.05l-7.09-2.44a2.68 2.68 0 0 0-1.5 1.12 1.32 1.32 0 0 0 .29 1.77l7.21 2.6"
            className="Bolivia_svg__cls-9"
          />
        </g>
        <g id="Bolivia_svg__g3472">
          <path
            id="Bolivia_svg__path3475"
            d="M669.93 424.92c-5.94-4-22.86-6.16-25.25-5.49 12.04 9.16 24.2 9.5 25.25 5.49Z"
            className="Bolivia_svg__cls-6"
          />
          <path
            id="Bolivia_svg__path3477"
            d="M669.87 425c-1 4-13.15 3.64-25.16-5.47 12.86 3.84 23.71 6.09 25.16 5.47Z"
            className="Bolivia_svg__cls-7"
          />
          <path
            id="Bolivia_svg__path3479"
            d="M669.87 425c-1 4-13.15 3.64-25.16-5.47 12.86 3.84 23.71 6.09 25.16 5.47Z"
            className="Bolivia_svg__cls-8"
          />
          <path
            id="Bolivia_svg__path3481"
            d="M669.9 424.87c-6.32-4.3-23.75-5.94-25.29-5.51 12 9.13 24.24 9.52 25.29 5.51Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3483"
            d="m598.07 329 38.59 79.27c1.92 1.48 3.5-.51 4.05-.29 2.31 2.6 5.5 3.13 6.17 3.74 2.68 3.66 1.21 6.62 1 6.87-2 2.71 2.37 5.34 2.19 6.18.86 1.52 4.09 1.18 4.76 3 .14-.21 6.57 12.61 7.24 14 1 .74 5.53 9.28 5.53 9.28 3.2-.05 15.5-7.9 15.75-7.78-6.92-11.06-23.5-28-23.16-29.11-4.66-7.89-12.1-16.44-15.31-16.39-4.54-2.39-6.75-8.53-5.87-9.95a8.75 8.75 0 0 1-5.63-2.28L605 328.64c-2.38-.78-2 .19-2.79 1.56 0 0-1.51-1.82-1.41-2-1.35-.66-2.66.27-2.68.87Z"
            className="Bolivia_svg__cls-4"
          />
          <path
            id="Bolivia_svg__path3489"
            d="M596.58 311.73c.74 1.57-.4 1.57-.8 1.79l-1.63.44c-1.86 0-2.83 1-2.85 1.58l45.36 92.76c1.92 1.48 3.75-.39 4.34-.15l-31.11-63.38s-12-22.28-15.11-28.47l4.12-1.76c1.28-.3 1.66-1.16 1.1-2.45l-19-32.76 15.35 31.8.28.6"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3491"
            d="M596.58 311.73c.74 1.57-.4 1.57-.8 1.79l-1.63.44c-1.86 0-2.83 1-2.85 1.58l45.36 92.76c1.92 1.48 3.75-.39 4.34-.15l-31.11-63.38s-12-22.28-15.11-28.47l4.12-1.76c1.28-.3 1.66-1.16 1.1-2.45l-19-32.76 15.35 31.8.28.6"
            className="Bolivia_svg__cls-5"
          />
          <path
            id="Bolivia_svg__path3493"
            d="M656.8 408.23c4.45-.19 7 3.1 4 7"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3495"
            d="M658.75 411.73a2 2 0 0 0 2.61-.5"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3497"
            d="M638.26 391.43c2.35 8.49 6.63 14.12 7.49 15.85 3.28 3.34 6 10.93 5.49 12.26l12.27 20.16"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3499"
            d="M636.86 408.62c2-.7 8.64-6.88 15.16-5.8 5 5.77 7.94 11.66 8.82 12.46a75 75 0 0 1-11.53 8.23 5 5 0 0 1-1.49-2.32 1.79 1.79 0 0 1 .29-2.64c-.17-3.72-2.88-6.32-5.63-6.5-3.45-.28-2.48-.56-2.92-.58a8.8 8.8 0 0 1-2.7-2.85Z"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3501"
            d="M636.86 408.62c2-.7 8.64-6.88 15.16-5.8 5 5.77 7.94 11.66 8.82 12.46a75 75 0 0 1-11.53 8.23 5 5 0 0 1-1.49-2.32 1.79 1.79 0 0 1 .29-2.64c-.17-3.72-2.88-6.32-5.63-6.5-3.45-.28-2.48-.56-2.92-.58a8.8 8.8 0 0 1-2.7-2.85Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3503"
            d="M643.46 408.75c3-.06 6.18 1.39 7.2 4l-7.2-4"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3505"
            d="M643.46 408.75c3-.06 6.18 1.39 7.2 4"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3507"
            d="M656.11 413.76a1.48 1.48 0 0 1-1.82.73 1.2 1.2 0 0 1-.82-1.6 1.49 1.49 0 0 1 1.84-.67 1.13 1.13 0 0 1 .8 1.54Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3509"
            d="M652.32 408.59a1.54 1.54 0 0 1-1.86.71 1.15 1.15 0 0 1-.78-1.58 1.43 1.43 0 0 1 1.79-.68 1.16 1.16 0 0 1 .85 1.55Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3511"
            d="M601.49 338a2.16 2.16 0 0 1-1.16-3.07l7.1-2.56a2.72 2.72 0 0 1 1.55 1.1 1.34 1.34 0 0 1-.26 1.79l-7.23 2.74"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3513"
            d="M601.49 338a2.16 2.16 0 0 1-1.16-3.07l7.1-2.56a2.72 2.72 0 0 1 1.55 1.1 1.34 1.34 0 0 1-.26 1.79l-7.23 2.74"
            className="Bolivia_svg__cls-9"
          />
        </g>
        <g id="Bolivia_svg__g3515">
          <path
            id="Bolivia_svg__path3517"
            d="M677.45 429.09c-5.79-4.09-22.51-6.44-24.88-5.81 11.73 9.25 23.76 9.72 24.88 5.81Z"
            className="Bolivia_svg__cls-6"
          />
          <path
            id="Bolivia_svg__path3519"
            d="M677.39 429.11c-1.12 3.95-13.09 3.42-24.79-5.78 12.64 4.04 23.4 6.43 24.79 5.78Z"
            className="Bolivia_svg__cls-7"
          />
          <path
            id="Bolivia_svg__path3521"
            d="M677.39 429.11c-1.12 3.95-13.09 3.42-24.79-5.78 12.64 4.04 23.4 6.43 24.79 5.78Z"
            className="Bolivia_svg__cls-8"
          />
          <path
            id="Bolivia_svg__path3523"
            d="M677.42 429c-6.16-4.35-23.39-6.23-24.92-5.83 11.75 9.21 23.81 9.78 24.92 5.83Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3525"
            d="m608.26 333.1 36.59 79c1.87 1.5 3.48-.45 4-.22 2.24 2.6 5.38 3.18 6 3.79 2.58 3.66 1.06 6.57.9 6.81-2 2.66 2.24 5.33 2.05 6.16.82 1.51 4 1.22 4.65 3.05.14-.2 6.24 12.58 6.88 13.95.94.75 5.29 9.27 5.29 9.27 3.17 0 15.5-7.59 15.74-7.47-6.62-11.05-22.69-28.1-22.33-29.16-4.46-7.88-11.65-16.45-14.82-16.45-4.45-2.43-6.52-8.54-5.62-9.93a8.72 8.72 0 0 1-5.53-2.34l-27-56.77c-2.34-.82-2 .15-2.79 1.5 0 0-1.46-1.83-1.36-2.05-1.32-.67-2.63.24-2.66.82Z"
            className="Bolivia_svg__cls-4"
          />
          <path
            id="Bolivia_svg__path3527"
            d="m608.26 333.1 36.59 79c1.87 1.5 3.48-.45 4-.22 2.24 2.6 5.38 3.18 6 3.79 2.58 3.66 1.06 6.57.9 6.81-2 2.66 2.24 5.33 2.05 6.16.82 1.51 4 1.22 4.65 3.05.14-.2 6.24 12.58 6.88 13.95.94.75 5.29 9.27 5.29 9.27 3.17 0 15.5-7.59 15.74-7.47-6.62-11.05-22.69-28.1-22.33-29.16-4.46-7.88-11.65-16.45-14.82-16.45-4.45-2.43-6.52-8.54-5.62-9.93a8.72 8.72 0 0 1-5.53-2.34l-27-56.77c-2.34-.82-2 .15-2.79 1.5 0 0-1.46-1.83-1.36-2.05-1.32-.67-2.63.24-2.66.82Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3531"
            d="M607.13 316c.7 1.56-.43 1.55-.83 1.75l-1.63.42c-1.83 0-2.82.93-2.84 1.52l43 92.49c1.87 1.5 3.72-.32 4.3-.08l-29.51-63.2s-11.4-22.23-14.38-28.4l4.11-1.68c1.27-.29 1.66-1.13 1.13-2.42l-18.19-32.7 14.56 31.7.26.6"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3533"
            d="M607.13 316c.7 1.56-.43 1.55-.83 1.75l-1.63.42c-1.83 0-2.82.93-2.84 1.52l43 92.49c1.87 1.5 3.72-.32 4.3-.08l-29.51-63.2s-11.4-22.23-14.38-28.4l4.11-1.68c1.27-.29 1.66-1.13 1.13-2.42l-18.19-32.7 14.56 31.7.26.6"
            className="Bolivia_svg__cls-5"
          />
          <path
            id="Bolivia_svg__path3535"
            d="M664.79 412.37c4.41-.12 6.82 3.17 3.86 7"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3537"
            d="M666.65 415.87a2 2 0 0 0 2.6-.46"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3539"
            d="M646.77 395.46c2.16 8.45 6.29 14.08 7.1 15.81 3.18 3.35 5.71 10.91 5.19 12.21l11.74 20.14"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3541"
            d="M645.05 412.46c2-.66 8.69-6.68 15.12-5.51 4.8 5.78 7.62 11.65 8.48 12.46a75 75 0 0 1-11.58 8 5 5 0 0 1-1.43-2.33 1.77 1.77 0 0 1 .34-2.6c-.1-3.69-2.73-6.3-5.44-6.52-3.41-.33-2.45-.59-2.88-.61a8.6 8.6 0 0 1-2.61-2.87Z"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3543"
            d="M645.05 412.46c2-.66 8.69-6.68 15.12-5.51 4.8 5.78 7.62 11.65 8.48 12.46a75 75 0 0 1-11.58 8 5 5 0 0 1-1.43-2.33 1.77 1.77 0 0 1 .34-2.6c-.1-3.69-2.73-6.3-5.44-6.52-3.41-.33-2.45-.59-2.88-.61a8.6 8.6 0 0 1-2.61-2.87Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3545"
            d="M651.58 412.69c3 0 6.08 1.47 7 4.05l-7-4.05"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3547"
            d="M651.58 412.69c3 0 6.08 1.47 7 4.05"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3549"
            d="M664 417.84a1.47 1.47 0 0 1-1.81.69 1.18 1.18 0 0 1-.78-1.59 1.48 1.48 0 0 1 1.83-.64 1.11 1.11 0 0 1 .76 1.54Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3551"
            d="M660.35 412.66a1.53 1.53 0 0 1-1.86.68 1.14 1.14 0 0 1-.74-1.58 1.43 1.43 0 0 1 1.79-.65 1.15 1.15 0 0 1 .81 1.55Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path3553"
            d="M611.45 342.07a2.13 2.13 0 0 1-1.08-3.05l7.08-2.44a2.7 2.7 0 0 1 1.55 1.12 1.32 1.32 0 0 1-.29 1.77l-7.22 2.6"
            className="Bolivia_svg__cls-10"
          />
          <path
            id="Bolivia_svg__path3555"
            d="M611.45 342.07a2.13 2.13 0 0 1-1.08-3.05l7.08-2.44a2.7 2.7 0 0 1 1.55 1.12 1.32 1.32 0 0 1-.29 1.77l-7.22 2.6"
            className="Bolivia_svg__cls-9"
          />
        </g>
        <g id="Bolivia_svg__g2502">
          <path
            id="Bolivia_svg__path2500"
            d="M631.88 376c.78-.87 52.7-56.22 53.3-56.87l-2-1.4c-.58.61-52.64 56-53.48 56.88-.61-.24 2.79 1.9 2.18 1.39Z"
            className="Bolivia_svg__cls-4"
          />
          <g id="Bolivia_svg__g2595">
            <g id="Bolivia_svg__g3437">
              <path
                id="Bolivia_svg__path2399"
                d="M683.72 318.31c-1.89-1.53-5.17-3.35-7.48-2.76-.78-3.22 3.75-6.57 5.65-6.08-.47 3.53 4.78 5.77 4.68 5.78Z"
                className="Bolivia_svg__cls-5"
              />
            </g>
            <path
              id="Bolivia_svg__path720"
              d="M687.16 315.61a23.5 23.5 0 0 0 4.18 2.36c2 1.11 4.87-1.67 6.17-2.52 0 0 1.4 5.1-1.7 8.46S689 328 686 327c0 0 3.89-3.8 2.28-5.46a15.1 15.1 0 0 0-3.66-2.75"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__rect2593"
              d="m689.12 315.66-4.21 4.56-2.79-1.93 4.2-4.56z"
              className="Bolivia_svg__cls-5"
            />
          </g>
        </g>
        <g id="Bolivia_svg__g38827">
          <g id="Bolivia_svg__g46228">
            <path
              id="Bolivia_svg__path2603"
              d="M621.26 435.48 619.87 449s2.1-2.57 2.6-3.42 2.33-3.14 2.72-11c0 0-1.42-4.37-2.09-4.36-1.11-.55-1.84 5.26-1.84 5.26Zm3.33-30.23S621 427 620.58 429c0 .68 1.85 2.48 3.18-1.73l2.2-15.83s-.96-4.22-1.37-6.19Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path2605"
              d="M632.82 426.86a13.8 13.8 0 0 1-2.11-3.08l-.57 4.81a7.29 7.29 0 0 1 2.6 6.45l.58-.86.34-1.7a27.6 27.6 0 0 0 .63-4.52 5.3 5.3 0 0 1-1.47-1.1Z"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path2607"
              d="M619.87 449s5-4.31 5.32-14.46l.62-2.83s.1 2.25 1.11.55a11.1 11.1 0 0 0 .94-4.25s1.81-2.28 2.36.53c0 0-1.69 13.28-1.8 14.41-.15 1.41-.4 3.11-.4 3.11s-1-1.68-2 0-2.83 4-6.14 2.91Zm6.09-37.6-2.2 15.82s1.76.82 2 4.49c.16 1.69.83.83 1.11.55a10.7 10.7 0 0 0 .1-3.39l1-11a47.5 47.5 0 0 1-1.97-6.43Z"
              className="Bolivia_svg__cls-13"
            />
            <path
              id="Bolivia_svg__path2609"
              d="m624.22 448.13-.32 3.95a3.2 3.2 0 0 0 2.51-1.72 12.4 12.4 0 0 0 1.59-4.26s-1.17-1.67-2 0a5.7 5.7 0 0 1-1.78 2.03Zm2.7-15.83a9.06 9.06 0 0 0 .94-4.25l-1 .86a11.6 11.6 0 0 1 .06 3.39Z"
              className="Bolivia_svg__cls-13"
            />
            <path
              id="Bolivia_svg__path2611"
              d="M631.87 430.7a6.6 6.6 0 0 0-1.85-2.23l-2.24 17.8s-.63 4.53-3.42 5.69c0 0 1.59 15.49 6.62 11.19.73-.57 1.64-5.38 1.34-8.2-.35-3.09-1.17-7.31-1.25-9a40.3 40.3 0 0 1 .71-7.09c.2-1.13.79-3.61.9-3.89.28-.29-.06-2.58-.81-4.27Z"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path2613"
              d="M634.29 428s1.36 1.39 1.61 1.38-3.53 29-3.53 29a42.4 42.4 0 0 0-1-8.95c-.92-4.8.27-11.25 1.3-14.34 0 0 1.22-.91 1.6-7.12Z"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path2619"
              d="M627.86 418.19s-.75 8.19-.93 10.73c0 0 2.55-3.71 3.21-.33l.57-4.8a39 39 0 0 1-2.85-5.6Z"
              className="Bolivia_svg__cls-14"
            />
            <path
              id="Bolivia_svg__path2621"
              d="M625.91 431.72s-.84-9.17-5.28-2.69a14.7 14.7 0 0 0-.15 4.52c.14 1.17 1.37 2.61 1.88 3.48 1 1.44 2-.32 2-.32a13 13 0 0 0 1.55-4.99Z"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g46260">
            <path
              id="Bolivia_svg__path236"
              d="M590.7 355.41c-.16-5.22-1.8-13.9-1.89-19.86l-18-18.35s-2.22 14.87-8.76 23.37l28.66 14.85"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path6858"
              d="M592 356a105.4 105.4 0 0 0 2.28-15.31l-11.6-11.42c.05 4.76-5.35 12.14-5.72 21"
              className="Bolivia_svg__cls-13"
            />
            <path
              id="Bolivia_svg__path238"
              d="M602 367c1.33-6.37-1.93-7.16 2.92-16.13l-10.71-10.27c-2 6-3.34 9.93-3.17 15.15l9.13 6.5"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g46249">
            <path
              id="Bolivia_svg__path1466"
              d="M560.33 405.13c-2.17-6.45.77-19.1.45-27.2-.25-5.23 3.6-24.89 3.51-30.84l-21.17-13.22s-.92 21.49-3.36 44.89a93.2 93.2 0 0 0-.6 32.18c2.25 13.05 4.46 18.4 9.73 23.92 9.35 9.68 29.49 4.09 29.49 4.09a53.5 53.5 0 0 0 26.73-14.2 125 125 0 0 1-14.46 2.25c-19.59-1.37-27.3 3.53-27.91-16.58"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path1468"
              d="m617.07 418.15.33-.14c-3.67 1.38-8.8 2.9-8.8 2.9l-11.93.91c-25.9.61-22.66-15.42-21.63-41.29.25-9.82 2.19-22.18 1.69-26.56L559.37 344c-5.66 16-3.89 27.19-5 35.37-.59 8.81-2.47 26 .39 33.54 4 17.47 17.73 16.76 36.25 15.22 9.19-.76 14.13-3.12 14.13-3.12l11.95-6.88"
              className="Bolivia_svg__cls-14"
            />
            <path
              id="Bolivia_svg__path1470"
              d="M617.41 417.8a52 52 0 0 1-8.88 3.24l-12.1 1.19c-18.77 1.59-29.76-11.59-27.35-41.41 0-10.53.35-15.21 4-29.24l10.31 6.05v1c-.58 3.15-2.06 10.52-2.06 13.88 0 23.94 15.14 42.33 35.76 45.45l.33-.13"
              className="Bolivia_svg__cls-15"
            />
            <path
              id="Bolivia_svg__path1474"
              d="M548.88 345.83c1.75 2.93 12.2 18.85 18 21.86"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path1476"
              d="M550.64 356.22c1.75 3 14.54 20.93 20.3 21.94"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path1478"
              d="M547.71 383.61c2.93 3.51 5.85 10.46 14.54 15"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path1480"
              d="M551.81 403.53c5.84 5.45 20.3 17.42 34.25 17.91"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path1482"
              d="M551.81 412.5c2.92 3.51 9.27 19.92 36 12.47"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path1484"
              d="M547.71 415.5c1.75 3.94 15.13 25.88 38.94 17.42"
              className="Bolivia_svg__cls-9"
            />
          </g>
          <g id="Bolivia_svg__g46238">
            <path
              id="Bolivia_svg__path2419"
              d="M575.63 397.25c-2.17-6.45.77-19.1.45-27.2-.25-5.23 2.22-23.31 2.13-29.26L558.42 326s-.92 21.49-3.36 44.89c-2.19 12-3.86 26.75-2.24 35.92 2.66 15 9.87 19.22 11.18 20.38 10.11 9 32.93 8.12 35.2 7.31 16.31-5.83 23.42-16.19 23.42-16.19a162 162 0 0 0-16.67.78c-19.59-1.37-29.48-.55-30.09-20.65"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path2421"
              d="m632.37 410.28.33-.14c-3.67 1.37-8.8 2.89-8.8 2.89L612 414c-25.9.6-22.66-15.43-21.63-41.3.25-9.82.58-18.63.08-23l-15.55-11.38c-5.66 16-4.12 25-5.26 33.2-.59 8.82-2.47 26 .39 33.54 4 17.48 17.73 16.76 36.25 15.23 9.19-.77 14.13-3.13 14.13-3.13l12-6.87"
              className="Bolivia_svg__cls-13"
            />
            <path
              id="Bolivia_svg__path2423"
              d="M632.83 410a51.5 51.5 0 0 1-8.87 3.23l-12.1 1.2c-18.78 1.59-29.77-11.59-27.36-41.41 0-10.53-.34-11.27 3.3-25.3 5.75 3.72 16.74 13.1 16.74 13.1a15.57 15.57 0 0 0-2.29 10.1c0 23.94 9.63 36.09 30.25 39.21l2.26-19.55"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path2427"
              d="M564.18 338c1.75 2.94 12.19 18.85 18.05 21.86"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path2429"
              d="M565.94 348.34c1.75 3 14.54 20.93 20.3 21.94"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path2431"
              d="M563 375.73c2.93 3.51 5.84 10.47 14.54 15"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path2433"
              d="M567.11 395.65c5.84 5.45 20.29 17.42 34.25 17.92"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path2435"
              d="M567.11 404.62c2.92 3.51 9.26 19.92 36 12.47"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path2437"
              d="M563 407.63c1.75 3.94 15.12 25.88 38.94 17.41"
              className="Bolivia_svg__cls-9"
            />
          </g>
          <path
            id="Bolivia_svg__path1486"
            d="M543.26 336s-.88 7.62-1 9a96 96 0 0 0 .09 14.73c0 .34 1.28 8.25.83 8.67-1.52 1.74-1.57 1.93-3.17.64-.23-.26.69-8.36.76-9.47s.4-10.66.57-14.79c0-1.63 1.42-9.67 1.42-9.67s.19-1.71.45.88"
            className="Bolivia_svg__cls-16"
          />
          <path
            id="Bolivia_svg__path1488"
            d="M543.26 336s-.88 7.62-1 9a97 97 0 0 0 .09 14.73c0 .34 1.55 11.35 1.06 8.68-1.52 1.74-1.83 2.39-3.43 1.11-.23-.27.72-8.84.79-9.95s.4-10.66.57-14.79c0-1.63 1.42-9.67 1.42-9.67s.19-1.71.45.88Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path1490"
            d="M543.1 333.28a124 124 0 0 0-1.89 14.37c-.22 6.36-.5 8.16-.39 11.87.06.25-.63 4.79-.83 6.76-.14 1 .15.26 0 .33-1.3.8-2.18.16-3-.47-.24-.17 2.1-5.67 2.17-6.78 1.23-16.14 3.57-25.6 3.57-25.6s-.94 5.73.36-.48"
            className="Bolivia_svg__cls-14"
          />
          <path
            id="Bolivia_svg__path1492"
            d="M543.1 333.28a122 122 0 0 0-1.88 14.37c-.22 6.36-.5 8.16-.39 11.87.06.25-.63 4.79-.83 6.76-.14 1 .15.26 0 .33-1.3.8-2.18.16-3-.47-.24-.17 2.1-5.67 2.17-6.79 1.23-16.14 3.56-25.6 3.56-25.6s-.94 5.73.36-.49Zm-.75 26s-1.37.62-1.52.27m-.06-1.88s1.17 0 1.35-.36m-.07-1.58s-.86.57-1.1.21m1.08-2.53h-.83m.89-2.28h-.92m.77-3.22s-.51.23-.57-.11m.74-2.55h-.75m-.71 14.34s-1.35.19-1.5-.23m1.6-2.86s-1.34.11-1.39-.32m1.45-1.91a5.3 5.3 0 0 1-1.17-.06m1.38-2.1h-1.08m1.08-2.54-.75-.12m1.05-2.1s-.68.14-.82-.2m.89-2.39s-.61.4-.58 0m-.07 13.44s-1.34 0-1.31-.39"
            className="Bolivia_svg__cls-16"
          />
          <path
            id="Bolivia_svg__path2439"
            d="M558.56 328.07s-.88 7.63-1 9a96 96 0 0 0 .09 14.73c0 .34 1.28 8.25.83 8.67-1.52 1.74-1.57 1.93-3.17.65-.23-.27.69-8.37.75-9.48s.41-10.66.58-14.79c0-1.63 1.42-9.66 1.42-9.66s.19-1.71.45.87"
            className="Bolivia_svg__cls-16"
          />
          <path
            id="Bolivia_svg__path2441"
            d="M558.56 328.07s-.88 7.63-1 9a97 97 0 0 0 .09 14.73c0 .34 1.55 11.35 1.06 8.68-1.52 1.74-1.83 2.39-3.43 1.11-.23-.26.72-8.84.78-9.95s.41-10.66.58-14.79c0-1.63 1.42-9.66 1.42-9.66s.19-1.71.45.87Z"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path2443"
            d="M558.39 325.4a125 125 0 0 0-1.88 14.37c-.22 6.36-.5 8.16-.4 11.87.07.25-.62 4.79-.82 6.76-.14 1 .15.26 0 .34-1.3.79-2.18.15-3-.47-.24-.18 2.1-5.68 2.16-6.79 1.24-16.14 3.58-25.59 3.58-25.59l.35-.49"
            className="Bolivia_svg__cls-16"
          />
          <path
            id="Bolivia_svg__path2445"
            d="M558.39 325.4a123 123 0 0 0-1.87 14.38c-.22 6.35-.5 8.15-.4 11.86.07.25-.62 4.79-.82 6.76-.14 1 .15.26 0 .34-1.3.79-2.18.15-3-.47-.24-.18 2.1-5.68 2.16-6.8 1.24-16.14 3.57-25.59 3.57-25.59l.35-.49Zm-.74 26s-1.37.62-1.53.27m0-1.88s1.16 0 1.35-.36m-.07-1.58s-.86.57-1.1.21m1.08-2.52h-.83m.88-2.28h-.91m.77-3.22s-.51.23-.58-.11m.74-2.55h-.74m-.72 14.35s-1.34.19-1.49-.24m1.6-2.86s-1.34.11-1.39-.32m1.45-1.91a6 6 0 0 1-1.17 0m1.38-2.1-1.08-.05m1.07-2.54-.74-.11m1-2.11s-.67.14-.81-.2m.89-2.39s-.61.4-.58 0m-.12 13.36s-1.33 0-1.3-.39"
            className="Bolivia_svg__cls-9"
          />
          <g id="Bolivia_svg__g2487">
            <path
              id="Bolivia_svg__path212"
              d="M570.5 316.89a88 88 0 0 1 .26 12.06c-.49 5.29-.41 6.8-.94 9.86-.08.21.09 4 .06 5.67 0 .85-.17.2 0 .28a2.65 2.65 0 0 0 3-.15c.34-.12-1.45-4.87-1.4-5.79.58-13.47-.69-21.5-.69-21.5l-.3-.43"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path214"
              d="M570.5 316.89a85 85 0 0 1 .25 12.06c-.48 5.29-.41 6.8-.94 9.86-.08.21.09 4 .06 5.67 0 .85-.17.2 0 .28a2.67 2.67 0 0 0 3-.15c.33-.12-1.46-4.87-1.4-5.8a120 120 0 0 0-.68-21.5l-.3-.43Z"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path2469"
              d="M570 338.9s1.32.27 1.51-.07"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path2467"
              d="M570.32 336.33s1.32.2 1.34-.15"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path2465"
              d="M570.44 334.47a7 7 0 0 0 1.16.06"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path2463"
              d="m570.45 332.67 1.09.05"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path2461"
              d="M570.75 330.53h.75"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path2459"
              d="M570.79 328.67s.56.17.75-.1"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path2457"
              d="M570.92 326.52s.55.38.58 0"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path2455"
              d="M570.06 337.68s1.33.12 1.35-.22"
              className="Bolivia_svg__cls-16"
            />
          </g>
          <path
            id="Bolivia_svg__path3079"
            d="m618 332.47 1.2.09Z"
            className="Bolivia_svg__cls-17"
          />
          <path
            id="Bolivia_svg__path4435"
            d="M634.09 384.61s-.56-.24-.7 0a.28.28 0 0 0 .28.24c.14 0 .42-.24.42-.24Z"
            className="Bolivia_svg__cls-18"
          />
          <path
            id="Bolivia_svg__path2941"
            d="M632.56 386.28s2.37-.24 3.2-.24"
            className="Bolivia_svg__cls-18"
          />
        </g>
        <g id="Bolivia_svg__g37871">
          <g id="Bolivia_svg__g4081">
            <g id="Bolivia_svg__g4083">
              <g id="Bolivia_svg__g4085">
                <path
                  id="Bolivia_svg__path4087"
                  d="M597.29 426.3c-.35 4.59-11 9.86-19 .18-8.54-6.75-6.69-17.08.09-18.51l81.92-79.9c3.29-1.79 3.6-3.5 5.24-5.25C669 326.47 676.08 333 680 336.19c-2.36 2-4.28 3.85-4.8 5.39z"
                  className="Bolivia_svg__cls-16"
                />
              </g>
              <g id="Bolivia_svg__g4089">
                <path
                  id="Bolivia_svg__path4091"
                  d="M665.73 322.57c3.91-5.36 19.15 8.58 15.08 12.91s-18.69-7.48-15.08-12.91Z"
                  className="Bolivia_svg__cls-19"
                />
                <path
                  id="Bolivia_svg__path4093"
                  d="M679.44 334.44c-2.87 2.18-13.92-7.18-12.09-10.72 3.05-3.31 15.21 8.57 12.09 10.72Z"
                  className="Bolivia_svg__cls-20"
                />
              </g>
            </g>
            <path
              id="Bolivia_svg__path4097"
              d="M675.05 341.79c-6.86-2.19-11.73-6.76-14.81-13.59"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path4101"
              d="M625.78 395.59c-8.63-2.67-14.54-8.3-17.21-17.47"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path4103"
              d="M622.28 399.61c-8.63-2.67-14.54-8.3-17.21-17.47"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path4105"
              d="M601.91 420.84a26.66 26.66 0 0 1-18.23-18.16"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path4107"
              d="M598.31 424.86A27 27 0 0 1 580 406.6"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path4109"
              d="M578 427.51c-.43 2-1.54 2.67-3.1 2.05"
              className="Bolivia_svg__cls-8"
            />
            <path
              id="Bolivia_svg__path4111"
              d="M595.55 426.68c-3.24 5.1-6.84 3.56-9.86 3.62"
              className="Bolivia_svg__cls-8"
            />
            <path
              id="Bolivia_svg__path4113"
              d="M573.6 427.78a2.52 2.52 0 0 0 2.57 2.46 2.54 2.54 0 0 0 2.6-2.47 2.52 2.52 0 0 0-2.57-2.47 2.9 2.9 0 0 0-2.59 2.87"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path4127"
              d="M578.28 427.26c-.43 2-1.55 2.67-3.11 2.05"
              className="Bolivia_svg__cls-8"
            />
            <path
              id="Bolivia_svg__path4129"
              d="M595.55 426.68c-3.24 5.1-6.84 3.56-9.86 3.62"
              className="Bolivia_svg__cls-8"
            />
          </g>
        </g>
        <g id="Bolivia_svg__g46565">
          <g id="Bolivia_svg__g46567">
            <path
              id="Bolivia_svg__path46569"
              d="m656.74 435.48 1.39 13.52s-2.1-2.57-2.6-3.42-2.33-3.14-2.72-11c0 0 1.42-4.37 2.09-4.36 1.11-.55 1.84 5.26 1.84 5.26Zm-3.33-30.23s3.64 21.77 4 23.75c0 .68-1.85 2.48-3.18-1.73L652 411.44s1-4.22 1.41-6.19Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path46571"
              d="M645.18 426.86a13.8 13.8 0 0 0 2.11-3.08l.57 4.81a7.29 7.29 0 0 0-2.6 6.45l-.58-.86-.34-1.7a27.6 27.6 0 0 1-.63-4.52 5.3 5.3 0 0 0 1.47-1.1Z"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path46573"
              d="M658.13 449s-5-4.31-5.32-14.46l-.62-2.83s-.1 2.25-1.11.55a11.1 11.1 0 0 1-.94-4.25s-1.81-2.28-2.36.53c0 0 1.69 13.28 1.8 14.41.15 1.41.4 3.11.4 3.11s1-1.68 2 0 2.83 4 6.14 2.91ZM652 411.44l2.2 15.82s-1.76.82-2 4.49c-.16 1.69-.83.83-1.11.55a10.7 10.7 0 0 1-.1-3.39l-1-11a47.5 47.5 0 0 0 2.01-6.47Z"
              className="Bolivia_svg__cls-13"
            />
            <path
              id="Bolivia_svg__path46575"
              d="m653.78 448.13.32 3.95a3.2 3.2 0 0 1-2.51-1.72 12.4 12.4 0 0 1-1.59-4.26s1.17-1.67 2 0a5.7 5.7 0 0 0 1.78 2.03Zm-2.7-15.83a9.06 9.06 0 0 1-.94-4.25l1 .86a11.6 11.6 0 0 0-.06 3.39Z"
              className="Bolivia_svg__cls-13"
            />
            <path
              id="Bolivia_svg__path46577"
              d="M646.13 430.7a6.6 6.6 0 0 1 1.85-2.23l2.24 17.8s.63 4.53 3.42 5.69c0 0-1.59 15.49-6.62 11.19-.73-.57-1.64-5.38-1.34-8.2.35-3.09 1.17-7.31 1.25-9a40.3 40.3 0 0 0-.71-7.09c-.2-1.13-.79-3.61-.9-3.89-.28-.29.06-2.58.81-4.27Z"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path46579"
              d="M643.71 428s-1.36 1.39-1.61 1.38 3.53 29 3.53 29a42.4 42.4 0 0 1 1-8.95c.92-4.8-.27-11.25-1.3-14.34 0 0-1.22-.91-1.6-7.12Z"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path46581"
              d="M650.14 418.19s.75 8.19.93 10.73c0 0-2.55-3.71-3.21-.33l-.57-4.8a39 39 0 0 0 2.85-5.6Z"
              className="Bolivia_svg__cls-14"
            />
            <path
              id="Bolivia_svg__path46583"
              d="M652.09 431.72s.84-9.17 5.28-2.69a14.7 14.7 0 0 1 .15 4.52c-.14 1.17-1.37 2.61-1.88 3.48-1 1.44-2-.32-2-.32a13 13 0 0 1-1.55-4.99Z"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g46585">
            <path
              id="Bolivia_svg__path46587"
              d="M687.3 355.41c.16-5.22 1.8-13.9 1.89-19.86l18-18.35s2.22 14.87 8.76 23.37l-28.65 14.85"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path46589"
              d="M686 356a105.4 105.4 0 0 1-2.28-15.31l11.6-11.42c-.05 4.76 5.35 12.14 5.72 21"
              className="Bolivia_svg__cls-13"
            />
            <path
              id="Bolivia_svg__path46591"
              d="M676 367c-1.33-6.37 1.93-7.16-2.92-16.13l10.71-10.27c2 6 3.34 9.93 3.17 15.15l-9.13 6.5"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g46593">
            <path
              id="Bolivia_svg__path46595"
              d="M717.67 405.13c2.17-6.45-.77-19.1-.45-27.2.25-5.23-3.6-24.89-3.51-30.84l21.17-13.22s.92 21.49 3.36 44.89a93.2 93.2 0 0 1 .6 32.18c-2.25 13.05-4.46 18.4-9.73 23.92-9.35 9.68-29.49 4.09-29.49 4.09a53.5 53.5 0 0 1-26.73-14.2 125 125 0 0 0 14.46 2.25c19.59-1.37 27.3 3.53 27.91-16.58"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path46597"
              d="m660.93 418.15-.33-.14c3.67 1.38 8.8 2.9 8.8 2.9l11.93.91c25.9.61 22.66-15.42 21.63-41.29-.25-9.82-2.19-22.18-1.69-26.56l17.36-9.97c5.66 16 3.89 27.19 5 35.37.59 8.81 2.47 26-.39 33.54-4 17.47-17.73 16.76-36.25 15.22-9.19-.76-14.13-3.12-14.13-3.12l-11.95-6.88"
              className="Bolivia_svg__cls-14"
            />
            <path
              id="Bolivia_svg__path46599"
              d="M660.59 417.8a52 52 0 0 0 8.88 3.24l12.1 1.19c18.77 1.59 29.76-11.59 27.35-41.41 0-10.53-.35-15.21-4-29.24l-10.31 6.05v1c.58 3.15 2.06 10.52 2.06 13.88 0 23.94-15.14 42.33-35.76 45.45l-.33-.13"
              className="Bolivia_svg__cls-15"
            />
            <path
              id="Bolivia_svg__path46601"
              d="M729.12 345.83c-1.75 2.93-12.2 18.85-18 21.86"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46603"
              d="M727.36 356.22c-1.75 3-14.54 20.93-20.3 21.94"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46605"
              d="M730.29 383.61c-2.93 3.51-5.85 10.46-14.54 15"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46607"
              d="M726.19 403.53c-5.84 5.45-20.3 17.42-34.25 17.91"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46609"
              d="M726.19 412.5c-2.92 3.51-9.27 19.92-36 12.47"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46611"
              d="M730.29 415.5c-1.75 3.94-15.13 25.88-38.94 17.42"
              className="Bolivia_svg__cls-9"
            />
          </g>
          <g id="Bolivia_svg__g46613">
            <path
              id="Bolivia_svg__path46615"
              d="M702.37 397.25c2.17-6.45-.77-19.1-.45-27.2.25-5.23-2.22-23.31-2.13-29.26L719.58 326s.92 21.49 3.36 44.89c2.19 12 3.86 26.75 2.24 35.92-2.66 15-9.87 19.22-11.18 20.38-10.11 9-32.93 8.12-35.2 7.31-16.31-5.83-23.42-16.19-23.42-16.19a162 162 0 0 1 16.67.78c19.59-1.37 29.48-.55 30.09-20.65"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path46617"
              d="m645.63 410.28-.33-.14c3.67 1.37 8.8 2.89 8.8 2.89l11.9.97c25.9.6 22.66-15.43 21.63-41.3-.25-9.82-.58-18.63-.08-23l15.52-11.32c5.66 16 4.12 25 5.26 33.2.59 8.82 2.47 26-.39 33.54-4 17.48-17.73 16.76-36.25 15.23-9.19-.77-14.13-3.13-14.13-3.13l-12-6.87"
              className="Bolivia_svg__cls-13"
            />
            <path
              id="Bolivia_svg__path46619"
              d="M645.17 410a51.5 51.5 0 0 0 8.87 3.23l12.1 1.2c18.78 1.59 29.77-11.59 27.36-41.41 0-10.53.34-11.27-3.3-25.3-5.75 3.72-16.74 13.1-16.74 13.1a15.57 15.57 0 0 1 2.29 10.1c0 23.94-9.63 36.09-30.25 39.21l-2.26-19.55"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path46621"
              d="M713.82 338c-1.75 2.94-12.19 18.85-18.05 21.86"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46623"
              d="M712.06 348.34c-1.75 3-14.54 20.93-20.3 21.94"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46625"
              d="M715 375.73c-2.93 3.51-5.84 10.47-14.54 15"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46627"
              d="M710.89 395.65c-5.84 5.45-20.29 17.42-34.25 17.92"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46629"
              d="M710.89 404.62c-2.92 3.51-9.26 19.92-36 12.47"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46631"
              d="M715 407.63c-1.75 3.94-15.12 25.88-38.94 17.41"
              className="Bolivia_svg__cls-9"
            />
          </g>
          <path
            id="Bolivia_svg__path46633"
            d="M734.74 336s.88 7.62 1 9a96 96 0 0 1-.09 14.73c0 .34-1.28 8.25-.83 8.67 1.52 1.74 1.57 1.93 3.17.64.23-.26-.69-8.36-.76-9.47s-.4-10.66-.57-14.79c0-1.63-1.42-9.67-1.42-9.67s-.19-1.71-.45.88"
            className="Bolivia_svg__cls-14"
          />
          <path
            id="Bolivia_svg__path46635"
            d="M734.74 336s.88 7.62 1 9a97 97 0 0 1-.09 14.73c0 .34-1.55 11.35-1.06 8.68 1.52 1.74 1.83 2.39 3.43 1.11.23-.27-.72-8.84-.79-9.95s-.4-10.66-.57-14.79c0-1.63-1.42-9.67-1.42-9.67s-.19-1.71-.45.88Z"
            className="Bolivia_svg__cls-16"
          />
          <path
            id="Bolivia_svg__path46637"
            d="M734.9 333.28a124 124 0 0 1 1.89 14.37c.22 6.36.5 8.16.39 11.87-.06.25.63 4.79.83 6.76.14 1-.15.26 0 .33 1.3.8 2.18.16 3-.47.24-.17-2.1-5.67-2.17-6.78-1.23-16.14-3.57-25.6-3.57-25.6s.94 5.73-.36-.48"
            className="Bolivia_svg__cls-14"
          />
          <path
            id="Bolivia_svg__path46639"
            d="M734.9 333.28a122 122 0 0 1 1.88 14.37c.22 6.36.5 8.16.39 11.87-.06.25.63 4.79.83 6.76.14 1-.15.26 0 .33 1.3.8 2.18.16 3-.47.24-.17-2.1-5.67-2.17-6.79-1.23-16.14-3.56-25.6-3.56-25.6s.94 5.73-.36-.49Zm.75 26s1.37.62 1.52.27m.06-1.88s-1.17 0-1.35-.36m.07-1.58s.86.57 1.1.21m-1.05-2.56h.83m-.89-2.28h.92m-.77-3.22s.51.23.57-.11m-.74-2.55h.75m.71 14.34s1.35.19 1.5-.23m-1.6-2.86s1.34.11 1.39-.32m-1.45-1.91a5.3 5.3 0 0 0 1.17-.06m-1.38-2.1h1.08m-1.09-2.54.75-.12m-1.05-2.1s.68.14.82-.2m-.89-2.39s.61.4.58 0m.07 13.44s1.34 0 1.31-.39"
            className="Bolivia_svg__cls-16"
          />
          <path
            id="Bolivia_svg__path46641"
            d="M719.44 328.07s.88 7.63 1 9a96 96 0 0 1-.09 14.73c0 .34-1.28 8.25-.83 8.67 1.52 1.74 1.57 1.93 3.17.65.23-.27-.69-8.37-.75-9.48s-.41-10.66-.58-14.79c0-1.63-1.42-9.66-1.42-9.66s-.19-1.71-.45.87"
            className="Bolivia_svg__cls-14"
          />
          <path
            id="Bolivia_svg__path46643"
            d="M719.44 328.07s.88 7.63 1 9a97 97 0 0 1-.09 14.73c0 .34-1.55 11.35-1.06 8.68 1.52 1.74 1.83 2.39 3.43 1.11.23-.26-.72-8.84-.78-9.95s-.41-10.66-.58-14.79c0-1.63-1.42-9.66-1.42-9.66s-.19-1.71-.45.87Z"
            className="Bolivia_svg__cls-16"
          />
          <path
            id="Bolivia_svg__path46645"
            d="M719.61 325.4a125 125 0 0 1 1.88 14.37c.22 6.36.5 8.16.4 11.87-.07.25.62 4.79.82 6.76.14 1-.15.26 0 .34 1.3.79 2.18.15 3-.47.24-.18-2.1-5.68-2.16-6.79-1.24-16.14-3.58-25.59-3.58-25.59l-.35-.49"
            className="Bolivia_svg__cls-14"
          />
          <path
            id="Bolivia_svg__path46647"
            d="M719.61 325.4a123 123 0 0 1 1.87 14.38c.22 6.35.5 8.15.4 11.86-.07.25.62 4.79.82 6.76.14 1-.15.26 0 .34 1.3.79 2.18.15 3-.47.24-.18-2.1-5.68-2.16-6.8-1.24-16.14-3.57-25.59-3.57-25.59l-.35-.49Zm.74 26s1.37.62 1.53.27m0-1.88s-1.16 0-1.35-.36m.07-1.58s.86.57 1.1.21m-1.08-2.52h.83m-.88-2.28h.91m-.77-3.22s.51.23.58-.11m-.74-2.55h.74m.72 14.35s1.34.19 1.49-.24m-1.6-2.86s1.34.11 1.39-.32m-1.45-1.91a6 6 0 0 0 1.17 0m-1.38-2.1 1.08-.05m-1.07-2.54.74-.11m-1-2.11s.67.14.81-.2m-.89-2.39s.61.4.58 0m.08 13.43s1.33 0 1.3-.39"
            className="Bolivia_svg__cls-16"
          />
          <g id="Bolivia_svg__g46649">
            <path
              id="Bolivia_svg__path46651"
              d="M707.5 316.89a88 88 0 0 0-.26 12.06c.49 5.29.41 6.8.94 9.86.08.21-.09 4-.06 5.67 0 .85.17.2 0 .28a2.65 2.65 0 0 1-3-.15c-.34-.12 1.45-4.87 1.4-5.79-.58-13.47.69-21.5.69-21.5l.3-.43"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46653"
              d="M707.5 316.89a85 85 0 0 0-.25 12.06c.48 5.29.41 6.8.94 9.86.08.21-.09 4-.06 5.67 0 .85.17.2 0 .28a2.67 2.67 0 0 1-3-.15c-.33-.12 1.46-4.87 1.4-5.8a120 120 0 0 1 .68-21.5l.3-.43Z"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46655"
              d="M708 338.9s-1.32.27-1.51-.07"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46657"
              d="M707.68 336.33s-1.32.2-1.34-.15"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46659"
              d="M707.56 334.47a7 7 0 0 1-1.16.06"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46661"
              d="m707.55 332.67-1.09.05"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46663"
              d="M707.25 330.53h-.75"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46665"
              d="M707.21 328.67s-.56.17-.75-.1"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46667"
              d="M707.08 326.52s-.55.38-.58 0"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46669"
              d="M707.94 337.68s-1.33.12-1.35-.22"
              className="Bolivia_svg__cls-16"
            />
          </g>
          <path
            id="Bolivia_svg__path46671"
            d="m660 332.47-1.2.09Z"
            className="Bolivia_svg__cls-17"
          />
          <path
            id="Bolivia_svg__path46673"
            d="M643.91 384.61s.56-.24.7 0a.28.28 0 0 1-.28.24c-.14 0-.42-.24-.42-.24Z"
            className="Bolivia_svg__cls-18"
          />
          <path
            id="Bolivia_svg__path46675"
            d="M645.44 386.28s-2.37-.24-3.2-.24"
            className="Bolivia_svg__cls-18"
          />
        </g>
        <g id="Bolivia_svg__g46878">
          <path
            id="Bolivia_svg__path3865"
            d="M596.5 323.21c0-3.15 2.92-5 3.38-5.28a10.37 10.37 0 0 1 5.58-2.24 4.3 4.3 0 0 1 .21 1.21c0 .55-.7 2.48-3.11 4.11a17.2 17.2 0 0 1-6.06 2.2Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path4013"
            d="m596.46 322 44.47 57.72 2.11-2.08L597.68 319Z"
            className="Bolivia_svg__cls-4"
          />
          <g id="Bolivia_svg__g46862">
            <path
              id="Bolivia_svg__path3859"
              d="M595.78 310.74s4.81-.5 4.17-3.25-3.92-2.67-5.27-2.79-5.81.93-7.12 2.24-4.12 3.64-3.22 7.5a30 30 0 0 0 3.45 8.91 7.35 7.35 0 0 1 .68 5.9c-.12.45-.56 1.91.65 2.44 1.77.76 2.21.76 3.75-.95s3.67-4.38 3.63-7.53 2.92-5 3.38-5.28a10.37 10.37 0 0 1 5.58-2.24s-1.11-1.82-2.78-1.73-5.09-1.45-6.9-3.22Z"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path3861"
              d="M595.78 310.74s4.81-.5 4.17-3.25-3.92-2.67-5.27-2.79-5.81.93-7.12 2.24-4.12 3.64-3.22 7.5a30 30 0 0 0 3.45 8.91 7.35 7.35 0 0 1 .68 5.9c-.12.45-.56 1.91.65 2.44 1.77.76 2.21.76 3.75-.95s3.67-4.38 3.63-7.53 2.92-5 3.38-5.28a10.37 10.37 0 0 1 5.58-2.24s-1.11-1.82-2.78-1.73-5.09-1.45-6.9-3.22Z"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path3867"
              d="M595.78 310.74c-.65 0-2.57-.83-3.9-.36s-4 2.08-3.55 4.36"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path13300"
              d="M604 314.43a31 31 0 0 0-4.73 2.47 59 59 0 0 0-5.29 4.86c-1.54 1.53-1.89 3.6-5.21 5.84"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path3875"
              d="M602.22 314a10.8 10.8 0 0 1-2.11 1.55c-.93.51-1.23 1.32-1.82 2"
              className="Bolivia_svg__cls-9"
            />
          </g>
        </g>
        <g id="Bolivia_svg__g46509">
          <g id="Bolivia_svg__g46511">
            <g id="Bolivia_svg__g46513">
              <g id="Bolivia_svg__g46515">
                <path
                  id="Bolivia_svg__path46517"
                  d="M680.71 426.3c.35 4.59 11 9.86 19 .18 8.54-6.75 6.69-17.08-.09-18.51l-81.92-79.9c-3.29-1.79-3.6-3.5-5.24-5.25C609 326.47 601.92 333 598 336.19c2.36 2 4.28 3.85 4.8 5.39l77.87 84.72Z"
                  className="Bolivia_svg__cls-16"
                />
              </g>
              <g id="Bolivia_svg__g46519">
                <path
                  id="Bolivia_svg__path46521"
                  d="M612.27 322.57c-3.91-5.36-19.15 8.58-15.08 12.91s18.69-7.48 15.08-12.91Z"
                  className="Bolivia_svg__cls-19"
                />
                <path
                  id="Bolivia_svg__path46523"
                  d="M598.56 334.44c2.87 2.18 13.92-7.18 12.09-10.72-3.05-3.31-15.21 8.57-12.09 10.72Z"
                  className="Bolivia_svg__cls-20"
                />
              </g>
            </g>
            <path
              id="Bolivia_svg__path46525"
              d="M603 341.79c6.86-2.19 11.73-6.76 14.81-13.59"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46527"
              d="M652.22 395.59c8.63-2.67 14.54-8.3 17.21-17.47"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46529"
              d="M655.72 399.61c8.63-2.67 14.54-8.3 17.21-17.47"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46531"
              d="M676.09 420.84a26.66 26.66 0 0 0 18.23-18.16"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46533"
              d="M679.69 424.86A27 27 0 0 0 698 406.6"
              className="Bolivia_svg__cls-9"
            />
            <path
              id="Bolivia_svg__path46535"
              d="M700 427.51c.43 2 1.54 2.67 3.1 2.05"
              className="Bolivia_svg__cls-8"
            />
            <path
              id="Bolivia_svg__path46537"
              d="M682.45 426.68c3.24 5.1 6.84 3.56 9.86 3.62"
              className="Bolivia_svg__cls-8"
            />
            <path
              id="Bolivia_svg__path46539"
              d="M704.4 427.78a2.52 2.52 0 0 1-2.57 2.46 2.54 2.54 0 0 1-2.6-2.47 2.52 2.52 0 0 1 2.57-2.47 2.9 2.9 0 0 1 2.59 2.87"
              className="Bolivia_svg__cls-16"
            />
            <path
              id="Bolivia_svg__path46541"
              d="M699.72 427.26c.43 2 1.55 2.67 3.11 2.05"
              className="Bolivia_svg__cls-8"
            />
            <path
              id="Bolivia_svg__path46543"
              d="M682.45 426.68c3.24 5.1 6.84 3.56 9.86 3.62"
              className="Bolivia_svg__cls-8"
            />
          </g>
        </g>
      </g>
      <g id="Bolivia_svg__g14289-8">
        <g id="Bolivia_svg__g8637-0">
          <path
            id="Bolivia_svg__path30956-2"
            d="M668.47 263.28c2.67 4.26 6.61 11.94 7.69 17.83a33.68 33.68 0 0 1-10.58 31.4c-7.7 6.93-19.8 9.08-24.85 10.11s-8.68 2.66-9.52 3.77a2.51 2.51 0 0 1 .69-2.35c2.39-1.06 6.27-1.68 11.69-2.8 10.87-2.24 22.3-6.32 28.52-18.19 8.12-15.47 3.29-27.64-3.75-39.71Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30731-5"
            d="M671.46 309.35a.81.81 0 0 1-1.08.13.73.73 0 0 1 .14-1 .82.82 0 0 1 1.09-.13.73.73 0 0 1-.15 1Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path30759-2"
            d="M678.86 307.41a19.8 19.8 0 0 1-4.5 1.64c-1 .33-2.7.87-3.29 1.09s-1.44.61-2.19.95a9.4 9.4 0 0 0-2.48 2s1.81 1.9 4 1.63a9.1 9.1 0 0 0 3.4-1.09c.89-.43.87-.92 2.14-1.83a10.33 10.33 0 0 0 2.92-4.39Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30761-8"
            d="M670.39 309.2c-.52.82-1.76.75-2.47.64l-.32.41c1 0 2.3 0 3-.85 0-.14-.1-.2-.18-.2Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30763-6"
            d="M678.84 307.48a25 25 0 0 1-6.94 4.19 21.1 21.1 0 0 1-7.5 1.54l-.41.43a27.6 27.6 0 0 0 7.64-1.63 22.3 22.3 0 0 0 7.23-4.44Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30906-1"
            d="M675.27 314.34c-2.92-.1-4.52.81-7.24 1.4-2.53.56-5.5-.76-7.14 1.68 6.61 4.28 11.38 1.4 14.38-3.08Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30908-3"
            d="M669.33 320.35c-1.26-1.08-12.08-4.74-13.8-.65 2.57 2.84 10.1 3.48 13.8.65Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30910-5"
            d="M666.77 323.23c-1.15-.18-2.49-.45-3.81-.6s-1.84-.38-2.82-.52c-1.59-.22-3.42-2.46-9.06-.75 2.18 5.02 9.63 6.08 15.69 1.87Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30914-8"
            d="M669.2 320.43c-5.76 1.15-12.53 0-15.21-1.58l-.43.28a24.5 24.5 0 0 0 15.64 1.3Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30916-9"
            d="M675.18 314.34c-3.39 2.28-7.76 4-17.13 2.72l-.13.33c12.84 1.1 14.08-1.26 17.26-3.05Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30920-7"
            d="M666.72 323.27c-4.48.16-7 2.15-15.39-2-.68-.34-1.6-.57-2.13-.82l-.77.28c.59.26 1.53.26 2.06.49 10.51 4.64 10.18 2.48 16.23 2.05Z"
            className="Bolivia_svg__cls-11"
          />
          <g id="Bolivia_svg__g3317-2">
            <path
              id="Bolivia_svg__path30890-7"
              d="M649.88 317.41c-.42.22-.62.65-.44.95a.83.83 0 0 0 1.1.15c.42-.22.61-.64.43-.95a.83.83 0 0 0-1.09-.15Z"
              className="Bolivia_svg__cls-12"
            />
            <path
              id="Bolivia_svg__path30924-3"
              d="M649.72 318.38c-1 .25-1.24 1.4-1.33 2.07l-.5.18c.26-.89.61-2.1 1.69-2.47.12 0 .17.14.14.22Z"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <path
            id="Bolivia_svg__path30729-2"
            d="M677.88 280.22a.78.78 0 0 1-.85.65.74.74 0 0 1-.44-1 .77.77 0 0 1 .85-.65.74.74 0 0 1 .44 1Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path30733-3"
            d="M671.43 304.73c-.21-3.13-1.73 1.21-4.79-5.78-.89-2-.89-3.33-1.49-6.38 1.67 2.64 4.46 3.35 5.59 5.38s.83 5.23.69 6.78Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30735-4"
            d="M665.21 292.8a26.6 26.6 0 0 0 3.68 6 11.8 11.8 0 0 1 2.6 5.57"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30737-6"
            d="M666.7 295.79c1.93 2.6 4.52 5.67 4.64 8.89l.3.11c-.45-4.24-3-6.2-4.5-8.33Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30739-2"
            d="M683 299.8a17.5 17.5 0 0 1-4 2.15c-.9.44-1.65 1-2.18 1.32a18 18 0 0 0-2 .83 24 24 0 0 0-3.13 3s2 1.6 3.18 1.34c3.53-.69 4.56-2.09 6.34-3.39 1.32-1.05 1.41-3.75 1.79-5.25Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30741-0"
            d="m670 307.25-.33.49c2-.2 5.26-2.14 7.41-3.23 2.9-1.46 4.52-2.56 5.74-4.64-1.38 2.07-3.19 3.25-5.91 4.57-2.24 1.1-5.49 2.97-6.91 2.81Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30743-4"
            d="M684.18 292.94a17 17 0 0 1-3.61 2.78c-.8.58-1.44 1.28-1.91 1.65a18 18 0 0 0-1.81 1.14 18.6 18.6 0 0 0-2.29 3.28 2.1 2.1 0 0 0 2.13.59c3.56-.44 4.61-2.13 5.93-5.16.74-1.58 1.48-2.73 1.56-4.28Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30745-7"
            d="M671.31 299.17a.78.78 0 0 0 1 .49.73.73 0 0 0 .25-1 .8.8 0 0 0-1-.49.74.74 0 0 0-.25 1Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path30747-2"
            d="m672.77 302.38-.24.53c4.26-1.94 9.86-5.87 11.7-9.87-2.61 4.32-6.92 7.16-11.46 9.34Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30749-4"
            d="M685.15 286.35a16.2 16.2 0 0 1-3.2 3c-.71.62-1.26 1.35-1.68 1.75a20 20 0 0 0-1.63 1.24 18 18 0 0 0-1.92 3.39s1.31 1.22 2.36.7a18 18 0 0 0 3.16-2.35c.72-.64.9-2.21 1.75-3.4a6.62 6.62 0 0 0 1.16-4.33Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30751-2"
            d="M682.08 290.76a22 22 0 0 1-7 5.63l-.18.54a25.2 25.2 0 0 0 7.24-6.1Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30753-9"
            d="M683.68 282.29a14.4 14.4 0 0 1-2.5 3c-.56.65-.95 1.36-1.28 1.76s-.93.76-1.32 1.32a15 15 0 0 0-1.21 3.21s.88.94 1.78.33a17.8 17.8 0 0 0 2.74-2.49c.57-.67.86-2.11 1.46-3.27a5.38 5.38 0 0 0 .33-3.86Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30755-4"
            d="M677.13 280.65a15.7 15.7 0 0 0-.77 2.44l-.1-.6a11 11 0 0 1 .68-1.94c.06-.02.12-.02.19.1Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30757-4"
            d="M681.56 286.56a19.5 19.5 0 0 1-5.63 5.91l-.08.49a22 22 0 0 0 5.76-6.34Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30765-4"
            d="M673.12 301.4a4.9 4.9 0 0 0-.79-2c-.08 0-.13 0-.15.09a5.24 5.24 0 0 1 .76 2.24Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30727-3"
            d="M671.83 272a.55.55 0 0 1 .09.79.62.62 0 0 1-.82-.12.54.54 0 0 1-.1-.78.63.63 0 0 1 .83.11Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path30767-4"
            d="M673.72 273.79a13.6 13.6 0 0 0-1.87-1.29c-.08 0-.08.08-.06.15a13.2 13.2 0 0 1 2 1.51Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30868-8"
            d="M682 274.33c-1.7 3.58-5.78 6.08-4.14 11.33 4.22 3.8 4.49-6.82 4.14-11.33Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30870-0"
            d="M678.14 266.5c-.69 3.66-3.94 6.68-1.81 11.53 5.97 1.5 3.13-6.55 1.81-11.53Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30872-8"
            d="M674.61 261c3 5.59 3.72 8.82.18 12.48a8.9 8.9 0 0 1-2.31-5c-.37-2.67 1.85-5.93 2.13-7.48Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30874-7"
            d="M669.62 257.78c.8 3.54-2.27 5.16 2.11 9.72 3.13-3.72 1.64-4.65-2.11-9.72Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30876-8"
            d="M668.44 264c-5.05.54-3.08-3.84-4.52-7.88 2.97 2.19 7 3.08 4.52 7.88Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30878-2"
            d="M671.73 270.66c-1.42-6.59-6-4-8.46-6.91 1.3 4.25 3.21 7.14 8.46 6.91Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30880-2"
            d="M673.77 276.78c-3.94-.26-7.14-2.2-9.27-6.57 4.05 1.79 8.5 1.99 9.27 6.57Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30882-4"
            d="M674.37 282.5c-1.56-1.78-1.59-2.94-2.19-4.13a13.5 13.5 0 0 0-4.56-5.56c.02 4.66.68 9.8 6.75 9.69Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30884-0"
            d="M675.27 287.37c-2.42-3.37-4.67-6.24-8.33-8.6 1.52 3.32.81 9.45 8.33 8.6Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30886-3"
            d="M674.58 294.06c-7.43-.21-6.73-7.22-6.79-10.5a58 58 0 0 0 4.21 5.2c1.34 1.57 2.62 3.36 2.58 5.3Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30894-3"
            d="M673.69 298.24c-.6-1.52-.14-2.13-1.47-3.47s-4.19-4-5.63-7c-.2 2.62-.24 6.67 1.79 8 1.54 1.05 2.88 1.34 5.31 2.47Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30896-3"
            d="M667.19 309.11c-5.83-4.54-2.32-8.37-1.83-11.76 1.48 3.83 5.64 7.13 1.83 11.76Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30912-0"
            d="M669.59 265.35a84 84 0 0 0-5.52-9.12 109 109 0 0 1 5.79 9.68"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30930-8"
            d="M667.28 310.25c.24-4.63-1-8.61-1.84-12.78.77 4.41 1.87 8.84 1.45 13.14Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30932-5"
            d="M674.21 299.17c-.61-2.83-6.18-4.71-7.57-11.27 1.14 6.53 6.78 8.17 7.35 11.84Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30934-5"
            d="m675.45 295.32-.15.72c-.82-4.43-6-6.6-7.52-12.51 2.22 6.4 6.43 7.24 7.67 11.79Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30936-4"
            d="M676.48 288.7c-2.56-3.9-6.13-5.38-9.52-9.95 3.17 4.49 7.16 6.6 9.58 10.55Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30938-3"
            d="M676.39 283.56c-2.82-1.2-5.74-4.58-8.79-10.75 2 4.57 4.54 8.7 8.79 11.44Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30940-7"
            d="M675.09 277.54c-3.29-2.6-7.54-4.32-10.61-7.37 2.55 2.9 7.44 4.93 10.7 7.8Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30942-7"
            d="M672.55 271.09c-3.32-2.26-6.52-3-9.28-7.23 2.22 4.18 5.75 5.24 9.4 7.54Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30944-0"
            d="M682 274.41c-1.19 4.61-2.2 9.46-5.35 12.57v-.61c1.48-.8 3.76-5.6 5.35-11.96Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30946-6"
            d="M678.17 266.67c-.22 4.76-.13 9.8-2.6 12.51l-.18-.55c2.51-2.03 2.3-7.42 2.78-11.96Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30948-9"
            d="M674.79 261.25c.84 4.19.9 8.07-.21 14.34l-.25-.46a34.8 34.8 0 0 0 .46-13.88Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30950-6"
            d="M669.71 257.92c1.69 3.56 3 7.16 1.87 11l-.3-.43c1.31-3.49-.22-7.04-1.57-10.57Z"
            className="Bolivia_svg__cls-11"
          />
          <g id="Bolivia_svg__g3281-1">
            <path
              id="Bolivia_svg__path30898-8"
              d="M663.2 304.73c2 4.79-.64 8.28-3.76 10.29-2.44-6.96 2.63-6.18 3.76-10.29Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path30918-0"
              d="M663.28 304.72c.34 3-2.88 6.28-3.88 11.3l-.45.41c1.48-6.12 4.61-8.43 4.33-11.71Z"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <path
            id="Bolivia_svg__path42835-7"
            d="M674.57 271.82c0 .35-.29.6-.56.55a.62.62 0 0 1-.41-.72c0-.35.29-.6.56-.55a.62.62 0 0 1 .41.72Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path42837-4"
            d="M674.29 274.43a14 14 0 0 0-.12-2.27.09.09 0 0 0-.15 0 13.5 13.5 0 0 1 0 2.53Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path42841-5"
            d="M673.23 271.32a.68.68 0 0 1-.26.73c-.21.11-.43-.05-.5-.35a.66.66 0 0 1 .26-.73c.21-.11.43 0 .5.35Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path42843-3"
            d="M673.73 273.53a10.5 10.5 0 0 0-.71-1.73c-.06 0-.08.05-.1.11a11 11 0 0 1 .73 2Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path42850-5"
            d="M676.05 280.31c0 .36-.17.65-.44.65a.62.62 0 0 1-.55-.63c0-.35.17-.64.45-.65a.63.63 0 0 1 .54.63Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path42852-7"
            d="M676.29 282.93a14.4 14.4 0 0 0-.57-2.21c-.07 0-.11 0-.14.07a13.6 13.6 0 0 1 .54 2.47Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path42856-1"
            d="M674.41 280.84a.68.68 0 0 1 .09.87c-.19.2-.53.14-.77-.13a.68.68 0 0 1-.09-.87.53.53 0 0 1 .77.13Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path42858-4"
            d="M676.19 282.86a13 13 0 0 0-1.76-1.44c-.07 0-.08.09 0 .17a13 13 0 0 1 1.9 1.67Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path42862-6"
            d="M674 298.69c-.11.34-.4.54-.66.44a.63.63 0 0 1-.26-.79.55.55 0 0 1 .65-.44.62.62 0 0 1 .27.79Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path42864-3"
            d="M673.26 301.2a14 14 0 0 0 .31-2.25c-.06-.06-.11 0-.16 0a14 14 0 0 1-.43 2.49Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path42868-6"
            d="M675 299.81a.54.54 0 0 0-.09.78.62.62 0 0 0 .82-.11.55.55 0 0 0 .09-.79.62.62 0 0 0-.82.12Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path42870-2"
            d="M673.07 301.63a14.4 14.4 0 0 1 1.88-1.29c.07 0 .08.08.06.14a14 14 0 0 0-2 1.51Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path42874-6"
            d="M670.07 307.37a.54.54 0 0 1-.78.08.61.61 0 0 1 .13-.82.54.54 0 0 1 .78-.08.62.62 0 0 1-.13.82Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path42876-9"
            d="M668.22 309.24a14 14 0 0 0 1.32-1.86c0-.07-.08-.08-.14-.06a13.3 13.3 0 0 1-1.54 2Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30888-7"
            d="M667.27 306.77a.74.74 0 0 0 .55.9.8.8 0 0 0 .78-.75.74.74 0 0 0-.6-.92.77.77 0 0 0-.77.74Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path30952-9"
            d="M668.07 307.61a1.62 1.62 0 0 0 .1 1.65l-.22.46a2.6 2.6 0 0 1-.15-2.17.21.21 0 0 1 .27.06Z"
            className="Bolivia_svg__cls-11"
          />
          <g id="Bolivia_svg__g3321-9">
            <path
              id="Bolivia_svg__path30954-7"
              d="M649.9 321.68a1.76 1.76 0 0 1-1.83-1.08h-.53a2.67 2.67 0 0 0 2.3 1.33c.1-.09.11-.18.06-.25Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path30892-6"
              d="M650 322.71c-.47-.09-.79-.45-.71-.79a.81.81 0 0 1 1-.44c.47.09.79.45.71.79a.81.81 0 0 1-1 .44Z"
              className="Bolivia_svg__cls-12"
            />
          </g>
          <path
            id="Bolivia_svg__path30900-7"
            d="M658 309.12a8.25 8.25 0 0 1-6 9.54c-1.3-5.96 4.2-6.17 6-9.54Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path30928-1"
            d="M658.05 309.16a32.3 32.3 0 0 1-7.13 10.72l-.78.1c4.03-3.18 6.24-7.32 7.91-10.82Z"
            className="Bolivia_svg__cls-11"
          />
          <path
            id="Bolivia_svg__path42880-2"
            d="M650.7 320a.94.94 0 0 1-1-.38c-.17-.3 0-.62.39-.72a.92.92 0 0 1 1 .38c.17.3 0 .62-.39.72Z"
            className="Bolivia_svg__cls-12"
          />
          <path
            id="Bolivia_svg__path42882-6"
            d="M647.86 320.69a12.7 12.7 0 0 0 2.18-1 .17.17 0 0 0-.17-.14 11.2 11.2 0 0 1-2.48 1l.47.13Z"
            className="Bolivia_svg__cls-11"
          />
          <g id="Bolivia_svg__g3299-8">
            <path
              id="Bolivia_svg__path30904-2"
              d="M651.8 313.2c-.19 1.85-1.66 3.52-3 4.83s-1.5 1.79-3.4 2.35c-1.82-4.15 4.28-4.98 6.4-7.18Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path30922-5"
              d="M651.78 313.15c-2 3.81-5.28 5.69-7 8.15h-.25c2.47-3.36 4.64-4 7.25-8.15Z"
              className="Bolivia_svg__cls-11"
            />
          </g>
        </g>
        <g id="Bolivia_svg__g13596-0">
          <path
            id="Bolivia_svg__path8725-0"
            d="M609.63 263.28c-2.63 4.26-6.63 11.94-7.63 17.83a33.7 33.7 0 0 0 10.57 31.4c7.71 6.93 19.81 9.08 24.86 10.11s8.68 2.66 9.52 3.77a2.51 2.51 0 0 0-.69-2.35c-2.39-1.06-6.27-1.68-11.69-2.8-10.87-2.24-22.3-6.32-28.53-18.19-8.11-15.47-3.28-27.64 3.75-39.71Z"
            className="Bolivia_svg__cls-11"
          />
          <g id="Bolivia_svg__g12828-6">
            <path
              id="Bolivia_svg__path12270-0"
              d="M630.15 320.37c-.33.62-6 5.61-11.18 5.23-3.79-.27-4.41-1.18-4.41-1.18s-.36-.94 3-1.63 9.28-3.01 12.59-2.42Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path12272-0"
              d="M614.74 324.44c4.07.46 8.21-1.18 11.45-2.42"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g12848-3">
            <path
              id="Bolivia_svg__path12850-7"
              d="M625.79 313c.43.07 5.1 2.46 6.89 5.6 1.32 2.29 1.1 2.84 1.1 2.84s-.33.4-2-1.46-5.02-4.93-5.99-6.98Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path12852-8"
              d="M633.72 321.31c-1.32-2.5-3.73-4.63-5.59-6.31"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g12854-6">
            <path
              id="Bolivia_svg__path12856-2"
              d="M609.4 263.78c-.11-.46.44-5.15 3.07-6.63 1.93-1.08 2.62-.77 2.62-.77s.57.41-.73 1.9-3.13 4.72-4.96 5.5Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path12858-7"
              d="M615 256.42c-2.14 1.08-3.4 3.36-4.41 5.12"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g12860-9">
            <path
              id="Bolivia_svg__path12862-6"
              d="M608.08 266.15c-.24-.31-1.53-4.42-.35-7.09.86-2 1.42-2.1 1.42-2.1s.52 0 .2 2-.35 5.56-1.27 7.19Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path12864-3"
              d="M609.1 257.06c-1 2.06-1 4.63-1.05 6.62"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g12866-3">
            <path
              id="Bolivia_svg__path12868-2"
              d="M608.06 266.19c.33 0 4.08-1.09 5.82-3.14 1.29-1.49 1.21-1.93 1.21-1.93s-.19-.33-1.64.8-4.39 2.89-5.39 4.27Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path12870-7"
              d="M615 261.2a19 19 0 0 1-5 3.84"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13368-1">
            <path
              id="Bolivia_svg__path13370-1"
              d="M606.27 269.38c-.25-.31-2-4.67-1.3-7.83.48-2.32.95-2.56.95-2.56s.45-.06.45 2.14.48 6.28-.1 8.25Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13372-6"
              d="M605.89 259.1a22.7 22.7 0 0 0 0 7.54"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13374-2">
            <path
              id="Bolivia_svg__path13376-2"
              d="M605 272.36c-.38-.26-3.41-4.37-3.12-7.83.22-2.53.8-2.9.8-2.9s.59-.18 1 2.12 1.68 6.42 1.32 8.61Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13378-3"
              d="M602.61 261.75c-.34 2.71.63 5.59 1.36 7.85"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13380-0">
            <path
              id="Bolivia_svg__path13382-1"
              d="M603.32 276.21c-.33-.22-3.28-3.85-3.62-7.06-.25-2.35.13-2.73.13-2.73s.41-.2 1.07 1.91 2.37 5.83 2.42 7.88Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13384-7"
              d="M599.83 266.54a22.9 22.9 0 0 0 2.3 7.17"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13410-2">
            <path
              id="Bolivia_svg__path13412-8"
              d="M606.35 269.43c.39.09 4.79-.38 6.82-2.58 1.49-1.62 1.39-2.2 1.39-2.2s-.23-.48-1.92.61-5.13 2.63-6.29 4.17Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13414-5"
              d="M614.49 264.73c-1.53 1.8-3.94 2.86-5.8 3.71"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13416-6">
            <path
              id="Bolivia_svg__path13418-3"
              d="M604.93 272.38c.38.12 4.8 0 7-2.08 1.6-1.5 1.54-2.09 1.54-2.09s-.19-.5-2 .47-5.27 2.25-6.54 3.7Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13420-7"
              d="M613.38 268.29c-1.65 1.68-4.13 2.56-6 3.27"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13422-6">
            <path
              id="Bolivia_svg__path13424-9"
              d="M603.54 276.26c.41.11 5.13-.23 7.38-2.52 1.65-1.68 1.56-2.3 1.56-2.3s-.22-.53-2.07.59-5.58 2.62-6.87 4.23Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13426-0"
              d="M612.41 271.52c-1.7 1.87-4.31 2.92-6.34 3.77"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13386-9">
            <path
              id="Bolivia_svg__path13388-4"
              d="M604.26 274.51a4.2 4.2 0 0 1-.44-1.6 3 3 0 0 1 .19-1.17l-.3-.18a8.5 8.5 0 0 0-.14 1.22v.5a3.4 3.4 0 0 1-.66-.73c-.11-.26-.26-.65-.26-.65l-.27.12a3.1 3.1 0 0 0 .46 1 4.6 4.6 0 0 1 1.16 1.67"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13390-7"
              d="M602.39 270.45c.31 0 .59.3.64.75s-.15.84-.45.87-.59-.3-.64-.74.15-.84.45-.88Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path13392-7"
              d="M604.26 270.44c.28.1.4.53.25.95s-.5.69-.79.59-.4-.53-.26-1 .54-.64.8-.54Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13402-0">
            <path
              id="Bolivia_svg__path13404-1"
              d="M604.09 274.42a4.2 4.2 0 0 0 1.35-1 2.9 2.9 0 0 0 .59-1l.34.05a10 10 0 0 1-.65 1 4 4 0 0 1-.33.38 3.5 3.5 0 0 0 1-.15c.26-.13.62-.34.62-.34l.13.26a3.2 3.2 0 0 1-1 .47 4.5 4.5 0 0 0-1.95.55"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13406-4"
              d="M608.1 272.45c-.22-.22-.65-.14-1 .18s-.41.75-.2 1 .65.14 1-.17.41-.79.2-1.01Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path13408-9"
              d="M606.66 271.27c-.29-.11-.65.15-.8.58s0 .85.25.95.64-.15.79-.58.1-.85-.24-.95Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13428-7">
            <path
              id="Bolivia_svg__path13430-0"
              d="M602.17 280.3c-.36-.2-3.67-3.79-4.23-7.1-.42-2.43-.05-2.84-.05-2.84s.41-.24 1.24 1.91 2.87 5.91 3.04 8.03Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13432-4"
              d="M597.9 270.48c.36 2.61 1.78 5.24 2.87 7.3"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13434-1">
            <path
              id="Bolivia_svg__path13436-9"
              d="M602.39 280.34c.44.09 5.33-.58 7.52-3.11 1.6-1.85 1.47-2.49 1.47-2.49s-.27-.53-2.12.75-5.62 3.09-6.87 4.85Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13438-5"
              d="M611.3 274.83c-1.64 2.05-4.29 3.32-6.34 4.33"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13440-4">
            <path
              id="Bolivia_svg__path13442-6"
              d="M601.76 284.44c.43 0 5.27-1.39 7.54-4 1.66-1.89 1.56-2.44 1.56-2.44s-.25-.43-2.13 1-5.67 3.68-6.97 5.44Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13444-9"
              d="M610.78 278.11c-1.71 2.09-4.37 3.64-6.44 4.86"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13446-8">
            <path
              id="Bolivia_svg__path13448-1"
              d="M601.62 284.44c-.5-.15-5.06-3.37-5.75-6.81-.5-2.52 0-3 0-3s.59-.33 1.7 1.81 3.86 5.76 4.05 8Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13450-0"
              d="M595.91 274.73c.43 2.72 2.35 5.27 3.82 7.28"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13468-0">
            <path
              id="Bolivia_svg__path13470-8"
              d="M601.76 289.61c.44-.07 5.08-2.4 6.89-5.46 1.33-2.24 1.12-2.78 1.12-2.78s-.32-.38-2 1.43-5.02 4.78-6.01 6.81Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13472-2"
              d="M609.71 281.49c-1.34 2.43-3.74 4.51-5.6 6.14"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13474-8">
            <path
              id="Bolivia_svg__path13476-6"
              d="M601.54 289.77c-.5-.06-5.43-2.52-6.69-5.94-.92-2.51-.5-3.14-.5-3.14s.51-.45 1.94 1.55 4.71 5.26 5.25 7.53Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13478-9"
              d="M594.38 280.82c.89 2.73 3.17 5 4.92 6.8"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13452-1">
            <path
              id="Bolivia_svg__path13454-5"
              d="M601.58 287.38a4.5 4.5 0 0 1-.89-1.57 3 3 0 0 1-.1-1.29l-.37-.11a10 10 0 0 0 .17 1.33 5 5 0 0 0 .14.52 3.9 3.9 0 0 1-.88-.59c-.2-.25-.46-.62-.46-.62l-.25.19s.48.8.74.91a5 5 0 0 1 1.68 1.46"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13456-5"
              d="M598.53 283.59c.31-.12.7.16.88.62s.05.92-.26 1-.7-.16-.87-.62-.06-.89.25-1Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path13458-2"
              d="M600.5 283.08c.33 0 .56.45.52.94s-.35.86-.69.83-.56-.45-.52-.94.35-.86.69-.83Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13460-5">
            <path
              id="Bolivia_svg__path13462-4"
              d="M601.56 287.33a4.7 4.7 0 0 0 1.17-1.38 3.1 3.1 0 0 0 .35-1.25h.38a12 12 0 0 1-.41 1.28 5 5 0 0 1-.25.48 3.8 3.8 0 0 0 1-.41l.57-.52.21.23s-.62.69-.9.76a4.9 4.9 0 0 0-1.92 1.11"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13464-6"
              d="M605.28 284.18c-.29-.18-.72 0-1 .44s-.23.9.05 1.07.72 0 1-.44.23-.9-.05-1.07Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path13466-2"
              d="M603.44 283.3c-.33 0-.64.34-.69.83s.18.91.51.94.64-.33.69-.82-.18-.91-.51-.95Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13480-3">
            <path
              id="Bolivia_svg__path13482-8"
              d="M602.14 294.34c-.48-.08-5.69-2.69-7.71-6.11-1.49-2.51-1.26-3.12-1.26-3.12s.37-.43 2.2 1.6 5.63 5.36 6.77 7.63Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13484-3"
              d="M593.24 285.24c1.5 2.73 4.2 5.06 6.28 6.89"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13486-0">
            <path
              id="Bolivia_svg__path13488-7"
              d="M602.48 294.25c.55-.07 5.95-2.76 7.33-6.51 1-2.75.55-3.43.55-3.43s-.56-.5-2.12 1.69-5.13 5.76-5.76 8.25Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13490-2"
              d="M610.32 284.44c-1 3-3.46 5.49-5.39 7.45"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13492-2">
            <path
              id="Bolivia_svg__path13494-4"
              d="M603.88 298.87c.51-.13 5.51-3.35 6.81-7.15.95-2.78.54-3.39.54-3.39s-.52-.43-2 1.88-4.75 6.17-5.35 8.66Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13496-3"
              d="M611.18 288.46c-.91 3-3.23 5.72-5 7.84"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13498-1">
            <path
              id="Bolivia_svg__path13500-9"
              d="M603.5 298.87c-.61 0-7.07-1.84-9.33-5.68-1.65-2.81-1.29-3.65-1.29-3.65s.52-.66 2.67 1.43 6.77 5.29 7.95 7.9Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13502-7"
              d="M593 289.68c1.66 3.09 4.9 5.32 7.4 7.09"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13520-9">
            <path
              id="Bolivia_svg__path13522-9"
              d="M609.23 308.54c.4-.27 3.89-4.61 4.17-8.35.2-2.73-.27-3.15-.27-3.15s-.52-.21-1.25 2.26-2.68 6.86-2.65 9.24Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13524-6"
              d="M613.12 297.18c-.12 2.93-1.49 6-2.53 8.41"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13526-1">
            <path
              id="Bolivia_svg__path13528-9"
              d="M608.93 308.43c-.64.2-7.95 0-11.4-3.19-2.52-2.37-2.37-3.3-2.37-3.3s.35-.79 3.2.72 8.64 3.49 10.57 5.77Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13530-6"
              d="M595.27 302.06c2.61 2.64 6.63 4 9.75 5.11"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13532-9">
            <path
              id="Bolivia_svg__path13534-3"
              d="M606.24 304.62c-.57 0-7.09-1.54-10.21-4.81-2.29-2.39-2.18-3.11-2.18-3.11s.31-.56 2.87 1.21 7.72 4.49 9.52 6.71Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13536-6"
              d="M594 296.82c2.36 2.63 6 4.52 8.78 6"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13538-7">
            <path
              id="Bolivia_svg__path13540-2"
              d="M606.6 304.43c.54-.2 5.35-4.19 5.9-8.37.4-3.06-.21-3.66-.21-3.66s-.67-.39-1.75 2.22-3.86 7.09-3.94 9.81Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13542-9"
              d="M612.28 292.55c-.3 3.3-2.25 6.43-3.75 8.89"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13504-3">
            <path
              id="Bolivia_svg__path13506-0"
              d="M605.16 302.21a5.2 5.2 0 0 1-1.61-1.23 3.5 3.5 0 0 1-.69-1.27l-.43.05a11 11 0 0 0 .77 1.29l.38.47a4 4 0 0 1-1.17-.21l-.75-.43-.16.31a3.8 3.8 0 0 0 1.16.6 5.6 5.6 0 0 1 2.37.74"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13508-1"
              d="M600.33 299.67c.27-.26.79-.15 1.18.25s.47.92.21 1.18-.8.15-1.18-.24-.48-.93-.21-1.19Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path13510-8"
              d="M602.12 298.27c.36-.12.78.21 1 .73s0 1-.33 1.16-.78-.21-1-.73-.02-1.04.33-1.16Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13512-6">
            <path
              id="Bolivia_svg__path13514-9"
              d="M605.3 302.15a5.1 5.1 0 0 0 .58-1.94 3.4 3.4 0 0 0-.2-1.43l.37-.21a12 12 0 0 1 .15 1.49v.61a4.3 4.3 0 0 0 .83-.86c.15-.32.34-.79.34-.79l.32.15a3.8 3.8 0 0 1-.58 1.17 5.7 5.7 0 0 0-1.48 2"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13516-3"
              d="M607.7 297.26c-.37-.05-.73.35-.81.89s.17 1 .54 1.08.73-.35.8-.89-.16-1.03-.53-1.08Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path13518-2"
              d="M605.42 297.18c-.35.12-.5.64-.33 1.16s.59.85.94.74.51-.63.34-1.15-.59-.86-.95-.75Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13560-7">
            <path
              id="Bolivia_svg__path13562-8"
              d="M611.65 311.39c-.45.29-6.37 1.6-10.15-.36-2.76-1.43-2.94-2.22-2.94-2.22s.05-.72 2.81-.05 7.98 1.15 10.28 2.63Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13564-2"
              d="M598.7 308.88c2.91 1.65 6.57 2 9.42 2.25"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13566-4">
            <path
              id="Bolivia_svg__path13568-1"
              d="M612 311.29c.32-.21 2.93-3.86 2.81-7.29-.08-2.52-.53-2.95-.53-2.95s-.47-.26-.87 1.95-1.64 6.08-1.41 8.29Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13570-4"
              d="M614.31 301.17a20.9 20.9 0 0 1-1.4 7.53"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13572-0">
            <path
              id="Bolivia_svg__path13574-6"
              d="M617.31 315.51c-.56.34-7.66 2.19-12 .36-3.16-1.33-3.3-2.18-3.3-2.18s.11-.77 3.32-.25 9.38.65 11.98 2.07Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13576-7"
              d="M602.19 313.77c3.32 1.55 7.62 1.63 11 1.72"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13578-0">
            <path
              id="Bolivia_svg__path13580-6"
              d="M617.65 315.46c.3-.45 1.83-5.74 0-8.47-1.34-2-2.13-2-2.13-2s-.73.2-.15 2.37.87 6.5 2.28 8.1Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13582-7"
              d="M615.59 305.12c1.55 2.07 1.74 5.09 1.92 7.42"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g13544-1">
            <path
              id="Bolivia_svg__path13546-4"
              d="M614 313a1.72 1.72 0 0 1-1.82.14 3.9 3.9 0 0 1-1.27-1.07l-.44.23a13 13 0 0 0 1.37 1.06c.48.28.62.34.62.34a4.8 4.8 0 0 1-1.35.27c-.4 0-1-.14-1-.14v.4a11 11 0 0 0 1.5.15 20 20 0 0 0 2.3-.77"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13548-0"
              d="M608.19 313.1c.18-.39.79-.5 1.37-.24s.9.79.73 1.18-.79.5-1.37.24-.92-.78-.73-1.18Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path13550-2"
              d="M609.51 310.84c.33-.28.93-.11 1.34.37s.47 1.1.14 1.38-.93.11-1.33-.37-.48-1.11-.15-1.38Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13552-0">
            <path
              id="Bolivia_svg__path13554-1"
              d="M614.11 313.51a1.71 1.71 0 0 0 .25-1.8 4.1 4.1 0 0 0-1-1.35l.26-.42a13 13 0 0 1 1 1.44c.25.5.3.63.3.63a4.8 4.8 0 0 0 .36-1.33c0-.4-.08-1-.08-1h.4a14 14 0 0 1 .06 1.51 21 21 0 0 1-.92 2.25"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13556-7"
              d="M614.58 307.71c-.4.15-.55.75-.33 1.35s.73.95 1.14.8.55-.76.32-1.35-.71-.95-1.13-.8Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path13558-8"
              d="M612.24 308.89c-.3.31-.17.91.29 1.35s1.07.54 1.37.23.16-.92-.3-1.35-1.07-.54-1.36-.23Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13584-9">
            <path
              id="Bolivia_svg__path13586-0"
              d="M621.46 317.78c-.39.52-6.33 4.39-11.08 3.45-3.48-.69-3.94-1.59-3.94-1.59s-.21-.89 3-1.13 9.02-1.65 12.02-.73Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13588-7"
              d="M606.61 319.68c3.71.9 7.78-.11 10.95-.86"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g12835-4">
            <path
              id="Bolivia_svg__path12276-2"
              d="M625.15 318.82a1.94 1.94 0 0 1-1.92.82 4.65 4.65 0 0 1-1.79-.69l-.39.41a16 16 0 0 0 1.89.64c.63.13.79.15.79.15a5.5 5.5 0 0 1-1.37.8l-1.12.2.1.46a13 13 0 0 0 1.69-.4 24 24 0 0 0 2.22-1.69"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path12278-8"
              d="M618.85 321.09c0-.5.68-.84 1.4-.77s1.28.52 1.24 1-.68.83-1.41.76-1.27-.5-1.23-.99Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path12280-2"
              d="M619.46 318.13c.25-.43 1-.47 1.59-.09s.92 1 .67 1.45-1 .47-1.6.09-.92-1.03-.66-1.45Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
          <g id="Bolivia_svg__g13590-8">
            <path
              id="Bolivia_svg__path13592-9"
              d="M623.21 318.32c.27-.48 1.15-5.92-1.34-8.37-1.83-1.79-2.71-1.65-2.71-1.65s-.78.3.21 2.36 2.01 6.27 3.84 7.66Z"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path13594-7"
              d="M619.25 308.39c2.08 1.84 2.77 4.78 3.35 7.07"
              className="Bolivia_svg__cls-11"
            />
          </g>
          <g id="Bolivia_svg__g12840-2">
            <path
              id="Bolivia_svg__path12842-6"
              d="M626 319.6a2 2 0 0 0-.67-2 4.45 4.45 0 0 0-1.71-.87l.05-.57a17 17 0 0 1 1.74 1c.51.38.63.49.63.49a5.5 5.5 0 0 0-.31-1.55l-.6-1 .4-.23a14 14 0 0 1 .84 1.53 24 24 0 0 1 .22 2.78"
              className="Bolivia_svg__cls-11"
            />
            <path
              id="Bolivia_svg__path12844-6"
              d="M623.51 313.39c-.34.37-.18 1.06.36 1.56s1.24.6 1.58.24.17-1.06-.36-1.56-1.25-.63-1.58-.24Z"
              className="Bolivia_svg__cls-21"
            />
            <path
              id="Bolivia_svg__path12846-4"
              d="M621.7 315.82c-.14.47.31 1 1 1.24s1.38 0 1.52-.47-.3-1-1-1.25-1.37 0-1.52.48Z"
              className="Bolivia_svg__cls-21"
            />
          </g>
        </g>
      </g>
      <g id="Bolivia_svg__g44719">
        <path
          id="Bolivia_svg__path4673-8-4"
          d="M637.65 313.48s-3.51 8.16-2.29 9c0 0 3.56-6.33 6.69-8.73 1.62-1.53 2.61 0 2.82-1.34s-4.28-3.28-4.28-3.28l-2.87 4"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4675-9-6"
          d="M637.65 313.48s-3.51 8.16-2.29 9c0 0 3.56-6.33 6.69-8.73 1.62-1.53 2.61 0 2.82-1.34s-4.28-3.28-4.28-3.28l-2.87 4"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4677-7-2"
          d="M624.85 319.69s-5.11 8.89-3.77 9 6.8-11.33 6.8-11.33l-1.87.32Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4679-2-6"
          d="M624.85 319.69s-5.11 8.89-3.77 9 6.8-11.33 6.8-11.33l-1.87.32Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4681-2-1"
          d="M626.39 317.21s-5.34 8.75-4 8.89 7.09-11.1 7.09-11.1l-1.87.27Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4683-0-6"
          d="M626.39 317.21s-5.34 8.75-4 8.89 7.09-11.1 7.09-11.1l-1.87.27Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4685-8-2"
          d="M627.47 315.69s-6.08 8.23-4.76 8.49 8-10.45 8-10.45l-1.88.09Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4687-8-2"
          d="M627.47 315.69s-6.08 8.23-4.76 8.49 8-10.45 8-10.45l-1.88.09Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4689-0-1"
          d="M629.09 314.25s-7.11 7.3-5.84 7.74 9.35-9.23 9.35-9.23l-1.88-.17Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4691-05-4"
          d="M629.09 314.25s-7.11 7.3-5.84 7.74 9.35-9.23 9.35-9.23l-1.88-.17Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4693-9-5"
          d="M629.34 311.59s-6.2 8.12-4.89 8.41 8.2-10.32 8.2-10.32l-1.89.07Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4695-8-0"
          d="M629.34 311.59s-6.2 8.12-4.89 8.41 8.2-10.32 8.2-10.32l-1.89.07Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4697-1-4"
          d="M627.76 318.57s-6.07 8.22-4.76 8.49 8-10.46 8-10.46l-1.89.1Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4699-4-4"
          d="M627.76 318.57s-6.07 8.22-4.76 8.49 8-10.46 8-10.46l-1.89.1Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4701-4-7"
          d="M631.18 317s-3.56 6.69-3.15 7 4.72-3.82 6.86-7.8-3.86.66-3.86.66"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4703-6-0"
          d="M631.18 317s-3.56 6.69-3.15 7 4.72-3.82 6.86-7.8-3.86.66-3.86.66"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4709-0-4"
          d="M631.56 316.28s-3.51 8.16-2.3 9c0 0 4.41-4.92 5.56-8.83s0-.27 0-.27l-.32-4.25-2.88 4"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4711-6-4"
          d="M631.56 316.28s-3.51 8.16-2.3 9c0 0 4.41-4.92 5.56-8.83s0-.27 0-.27l-.32-4.25-2.88 4"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4713-9-7"
          d="M629.74 315.57s-7.12 7.3-5.85 7.74 9.35-9.24 9.35-9.24l-1.88-.16Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4715-5-1"
          d="M629.74 315.57s-7.12 7.3-5.85 7.74 9.35-9.24 9.35-9.24l-1.88-.16Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4717-7-9"
          d="M630.3 316.56s-7.11 7.3-5.84 7.74 9.35-9.24 9.35-9.24l-1.88-.16z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4719-3-7"
          d="M630.3 316.56s-7.11 7.3-5.84 7.74 9.35-9.24 9.35-9.24l-1.88-.16z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4721-3-9"
          d="M630.87 317.71s-7.12 7.31-5.85 7.75 9.35-9.24 9.35-9.24l-1.88-.17Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4723-4-6"
          d="M630.87 317.71s-7.12 7.31-5.85 7.75 9.35-9.24 9.35-9.24l-1.88-.17Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4725-6-8"
          d="M631.4 307.69s-5.29 6.75-4.52 7.91 5.58-3.1 7.11-6.09-2.54-2-2.54-2"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4727-2-4"
          d="M631.4 307.69s-5.29 6.75-4.52 7.91 5.58-3.1 7.11-6.09-2.54-2-2.54-2"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4729-6-7"
          d="M631.23 314.86s-4.53 8.66-3.36 8.17 5.76-7 6.27-8.46a7.5 7.5 0 0 0 .33-2.94l-3.5 2.16.3 1.68"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4731-0-2"
          d="M631.23 314.86s-4.53 8.66-3.36 8.17 5.76-7 6.27-8.46a7.5 7.5 0 0 0 .33-2.94l-3.5 2.16.3 1.68"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4733-2-1"
          d="M631.26 312s3.76-6.91 0 1.31-5.2 6.85-5.2 6.85c-.29-.47 3.29-6 3.29-6s2.66-4.28 3.3-4.69"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4735-8-1"
          d="M631.26 312s3.76-6.91 0 1.31-5.2 6.85-5.2 6.85c-.29-.47 3.29-6 3.29-6s2.66-4.28 3.3-4.69"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4737-7-0"
          d="M635.29 311.09s4.18-6.87 0 1.3-5.83 6.79-5.83 6.79c-.33-.48 3.67-6 3.67-6s3-4.25 3.68-4.65"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4739-6-4"
          d="M635.29 311.09s4.18-6.87 0 1.3-5.83 6.79-5.83 6.79c-.33-.48 3.67-6 3.67-6s3-4.25 3.68-4.65"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4751-1-5"
          d="M633.76 308.19s-5.29 6.75-4.53 7.91 5.59-3.1 7.12-6.08-2.54-2-2.54-2"
          className="Bolivia_svg__cls-23"
        />
      </g>
      <path
        id="Bolivia_svg__path4790-9"
        d="M688.23 376.62c0 30.58-22 55.39-49.22 55.4s-49.23-24.79-49.24-55.37c0-30.59 22-55.39 49.23-55.39s49.23 24.74 49.23 55.36"
        style={{
          fill: "#e8a30e",
        }}
      />
      <path
        id="Bolivia_svg__path15610"
        d="M599.55 376.62c0-25.73 18.1-45.48 39.45-45.48s39.45 19.75 39.45 45.48"
        style={{
          strokeWidth: ".5px",
          fill: "none",
          stroke: "#390",
        }}
      />
      <path
        id="Bolivia_svg__path12214-3"
        d="M589.84 379.52C591.18 408.76 612.68 432 639 432s47.82-23.24 49.16-52.48Z"
        style={{
          fill: "#007934",
          strokeWidth: ".5px",
          stroke: "#eee",
        }}
      />
      <path
        id="Bolivia_svg__path17689"
        d="M688.23 376.62c0 30.58-22 55.39-49.22 55.39s-49.23-24.78-49.24-55.37c0-30.59 22-55.39 49.23-55.39s49.23 24.75 49.23 55.37Z"
        className="Bolivia_svg__cls-9"
      />
      <g id="Bolivia_svg__g5967-9">
        <path
          id="Bolivia_svg__path5969-6"
          d="M630.76 338.05a6.66 6.66 0 0 0 1.08 5.47 7.43 7.43 0 0 1 1.3 4.06 12 12 0 0 0-1 .67l-8.33-5.53 5.59 8.23c-.1.14-.2.28-.29.43a7.3 7.3 0 0 0-4.49-.59 7.4 7.4 0 0 1-5.49-1.09 6.72 6.72 0 0 0 4.65 3.11 7.33 7.33 0 0 1 3.79 2 12 12 0 0 0-.27 1.19l-9.8 2 9.78 1.87.09.51a7.27 7.27 0 0 0-3.59 2.76 7.32 7.32 0 0 1-4.64 3.1 6.68 6.68 0 0 0 5.48-1.09 7.37 7.37 0 0 1 4.06-1.29 11 11 0 0 0 .66 1l-5.53 8.33 8.24-5.6.42.3a7.23 7.23 0 0 0-.58 4.5 7.35 7.35 0 0 1-1.1 5.47 6.67 6.67 0 0 0 3.11-4.65 7.26 7.26 0 0 1 2-3.78 10 10 0 0 0 1.19.26l2 9.8 1.87-9.77.51-.1a7.2 7.2 0 0 0 2.76 3.59 7.42 7.42 0 0 1 3.11 4.65 6.72 6.72 0 0 0-1.1-5.48 7.4 7.4 0 0 1-1.29-4.06c.36-.21.71-.43 1-.66l8.33 5.53-5.59-8.24.29-.42a7.3 7.3 0 0 0 4.5.58 7.34 7.34 0 0 1 5.47 1.09 6.69 6.69 0 0 0-4.64-3.1 7.4 7.4 0 0 1-3.79-2q.16-.6.27-1.2l9.8-2-9.78-1.88c0-.16-.06-.33-.1-.5a7.26 7.26 0 0 0 3.6-2.76 7.36 7.36 0 0 1 4.64-3.1 6.68 6.68 0 0 0-5.48 1.08 7.3 7.3 0 0 1-4.06 1.29 10 10 0 0 0-.66-1l5.53-8.33-8.28 5.61-.42-.29a7.22 7.22 0 0 0 .58-4.49 7.4 7.4 0 0 1 1.09-5.49 6.69 6.69 0 0 0-3.1 4.65 7.3 7.3 0 0 1-2 3.79 12 12 0 0 0-1.19-.27l-2-9.8-1.88 9.78-.5.09a7.27 7.27 0 0 0-2.76-3.59 7.4 7.4 0 0 1-3.06-4.64Z"
          className="Bolivia_svg__cls-12"
        />
        <g id="Bolivia_svg__g5971-3">
          <g id="Bolivia_svg__g5977-4">
            <g id="Bolivia_svg__g5979-0">
              <path
                id="Bolivia_svg__path5981-7"
                d="M647.77 355.06c-2.46-2.14-5.56-2.46-7.27-.86-1.24 1.66-1.13 3.62.32 5.67a.86.86 0 0 0-.43.21 7.28 7.28 0 0 1-.53-6.09c2.35-1.93 5.56-2.14 7.91 1.07"
              />
              <path
                id="Bolivia_svg__path5983-6"
                d="M643.92 354.41a2.81 2.81 0 0 0-2.35.86 2.65 2.65 0 0 1-1.07.53c-.11.11 0 .43.21.33a6.7 6.7 0 0 0 1.29-.86 2.64 2.64 0 0 1 1.92-.54c1.93 0 3 1.61 3.21 1.5s-1.07-1.82-3.21-1.82"
              />
              <path
                id="Bolivia_svg__path5985-3"
                d="M646.38 356.23c-1.39-1.5-4-1.6-5 .11h.43c1.07-1.71 3.64-1 3.85-.21v.21"
              />
              <circle
                id="Bolivia_svg__circle5987-9"
                cx={643.71}
                cy={356.13}
                r={0.96}
              />
              <path
                id="Bolivia_svg__path5989-6"
                d="M641.35 356.34a4.34 4.34 0 0 0 5-.11l-.75-.1a2.83 2.83 0 0 1-3.85.21v-.21"
              />
              <path
                id="Bolivia_svg__path5991-4"
                d="M646.49 356.77a4.22 4.22 0 0 1-4.71.64c-1.07-.64-1.07-.86-.85-.86s.42.22 1.28.64 2.14.43 4.28-.42"
              />
              <path
                id="Bolivia_svg__path5993-8"
                d="M641.25 360a.63.63 0 0 1 .41.73.65.65 0 0 1-.68.51.64.64 0 0 1-.59-.6 1.58 1.58 0 0 1-1.39.85h-.21l.21.32a2.23 2.23 0 0 0 1.28-.32 1 1 0 0 0 1.75-.63 1 1 0 0 0-.78-.86"
              />
              <path
                id="Bolivia_svg__path5995-5"
                d="M642.53 364.47c-1-.64-1.39-1.61-2.46-1.61a2.9 2.9 0 0 0-1.07.32h-.21l.21.33c.43 0 1.07-.54 1.82-.11s1.18.85 1.71 1.07"
              />
              <path
                id="Bolivia_svg__path5997-4"
                d="M642.21 364.47a5.74 5.74 0 0 0-3.21-.22h-.21l.21.43c.86 0 1.28-.64 3.21-.21"
              />
              <path
                id="Bolivia_svg__path5999-5"
                d="M642.53 364.47c-2.35-.22-1.6 1.17-3.53 1.17h-.21l.21.33c2.35 0 1.28-1.29 3.53-1.5"
              />
            </g>
            <g id="Bolivia_svg__g6001-5">
              <path
                id="Bolivia_svg__path6003-0"
                d="M630.23 355.06c2.46-2.14 5.56-2.46 7.27-.86 1.24 1.66 1.13 3.62-.32 5.67a.86.86 0 0 1 .43.21 7.28 7.28 0 0 0 .53-6.09c-2.35-1.93-5.56-2.14-7.91 1.07"
              />
              <path
                id="Bolivia_svg__path6005-0"
                d="M634.08 354.41a2.81 2.81 0 0 1 2.35.86 2.7 2.7 0 0 0 1.07.53c.11.11 0 .43-.21.33a6.7 6.7 0 0 1-1.29-.86 2.64 2.64 0 0 0-1.92-.54c-1.93 0-3 1.61-3.21 1.5s1.07-1.82 3.21-1.82"
              />
              <path
                id="Bolivia_svg__path6007-8"
                d="M631.62 356.23c1.39-1.5 4-1.6 5 .11h-.43c-1.07-1.71-3.64-1-3.85-.21v.21"
              />
              <circle
                id="Bolivia_svg__circle6009-7"
                cx={634.29}
                cy={356.13}
                r={0.96}
              />
              <path
                id="Bolivia_svg__path6011-4"
                d="M636.65 356.34a4.34 4.34 0 0 1-5-.11l.75-.1a2.83 2.83 0 0 0 3.85.21v-.21"
              />
              <path
                id="Bolivia_svg__path6013-4"
                d="M631.51 356.77a4.22 4.22 0 0 0 4.71.64c1.07-.64 1.07-.86.85-.86s-.42.22-1.28.64-2.14.43-4.28-.42"
              />
              <path
                id="Bolivia_svg__path6015-4"
                d="M636.75 360a.63.63 0 0 0-.41.73.65.65 0 0 0 .68.51.64.64 0 0 0 .59-.6 1.58 1.58 0 0 0 1.39.85h.21l-.21.32a2.23 2.23 0 0 1-1.28-.32 1 1 0 0 1-1.75-.63 1 1 0 0 1 .78-.86"
              />
              <path
                id="Bolivia_svg__path6017-8"
                d="M635.47 364.47c1-.64 1.39-1.61 2.46-1.61a2.9 2.9 0 0 1 1.07.32h.21l-.21.33c-.43 0-1.07-.54-1.82-.11s-1.18.85-1.71 1.07"
              />
              <path
                id="Bolivia_svg__path6019-3"
                d="M635.79 364.47a5.74 5.74 0 0 1 3.21-.22h.21l-.21.43c-.86 0-1.28-.64-3.21-.21"
              />
              <path
                id="Bolivia_svg__path6021-3"
                d="M635.47 364.47c2.35-.22 1.6 1.17 3.53 1.17h.21l-.21.36c-2.35 0-1.28-1.29-3.53-1.5"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Bolivia_svg__g3889-3-4">
        <path
          id="Bolivia_svg__path430-1-0"
          d="M643.83 387.63a17.1 17.1 0 0 0 7.09-.45 14.8 14.8 0 0 1 6.3-.93c0-.3.64-.51.28-.75-.78-.48-1.77-.43-2.74-.93-1.59-.73-2.52-2-4.1-2.88-.18-.07-.88-.48-.86-.87 3.33 4.8 11.2 2.35 17.93 1.82a10.3 10.3 0 0 0 3.6-.71c1.64-.56 5.56-.12 6.57-.78.16-.06-1.66-1.19-2-1.51-.94-1.18-3.37-1-4.58-2.29-1.89-2.13-4.82-2.76-7.2-4.52a10.7 10.7 0 0 0-2.4-.4c-1-.83 0-.8-7.49-7-6.76-2.78-6.36-4.89-10.56-6.51-1.49-.73-2.85-2-4.11-1.7a55 55 0 0 0-9.35 4.41 58 58 0 0 0-5.67 4.28 74 74 0 0 1-10.54 7.36c-5.39 3-13.2 7-13.87 7.07 12.17-.6-10.88 3.46 43.74 7.29Z"
          style={{
            fill: "#007934",
            stroke: "#000",
            strokeWidth: ".5px",
            strokeLinecap: "round",
          }}
        />
        <path
          id="Bolivia_svg__path436-3-9"
          d="M614 373.61c3.08-1.67 14.87-8.13 18.53-12.67-.5 0 1 1.41.87 2 1.15 0 .56-1.28 1.51-1.33a4.7 4.7 0 0 0 1.9-.5c.74-.13.3.33.29.58-1 1.83-3.12 2.89-4.85 4.29.2.17.4.33.29.58a2.33 2.33 0 0 0 1.78-.26c.1-.08.11-.33.12-.48.61.25.38.73.17 1-.45 1-2.22.81-2.78 1.69a9.3 9.3 0 0 1-2.27 2.43 5 5 0 0 1 2.56-1.45c1.46-.11 2-1.06 3.29-1.34s2.24-1.38 3.32-2.24c-.44.63-1.3 1.17-1 1.91a.85.85 0 0 0 .85.17c-1 1.27-2.92 2.18-3.6 3.7-.62-.26-1 .2-1.47.27-.62.21-.45 1.19-.88 1.51a9.25 9.25 0 0 0-3.49 4.09 8.2 8.2 0 0 1-2 1.06c-1 .38-6.89 5-7 4.32-.51-3.09-6.52 2.49-19.93-2.32"
          className="Bolivia_svg__cls-11"
        />
        <path
          id="Bolivia_svg__path3090-0-9"
          d="M646 380.51c-.1-.13-.3-.19-.3-.25.22-.47-.71-.57-.7-1.05 1.57.05 2.76 1.84 3.75.78.21-.24-.39-.61.54-.89.21 0-.2-.24-.09-.36a4.1 4.1 0 0 1-1.25-.1c-.41-.13-.62-.25-1.13-.4s-.71-.68 0-.84c1.36-.2 2.79.75 3.86.25a19 19 0 0 1 2.53-.76c.41-.11 1.78 0 1.34.4-.31.23-1 .14-1.47.24-.74.22-1.38.56-2.12.84.52 0 .4.55 1 .4a15.3 15.3 0 0 1 3-.69c-.1-.24.21-.42.22-.66h.31c-.49-.74 1-.39 1.49-1 0 .12.09.13.2.19-.74.27-.43.76-.65 1.13-.11.11-.42.16-.32.35.4.31.42-.22.73-.09a2.9 2.9 0 0 0 .94.14c.51 0 1-.2.73-.64s-.81-.68-.79-1.17q0-.09-.3-.18a2.35 2.35 0 0 1 1.75.65c.39.38.48.93 1.11 1.07 1.24.22 1.16-.38 1.18-1 .93.09 2.28.5 2.06 1s-.86.64-1.59.68c-.51 0-.22.41-.53.46a2.64 2.64 0 0 0-1.57.31 1.21 1.21 0 0 0 .46 1.35c.61.31 1.88-.06 2.82.09.11-.54.76-.69 1.29-1s-.28-.67-.8-.93-.09-.24.12-.54 1.26 0 1.37-.31-.17-.91.24-1.14.73.21.6.51c.41 0 .53-.28 1-.33s.82.38.6.5c-.63.4-1.17.68-1 1.3 0 .3-.74.4-.43.65.6.44.58.87.79 1.35s1.33.71 2.38.51c-.38-1 2-.54 3.06-.81.09 0 .1-.17 0-.23-.5-.32-.6-.44-.48-.86 0-.06-.19-.19-.3-.25 1.54.53 4.29 1.26 5.41 2.21-1.47.24-4.22-.42-5.69-.11a21 21 0 0 1-5.48.9c-.83 0-1.65-.41-2.48-.44m-16.83-1c.2.06-.51-.08-.61-.14"
          className="Bolivia_svg__cls-11"
        />
        <path
          id="Bolivia_svg__path1871-3-7"
          d="M640.76 388.72c2.91-.17 3.36 2.09 5.27.12 1.74.31 3.35-.27 3.38-.52 4.06.85 16.66-.32 15.83-1.21-1.3-1.48-3.41-2-5.08-3.32a8.6 8.6 0 0 0-1.72-.52c-1-.29-2.22-.07-3-.5a28.5 28.5 0 0 1-3.85-2.29c-.73-.52-1-1.35-1.79-2a14.4 14.4 0 0 0-3-1.14c-1.33-.54-2.06-1.82-3.29-2.75-.43-.34-1.15-.31-1.65-.61-1.06-.55-1.87-1.75-2.8-1.58-1.67.28-2.66 1.65-4.31 2.39-1.37.62-2 1.77-3.2 2.51a53 53 0 0 1-8 4.28c-4 1.67-9.36 3.7-9.85 3.7 0 0 3.57 2.63 11.9 2.28l5.09 1.64 2.84-.5h7.22Z"
          className="Bolivia_svg__cls-11"
        />
        <path
          id="Bolivia_svg__path3088-3-3"
          d="M623.64 382.25c1.87-.89 9-4.35 11.24-6.78-.31 0 .61.75.54 1 .69 0 .33-.68.91-.71a3.3 3.3 0 0 0 1.15-.27c.45-.07.19.17.18.31-.6 1-1.89 1.55-2.93 2.3.12.08.24.17.18.3a1.55 1.55 0 0 0 1.08-.14c.06 0 .07-.17.07-.25.38.13.24.39.11.56-.27.51-1.35.44-1.68.9a5.2 5.2 0 0 1-1.38 1.31 3.13 3.13 0 0 1 1.56-.78c.89-.06 1.22-.57 2-.72a5.2 5.2 0 0 0 2-1.2c-.26.34-.79.62-.6 1a.64.64 0 0 0 .56.19c-.59.68-1.81 1.07-2.22 1.88-.38-.14-.63.11-.89.15s-.27.64-.53.8a5.17 5.17 0 0 0-2.11 2.19 4.7 4.7 0 0 1-1.22.57c-.58.21-4.18 2.67-4.23 2.32-.33-1.65-3.83.79-12-1.78"
          className="Bolivia_svg__cls-11"
        />
      </g>
      <path
        id="Bolivia_svg__path4014-9"
        d="M639 321.23c-27.19 0-49.23 24.8-49.23 55.39S611.81 432 639 432s49.23-24.8 49.23-55.38-22.04-55.39-49.23-55.39Zm0 12.37c19.82 0 37 18.43 37 43s-17.17 43-37 43-37-18.43-37-43 17.18-43 37-43Z"
        style={{
          stroke: "#000",
          strokeWidth: ".5px",
          fill: "#00a6de",
        }}
      />
      <g id="Bolivia_svg___1-5-2-8" data-name="1-5-2-8">
        <path
          id="Bolivia_svg___2-8-89-4"
          d="M646.09 400.19c0 .3-.11.31-.67.39s-.66.07-.67-.21.12-.32.67-.39.66-.11.67.21Z"
          className="Bolivia_svg__cls-29"
          data-name="2-8-89-4"
        />
        <path
          id="Bolivia_svg___3-1-8-1"
          d="M646.21 400.17c0 .19-.36.24-.79.29s-.78.1-.79-.08.35-.23.79-.29.78-.09.79.08Z"
          className="Bolivia_svg__cls-29"
          data-name="3-1-8-1"
        />
        <path
          id="Bolivia_svg___4-2-9-6"
          d="M642 413.64c1.2-3.19 1.51-5.6-.2-9 2.84-2.71 4.92-1.77 6.8.15-1.79 3.38-1.32 5.79-.3 8.9a6.09 6.09 0 0 1-6.3-.05Z"
          className="Bolivia_svg__cls-29"
          data-name="4-2-9-6"
        />
        <path
          id="Bolivia_svg___5-5-9-9"
          d="M645.1 402.94h-.18c.2 3.88 0 7.73 0 11.59h.23c0-3.88.21-7.63 0-11.59Z"
          className="Bolivia_svg__cls-29"
          data-name="5-5-9-9"
        />
        <path
          id="Bolivia_svg___6-7-9-8"
          d="M645.63 403a67 67 0 0 0-.56 11.55h.2a90 90 0 0 1 .56-11.52Z"
          className="Bolivia_svg__cls-29"
          data-name="6-7-9-8"
        />
        <path
          id="Bolivia_svg___7-4-4-4"
          d="M646.59 399.28c-.5.56-.78.55-.52 1.41.55-.38.54-.69.52-1.41Z"
          className="Bolivia_svg__cls-29"
          data-name="7-4-4-4"
        />
        <path
          id="Bolivia_svg___8-4-2-0"
          d="M645.48 399.65c.33.35.81.53.5 1.46-.6-.52-.52-.57-.5-1.46Z"
          className="Bolivia_svg__cls-29"
          data-name="8-4-2-0"
        />
        <path
          id="Bolivia_svg___9-4-0-4"
          d="M645.37 400.61c.44.31.84.38.54 1.19-.38-.45-.55-.41-.54-1.19Z"
          className="Bolivia_svg__cls-29"
          data-name="9-4-0-4"
        />
        <path
          id="Bolivia_svg___10-4-8-2"
          d="M645.26 401.12c.33.34.81.51.5 1.43-.6-.55-.52-.55-.5-1.43Z"
          className="Bolivia_svg__cls-29"
          data-name="10-4-8-2"
        />
        <path
          id="Bolivia_svg___11-4-7-9"
          d="M645.06 401.86c.39.33 1 .51.61 1.39-.67-.56-.34-.69-.61-1.39Z"
          className="Bolivia_svg__cls-29"
          data-name="11-4-7-9"
        />
        <path
          id="Bolivia_svg___12-2-8-5"
          d="M645 402.61c.36.32.93.51.61 1.36-.53-.47-.61-.54-.61-1.36Z"
          className="Bolivia_svg__cls-29"
          data-name="12-2-8-5"
        />
        <path
          id="Bolivia_svg___13-9-7-8"
          d="M646.93 400.06c-.26.22-.87.2-.89 1.13.74-.43.73-.34.89-1.13Z"
          className="Bolivia_svg__cls-29"
          data-name="13-9-7-8"
        />
        <path
          id="Bolivia_svg___14-3-3-4"
          d="M646.89 400.73c-.28.2-.93.17-.95 1 .8-.35.79-.27.95-1Z"
          className="Bolivia_svg__cls-29"
          data-name="14-3-3-4"
        />
        <path
          id="Bolivia_svg___15-0-0-9"
          d="M646.79 401.33c-.29.22-1 .19-1 1.13.84-.46.84-.34 1-1.13Z"
          className="Bolivia_svg__cls-29"
          data-name="15-0-0-9"
        />
        <path
          id="Bolivia_svg___16-7-7-4"
          d="M646.74 402.15c-.3.12-1-.11-1 1.06.59-.16.55-.52 1-1.06Z"
          className="Bolivia_svg__cls-29"
          data-name="16-7-7-4"
        />
        <path
          id="Bolivia_svg___17-7-6-4"
          d="M646.4 402.87c-.42.17-.66.14-.74 1.08.62-.42.61-.34.74-1.08Z"
          className="Bolivia_svg__cls-29"
          data-name="17-7-6-4"
        />
        <path
          id="Bolivia_svg___18-8-4-4"
          d="M646.87 403.42c-1.07 3.07-1.3 6-1.19 11.08h.26c-.05-5.06.14-7.86 1.12-10.94Z"
          className="Bolivia_svg__cls-29"
          data-name="18-8-4-4"
        />
        <path
          id="Bolivia_svg___19-7-2-7"
          d="M648.62 400c-.61.43-.88.37-.82 1.26.63-.21.68-.52.82-1.26Z"
          className="Bolivia_svg__cls-29"
          data-name="19-7-2-7"
        />
        <path
          id="Bolivia_svg___20-3-1-8"
          d="M647.44 400.16c.25.41.69.69.19 1.53-.48-.63-.39-.69-.19-1.53Z"
          className="Bolivia_svg__cls-29"
          data-name="20-3-1-8"
        />
        <path
          id="Bolivia_svg___21-0-9-3"
          d="M647.14 401.07c.36.4.74.55.27 1.28-.28-.53-.41-.52-.27-1.28Z"
          className="Bolivia_svg__cls-29"
          data-name="21-0-9-3"
        />
        <path
          id="Bolivia_svg___22-3-1-3"
          d="M646.92 401.54c.25.4.68.68.19 1.5-.48-.62-.4-.65-.19-1.5Z"
          className="Bolivia_svg__cls-29"
          data-name="22-3-1-3"
        />
        <path
          id="Bolivia_svg___23-8-6-1"
          d="M646.57 402.22c.31.41.82.7.29 1.49-.53-.71-.18-.71-.29-1.49Z"
          className="Bolivia_svg__cls-29"
          data-name="23-8-6-1"
        />
        <path
          id="Bolivia_svg___24-2-0-9"
          d="M646.34 402.93c.29.39.8.7.3 1.46a1.37 1.37 0 0 1-.3-1.46Z"
          className="Bolivia_svg__cls-29"
          data-name="24-2-0-9"
        />
        <path
          id="Bolivia_svg___25-5-3-1"
          d="M648.78 400.87c-.3.16-.89 0-1.12.91.83-.26.8-.18 1.12-.91Z"
          className="Bolivia_svg__cls-29"
          data-name="25-5-3-1"
        />
        <path
          id="Bolivia_svg___26-2-3-2"
          d="M648.6 401.51c-.32.13-1 0-1.15.82.86-.21.84-.14 1.15-.82Z"
          className="Bolivia_svg__cls-29"
          data-name="26-2-3-2"
        />
        <path
          id="Bolivia_svg___27-0-6-5"
          d="M648.38 402.07c-.33.15-1 0-1.21.9.9-.24.88-.16 1.21-.9Z"
          className="Bolivia_svg__cls-29"
          data-name="27-0-6-5"
        />
        <path
          id="Bolivia_svg___28-3-2-2"
          d="M648.15 402.86c-.32.05-1-.32-1.22.82.63-.03.66-.38 1.22-.82Z"
          className="Bolivia_svg__cls-29"
          data-name="28-3-2-2"
        />
        <path
          id="Bolivia_svg___29-7-2-7"
          d="M647.67 403.49c-.45.08-.68 0-1 .89.74-.27.71-.2 1-.89Z"
          className="Bolivia_svg__cls-29"
          data-name="29-7-2-7"
        />
        <path
          id="Bolivia_svg___30-2-1-8"
          d="M647.88 404.13c-1.4 2.79-1.69 5.35-1 10.12l.31-.1c-.69-4.56-.42-7.11.86-9.87Z"
          className="Bolivia_svg__cls-29"
          data-name="30-2-1-8"
        />
        <path
          id="Bolivia_svg___31-9-4-4"
          d="M650.2 400.79c-.67.35-.93.25-1 1.14.68-.16.8-.46 1-1.14Z"
          className="Bolivia_svg__cls-29"
          data-name="31-9-4-4"
        />
        <path
          id="Bolivia_svg___32-7-3-7"
          d="M649 400.76c.2.44.59.77 0 1.54-.39-.69-.3-.71 0-1.54Z"
          className="Bolivia_svg__cls-29"
          data-name="32-7-3-7"
        />
        <path
          id="Bolivia_svg___33-5-2-5"
          d="M648.6 401.62c.3.44.66.64.1 1.3-.21-.55-.38-.57-.1-1.3Z"
          className="Bolivia_svg__cls-29"
          data-name="33-5-2-5"
        />
        <path
          id="Bolivia_svg___34-3-6-8"
          d="M648.31 402.06c.2.43.6.76 0 1.51-.4-.68-.31-.7 0-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="34-3-6-8"
        />
        <path
          id="Bolivia_svg___35-4-0-4"
          d="M647.88 402.68c.25.45.72.8.1 1.51-.44-.75-.09-.76-.1-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="35-4-0-4"
        />
        <path
          id="Bolivia_svg___36-3-5-4"
          d="M647.56 403.36c.23.42.71.79.11 1.48a1.37 1.37 0 0 1-.11-1.48Z"
          className="Bolivia_svg__cls-29"
          data-name="36-3-5-4"
        />
        <path
          id="Bolivia_svg___37-2-4-8"
          d="M650.25 401.64c-.32.11-.89-.11-1.22.75.84-.15.81-.07 1.22-.75Z"
          className="Bolivia_svg__cls-29"
          data-name="37-2-4-8"
        />
        <path
          id="Bolivia_svg___38-1-96-0"
          d="M650 402.24c-.33.1-.94-.14-1.25.67.87-.1.84-.03 1.25-.67Z"
          className="Bolivia_svg__cls-29"
          data-name="38-1-96-0"
        />
        <path
          id="Bolivia_svg___39-1-0-4"
          d="M649.7 402.77c-.35.11-1-.14-1.32.73.93-.12.89-.04 1.32-.73Z"
          className="Bolivia_svg__cls-29"
          data-name="39-1-0-4"
        />
        <path
          id="Bolivia_svg___40-3-8-2"
          d="M649.37 403.53c-.32 0-.92-.45-1.32.64.63.06.71-.29 1.32-.64Z"
          className="Bolivia_svg__cls-29"
          data-name="40-3-8-2"
        />
        <path
          id="Bolivia_svg___41-2-2-2"
          d="M648.81 404.08c-.46 0-.68-.09-1.07.76.73-.18.69-.11 1.07-.76Z"
          className="Bolivia_svg__cls-29"
          data-name="41-2-2-2"
        />
        <path
          id="Bolivia_svg___42-5-7-3"
          d="m644.35 403-.2.05a77 77 0 0 1 .7 11.44h.15a61.3 61.3 0 0 0-.65-11.49Z"
          className="Bolivia_svg__cls-29"
          data-name="42-5-7-3"
        />
        <path
          id="Bolivia_svg___43-3-4-7"
          d="M643.38 399.21c.5.57.78.58.52 1.43-.56-.4-.54-.72-.52-1.43Z"
          className="Bolivia_svg__cls-29"
          data-name="43-3-4-7"
        />
        <path
          id="Bolivia_svg___44-5-0-2"
          d="M644.5 399.63c-.34.33-.82.49-.52 1.44.6-.49.53-.55.52-1.44Z"
          className="Bolivia_svg__cls-29"
          data-name="44-5-0-2"
        />
        <path
          id="Bolivia_svg___45-1-7-7"
          d="M644.59 400.59c-.44.29-.84.34-.55 1.17.39-.44.55-.39.55-1.17Z"
          className="Bolivia_svg__cls-29"
          data-name="45-1-7-7"
        />
        <path
          id="Bolivia_svg___46-2-6-8"
          d="M644.71 401.1c-.34.33-.82.48-.52 1.41.6-.51.53-.51.52-1.41Z"
          className="Bolivia_svg__cls-29"
          data-name="46-2-6-8"
        />
        <path
          id="Bolivia_svg___47-2-01-6"
          d="M644.89 401.85c-.39.32-.95.47-.61 1.37.72-.53.34-.68.61-1.37Z"
          className="Bolivia_svg__cls-29"
          data-name="47-2-01-6"
        />
        <path
          id="Bolivia_svg___48-2-2-3"
          d="M645 402.61c-.36.3-.93.47-.62 1.33.48-.45.55-.52.62-1.33Z"
          className="Bolivia_svg__cls-29"
          data-name="48-2-2-3"
        />
        <path
          id="Bolivia_svg___49-6-9-4"
          d="M643 400c.26.23.87.24.88 1.17-.7-.49-.69-.41-.88-1.17Z"
          className="Bolivia_svg__cls-29"
          data-name="49-6-9-4"
        />
        <path
          id="Bolivia_svg___50-4-3-5"
          d="M643.08 400.64c.27.21.92.22.93 1.09-.79-.42-.78-.35-.93-1.09Z"
          className="Bolivia_svg__cls-29"
          data-name="50-4-3-5"
        />
        <path
          id="Bolivia_svg___51-0-8-1"
          d="M643.17 401.24c.28.24 1 .24 1 1.19-.85-.43-.84-.43-1-1.19Z"
          className="Bolivia_svg__cls-29"
          data-name="51-0-8-1"
        />
        <path
          id="Bolivia_svg___52-7-5-8"
          d="M643.21 402.07c.3.13 1-.06 1 1.11-.59-.18-.55-.55-1-1.11Z"
          className="Bolivia_svg__cls-29"
          data-name="52-7-5-8"
        />
        <path
          id="Bolivia_svg___53-0-1-9"
          d="M643.54 402.8c.43.2.66.17.74 1.12-.62-.44-.61-.37-.74-1.12Z"
          className="Bolivia_svg__cls-29"
          data-name="53-0-1-9"
        />
        <path
          id="Bolivia_svg___54-3-5-5"
          d="M643.17 403.53a1 1 0 0 0-.19.11c1 3.05 1.35 5.87 1.27 10.82h.23c.14-4.97-.24-7.88-1.31-10.93Z"
          className="Bolivia_svg__cls-29"
          data-name="54-3-5-5"
        />
        <path
          id="Bolivia_svg___55-4-6-9"
          d="M641.35 399.87c.61.46.88.41.81 1.3-.63-.28-.68-.59-.81-1.3Z"
          className="Bolivia_svg__cls-29"
          data-name="55-4-6-9"
        />
        <path
          id="Bolivia_svg___56-0-6-2"
          d="M642.53 400.05c-.26.4-.69.65-.2 1.52.48-.57.4-.65.2-1.52Z"
          className="Bolivia_svg__cls-29"
          data-name="56-0-6-2"
        />
        <path
          id="Bolivia_svg___57-0-8-7"
          d="M642.82 401c-.36.38-.74.52-.28 1.27.28-.54.46-.53.28-1.27Z"
          className="Bolivia_svg__cls-29"
          data-name="57-0-8-7"
        />
        <path
          id="Bolivia_svg___58-5-8-5"
          d="M643 401.45c-.25.39-.69.65-.2 1.49.52-.6.44-.63.2-1.49Z"
          className="Bolivia_svg__cls-29"
          data-name="58-5-8-5"
        />
        <path
          id="Bolivia_svg___59-3-9-5"
          d="M643.38 402.15c-.31.39-.82.66-.3 1.47.54-.62.19-.74.3-1.47Z"
          className="Bolivia_svg__cls-29"
          data-name="59-3-9-5"
        />
        <path
          id="Bolivia_svg___60-1-8-6"
          d="M643.61 402.87c-.29.38-.81.66-.32 1.45a1.35 1.35 0 0 0 .32-1.45Z"
          className="Bolivia_svg__cls-29"
          data-name="60-1-8-6"
        />
        <path
          id="Bolivia_svg___61-0-7-5"
          d="M641.18 400.7c.31.17.9.05 1.11 1-.82-.34-.79-.26-1.11-1Z"
          className="Bolivia_svg__cls-29"
          data-name="61-0-7-5"
        />
        <path
          id="Bolivia_svg___62-6-0-1"
          d="M641.36 401.34c.32.15.95 0 1.14.88-.86-.22-.83-.22-1.14-.88Z"
          className="Bolivia_svg__cls-29"
          data-name="62-6-0-1"
        />
        <path
          id="Bolivia_svg___63-7-7-4"
          d="M641.57 401.92c.33.16 1 0 1.2.95-.89-.28-.87-.2-1.2-.95Z"
          className="Bolivia_svg__cls-29"
          data-name="63-7-7-4"
        />
        <path
          id="Bolivia_svg___64-5-9-0"
          d="M641.79 402.72c.33.06 1-.28 1.22.87-.63-.06-.66-.41-1.22-.87Z"
          className="Bolivia_svg__cls-29"
          data-name="64-5-9-0"
        />
        <path
          id="Bolivia_svg___65-0-1-9"
          d="M642.27 403.36c.45.11.68 0 1 .94-.74-.3-.71-.22-1-.94Z"
          className="Bolivia_svg__cls-29"
          data-name="65-0-1-9"
        />
        <path
          id="Bolivia_svg___66-0-5-0"
          d="m642.18 404.24-.16.14c1.26 2.83 1.47 5.25 1.06 9.76l.2.07c.52-4.54.29-7.02-1.1-9.97Z"
          className="Bolivia_svg__cls-29"
          data-name="66-0-5-0"
        />
        <path
          id="Bolivia_svg___67-4-8-5"
          d="M639.77 400.56c.66.37.92.29 1 1.18-.69-.2-.77-.5-1-1.18Z"
          className="Bolivia_svg__cls-29"
          data-name="67-4-8-5"
        />
        <path
          id="Bolivia_svg___68-5-6-7"
          d="M641 400.58c-.2.43-.6.74 0 1.54.35-.67.26-.7 0-1.54Z"
          className="Bolivia_svg__cls-29"
          data-name="68-5-6-7"
        />
        <path
          id="Bolivia_svg___69-4-3-0"
          d="M641.36 401.46c-.31.42-.67.61-.11 1.29.21-.54.38-.55.11-1.29Z"
          className="Bolivia_svg__cls-29"
          data-name="69-4-3-0"
        />
        <path
          id="Bolivia_svg___70-9-94-1"
          d="M641.64 401.91c-.2.42-.6.73 0 1.51.36-.66.36-.69 0-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="70-9-94-1"
        />
        <path
          id="Bolivia_svg___71-5-5-9"
          d="M642.07 402.55c-.26.43-.73.77-.11 1.51.45-.73.09-.76.11-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="71-5-5-9"
        />
        <path
          id="Bolivia_svg___72-6-3-4"
          d="M642.39 403.24c-.24.42-.72.76-.13 1.48a1.36 1.36 0 0 0 .13-1.48Z"
          className="Bolivia_svg__cls-29"
          data-name="72-6-3-4"
        />
        <path
          id="Bolivia_svg___73-4-8-5"
          d="M639.71 401.4c.32.13.89-.07 1.22.81-.85-.21-.82-.11-1.22-.81Z"
          className="Bolivia_svg__cls-29"
          data-name="73-4-8-5"
        />
        <path
          id="Bolivia_svg___74-8-2-8"
          d="M640 402c.34.1.94-.11 1.25.72-.93-.12-.89-.05-1.25-.72Z"
          className="Bolivia_svg__cls-29"
          data-name="74-8-2-8"
        />
        <path
          id="Bolivia_svg___75-2-39-7"
          d="M640.25 402.56c.35.12 1-.1 1.31.79-.92-.16-.89-.09-1.31-.79Z"
          className="Bolivia_svg__cls-29"
          data-name="75-2-39-7"
        />
        <path
          id="Bolivia_svg___76-1-4-4"
          d="M640.57 403.33c.33 0 .93-.41 1.32.71-.63.02-.71-.33-1.32-.71Z"
          className="Bolivia_svg__cls-29"
          data-name="76-1-4-4"
        />
        <path
          id="Bolivia_svg___77-6-85-7"
          d="M641.13 403.91c.46 0 .67-.06 1.06.81-.72-.21-.69-.14-1.06-.81Z"
          className="Bolivia_svg__cls-29"
          data-name="77-6-85-7"
        />
        <path
          id="Bolivia_svg___78-8-1-5"
          d="M644.4 399.15c.46.6.74.63.43 1.46-.53-.44-.49-.75-.43-1.46Z"
          className="Bolivia_svg__cls-29"
          data-name="78-8-1-5"
        />
        <path
          id="Bolivia_svg___79-3-3-8"
          d="M645.49 399.63c-.35.31-.84.44-.6 1.41.63-.46.56-.52.6-1.41Z"
          className="Bolivia_svg__cls-29"
          data-name="79-3-3-8"
        />
        <path
          id="Bolivia_svg___80-1-2-3"
          d="M645.53 400.59c-.46.27-.86.3-.61 1.14.41-.41.57-.36.61-1.14Z"
          className="Bolivia_svg__cls-29"
          data-name="80-1-2-3"
        />
        <path
          id="Bolivia_svg___81-4-8-1"
          d="M645.61 401.11c-.35.31-.84.44-.59 1.38.63-.49.56-.49.59-1.38Z"
          className="Bolivia_svg__cls-29"
          data-name="81-4-8-1"
        />
        <path
          id="Bolivia_svg___82-8-1-1"
          d="M645.76 401.87c-.41.3-1 .42-.69 1.33.7-.49.38-.66.69-1.33Z"
          className="Bolivia_svg__cls-29"
          data-name="82-8-1-1"
        />
        <path
          id="Bolivia_svg___83-4-6-1"
          d="M645.79 402.63c-.38.28-1 .41-.7 1.3.55-.42.62-.49.7-1.3Z"
          className="Bolivia_svg__cls-29"
          data-name="83-4-6-1"
        />
        <path
          id="Bolivia_svg___84-9-4-2"
          d="M644 399.89c.25.25.86.29.82 1.22-.7-.5-.7-.42-.82-1.22Z"
          className="Bolivia_svg__cls-29"
          data-name="84-9-4-2"
        />
        <path
          id="Bolivia_svg___85-2-6-8"
          d="M644 400.56c.27.23.91.27.88 1.14-.76-.47-.75-.39-.88-1.14Z"
          className="Bolivia_svg__cls-29"
          data-name="85-2-6-8"
        />
        <path
          id="Bolivia_svg___86-0-77-3"
          d="M644.07 401.17c.27.24.94.29.91 1.23-.8-.51-.79-.4-.91-1.23Z"
          className="Bolivia_svg__cls-29"
          data-name="86-0-77-3"
        />
        <path
          id="Bolivia_svg___87-7-9-4"
          d="M644.07 402c.29.14 1 0 .95 1.16-.6-.23-.53-.58-.95-1.16Z"
          className="Bolivia_svg__cls-29"
          data-name="87-7-9-4"
        />
        <path
          id="Bolivia_svg___88-0-6-5"
          d="M644.36 402.74c.41.22.65.21.67 1.16-.59-.48-.58-.4-.67-1.16Z"
          className="Bolivia_svg__cls-29"
          data-name="88-0-6-5"
        />
        <path
          id="Bolivia_svg___89-6-4-0"
          d="m643.8 403.21-.21.09a42 42 0 0 1 1 11.21h.18a38.8 38.8 0 0 0-.97-11.3Z"
          className="Bolivia_svg__cls-29"
          data-name="89-6-4-0"
        />
        <path
          id="Bolivia_svg___90-0-1-9"
          d="M642.3 399.63c.58.5.85.46.72 1.34-.61-.32-.63-.63-.72-1.34Z"
          className="Bolivia_svg__cls-29"
          data-name="90-0-1-9"
        />
        <path
          id="Bolivia_svg___91-7-9-2"
          d="M643.46 399.88c-.28.38-.73.61-.3 1.51.53-.58.44-.63.3-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="91-7-9-2"
        />
        <path
          id="Bolivia_svg___92-0-2-5"
          d="M643.7 400.82c-.39.36-.78.47-.37 1.24.32-.49.49-.47.37-1.24Z"
          className="Bolivia_svg__cls-29"
          data-name="92-0-2-5"
        />
        <path
          id="Bolivia_svg___93-5-6-1"
          d="M643.89 401.31c-.28.37-.73.6-.3 1.48.52-.57.41-.61.3-1.48Z"
          className="Bolivia_svg__cls-29"
          data-name="93-5-6-1"
        />
        <path
          id="Bolivia_svg___94-6-3-8"
          d="M644.18 402c-.33.37-.86.6-.4 1.44.59-.59.22-.69.4-1.44Z"
          className="Bolivia_svg__cls-29"
          data-name="94-6-3-8"
        />
        <path
          id="Bolivia_svg___95-7-1-8"
          d="M644.36 402.76c-.31.36-.85.61-.41 1.42.45-.52.5-.6.41-1.42Z"
          className="Bolivia_svg__cls-29"
          data-name="95-7-1-8"
        />
        <path
          id="Bolivia_svg___96-3-5-0"
          d="M642.08 400.44c.29.19.89.11 1 1-.76-.32-.74-.24-1-1Z"
          className="Bolivia_svg__cls-29"
          data-name="96-3-5-0"
        />
        <path
          id="Bolivia_svg___97-8-9-0"
          d="M642.21 401.09c.31.18.95.08 1.09 1-.85-.36-.83-.28-1.09-1Z"
          className="Bolivia_svg__cls-29"
          data-name="97-8-9-0"
        />
        <path
          id="Bolivia_svg___98-4-7-3"
          d="M642.39 401.68c.32.19 1 .09 1.14 1-.88-.31-.86-.23-1.14-1Z"
          className="Bolivia_svg__cls-29"
          data-name="98-4-7-3"
        />
        <path
          id="Bolivia_svg___99-9-0-0"
          d="M642.56 402.49c.32.08 1-.21 1.16.95-.63-.1-.63-.44-1.16-.95Z"
          className="Bolivia_svg__cls-29"
          data-name="99-9-0-0"
        />
        <path
          id="Bolivia_svg___100-2-2-0"
          d="M643 403.17c.45.13.68.07.89 1-.68-.35-.66-.28-.89-1Z"
          className="Bolivia_svg__cls-29"
          data-name="100-2-2-0"
        />
        <path
          id="Bolivia_svg___101-6-6-4"
          d="m641.84 404.54-.08.08a9.4 9.4 0 0 1 1.13 5.53 21 21 0 0 1-.5 3.71l.22.1c.86-3.84.78-6.68-.77-9.42Z"
          className="Bolivia_svg__cls-29"
          data-name="101-6-6-4"
        />
        <path
          id="Bolivia_svg___102-5-1-9"
          d="m642.72 403.82-.19.14c1.19 3.18 1.35 6.11 1.18 10.39h.23c.22-4.3.06-7.35-1.22-10.53Z"
          className="Bolivia_svg__cls-29"
          data-name="102-5-1-9"
        />
        <path
          id="Bolivia_svg___103-7-7-6"
          d="M640.57 400.21c.65.41.91.33.92 1.23-.65-.23-.72-.54-.92-1.23Z"
          className="Bolivia_svg__cls-29"
          data-name="103-7-7-6"
        />
        <path
          id="Bolivia_svg___104-7-6-1"
          d="M641.76 400.29c-.22.41-.63.71-.07 1.53.43-.65.31-.68.07-1.53Z"
          className="Bolivia_svg__cls-29"
          data-name="104-7-6-1"
        />
        <path
          id="Bolivia_svg___105-4-2-8"
          d="M642.13 401.18c-.33.41-.69.58-.17 1.29.24-.54.4-.54.17-1.29Z"
          className="Bolivia_svg__cls-29"
          data-name="105-4-2-8"
        />
        <path
          id="Bolivia_svg___106-5-53-3"
          d="M642.39 401.64c-.22.41-.63.71-.07 1.51.43-.64.34-.67.07-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="106-5-53-3"
        />
        <path
          id="Bolivia_svg___107-7-4-8"
          d="M642.79 402.31c-.27.42-.76.73-.18 1.49.48-.71.13-.75.18-1.49Z"
          className="Bolivia_svg__cls-29"
          data-name="107-7-4-8"
        />
        <path
          id="Bolivia_svg___108-9-0-7"
          d="M643.08 403c-.26.4-.75.73-.19 1.47a1.36 1.36 0 0 0 .19-1.47Z"
          className="Bolivia_svg__cls-29"
          data-name="108-9-0-7"
        />
        <path
          id="Bolivia_svg___109-8-7-9"
          d="M640.48 401.05c.31.14.89 0 1.18.86-.84-.22-.81-.15-1.18-.86Z"
          className="Bolivia_svg__cls-29"
          data-name="109-8-7-9"
        />
        <path
          id="Bolivia_svg___110-3-5-6"
          d="M640.71 401.68c.32.12.94-.07 1.21.77-.92-.18-.85-.11-1.21-.77Z"
          className="Bolivia_svg__cls-29"
          data-name="110-3-5-6"
        />
        <path
          id="Bolivia_svg___111-0-5-0"
          d="M641 402.23c.34.14 1-.05 1.28.85-.95-.2-.92-.08-1.28-.85Z"
          className="Bolivia_svg__cls-29"
          data-name="111-0-5-0"
        />
        <path
          id="Bolivia_svg___112-2-3-0"
          d="M641.26 403c.32 0 .94-.37 1.29.76-.64.01-.7-.34-1.29-.76Z"
          className="Bolivia_svg__cls-29"
          data-name="112-2-3-0"
        />
        <path
          id="Bolivia_svg___113-2-18-9"
          d="M641.79 403.62c.46.06.68 0 1 .85-.69-.24-.66-.17-1-.85Z"
          className="Bolivia_svg__cls-29"
          data-name="113-2-18-9"
        />
        <path
          id="Bolivia_svg___114-3-8-4"
          d="M638.94 401.16c.7.29.95.17 1.11 1-.68-.06-.8-.35-1.11-1Z"
          className="Bolivia_svg__cls-29"
          data-name="114-3-8-4"
        />
        <path
          id="Bolivia_svg___115-6-8-4"
          d="M640.11 401c-.14.46-.49.82.2 1.53.31-.69.22-.71-.2-1.53Z"
          className="Bolivia_svg__cls-29"
          data-name="115-6-8-4"
        />
        <path
          id="Bolivia_svg___116-7-0-8"
          d="M640.63 401.84c-.25.47-.58.7.06 1.31.14-.57.31-.61-.06-1.31Z"
          className="Bolivia_svg__cls-29"
          data-name="116-7-0-8"
        />
        <path
          id="Bolivia_svg___117-1-17-9"
          d="M641 402.25c-.15.45-.5.81.18 1.51.29-.71.19-.76-.18-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="117-1-17-9"
        />
        <path
          id="Bolivia_svg___118-5-5-8"
          d="M641.48 402.84c-.2.47-.63.86.08 1.51.35-.78-.01-.76-.08-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="118-5-5-8"
        />
        <path
          id="Bolivia_svg___119-5-0-5"
          d="M641.88 403.49c-.18.44-.61.85.06 1.48a1.35 1.35 0 0 0-.06-1.48Z"
          className="Bolivia_svg__cls-29"
          data-name="119-5-0-5"
        />
        <path
          id="Bolivia_svg___120-4-5-9"
          d="M639 402c.33.09.87-.18 1.31.65-.88-.08-.83-.01-1.31-.65Z"
          className="Bolivia_svg__cls-29"
          data-name="120-4-5-9"
        />
        <path
          id="Bolivia_svg___121-0-90-0"
          d="M639.32 402.58c.34.07.92-.23 1.33.56-.9-.03-.85.04-1.33-.56Z"
          className="Bolivia_svg__cls-29"
          data-name="121-0-90-0"
        />
        <path
          id="Bolivia_svg___122-2-9-9"
          d="M639.68 403.08c.36.08 1-.22 1.39.62-.93-.04-.89.03-1.39-.62Z"
          className="Bolivia_svg__cls-29"
          data-name="122-2-9-9"
        />
        <path
          id="Bolivia_svg___123-6-3-6"
          d="M640.09 403.81c.33 0 .87-.52 1.4.53-.62.11-.74-.23-1.4-.53Z"
          className="Bolivia_svg__cls-29"
          data-name="123-6-3-6"
        />
        <path
          id="Bolivia_svg___124-0-5-1"
          d="M640.72 404.31c.46 0 .66-.15 1.15.67-.74-.12-.7-.05-1.15-.67Z"
          className="Bolivia_svg__cls-29"
          data-name="124-0-5-1"
        />
        <path
          id="Bolivia_svg___125-6-42-7"
          d="M646.4 403.19a38.8 38.8 0 0 0-1.06 11.34h.24a41.7 41.7 0 0 1 1-11.22Z"
          className="Bolivia_svg__cls-29"
          data-name="125-6-42-7"
        />
        <path
          id="Bolivia_svg___126-1-7-4"
          d="M647.9 399.76c-.59.47-.86.42-.74 1.31.61-.29.64-.61.74-1.31Z"
          className="Bolivia_svg__cls-29"
          data-name="126-1-7-4"
        />
        <path
          id="Bolivia_svg___127-1-2-3"
          d="M646.73 400c.28.4.73.64.28 1.52-.51-.65-.43-.69-.28-1.52Z"
          className="Bolivia_svg__cls-29"
          data-name="127-1-2-3"
        />
        <path
          id="Bolivia_svg___128-1-6-9"
          d="M646.49 400.88c.38.38.77.5.35 1.26-.31-.51-.48-.49-.35-1.26Z"
          className="Bolivia_svg__cls-29"
          data-name="128-1-6-9"
        />
        <path
          id="Bolivia_svg___129-7-7-9"
          d="M646.29 401.37c.28.38.73.63.29 1.48-.52-.59-.43-.63-.29-1.48Z"
          className="Bolivia_svg__cls-29"
          data-name="129-7-7-9"
        />
        <path
          id="Bolivia_svg___130-3-2-3"
          d="M646 402.07c.33.38.86.64.39 1.46-.59-.65-.24-.73-.39-1.46Z"
          className="Bolivia_svg__cls-29"
          data-name="130-3-2-3"
        />
        <path
          id="Bolivia_svg___131-0-2-9"
          d="M645.81 402.79c.31.38.85.65.4 1.44a1.36 1.36 0 0 1-.4-1.44Z"
          className="Bolivia_svg__cls-29"
          data-name="131-0-2-9"
        />
        <path
          id="Bolivia_svg___132-0-0-4"
          d="M648.11 400.58c-.29.17-.89.06-1.05 1 .8-.33.78-.25 1.05-1Z"
          className="Bolivia_svg__cls-29"
          data-name="132-0-0-4"
        />
        <path
          id="Bolivia_svg___133-4-1-5"
          d="M648 401.23c-.31.15-.94 0-1.09.89.81-.27.79-.2 1.09-.89Z"
          className="Bolivia_svg__cls-29"
          data-name="133-4-1-5"
        />
        <path
          id="Bolivia_svg___134-8-1-6"
          d="M647.79 401.8c-.32.17-1 .05-1.15 1 .88-.32.86-.24 1.15-1Z"
          className="Bolivia_svg__cls-29"
          data-name="134-8-1-6"
        />
        <path
          id="Bolivia_svg___135-3-75-7"
          d="M647.62 402.61c-.32.06-1-.26-1.18.89.63-.07.64-.42 1.18-.89Z"
          className="Bolivia_svg__cls-29"
          data-name="135-3-75-7"
        />
        <path
          id="Bolivia_svg___136-0-9-5"
          d="M647.17 403.26c-.44.11-.68 0-.89 1 .72-.36.65-.26.89-1Z"
          className="Bolivia_svg__cls-29"
          data-name="136-0-9-5"
        />
        <path
          id="Bolivia_svg___137-1-18-1"
          d="M647.46 403.8c-1.4 3.15-1.58 6.19-1.26 10.62l.31-.07c-.35-4.48-.18-7.34 1.12-10.42Z"
          className="Bolivia_svg__cls-29"
          data-name="137-1-18-1"
        />
        <path
          id="Bolivia_svg___138-2-1-5"
          d="M649.62 400.42c-.65.37-.92.29-.93 1.18.65-.2.73-.5.93-1.18Z"
          className="Bolivia_svg__cls-29"
          data-name="138-2-1-5"
        />
        <path
          id="Bolivia_svg___139-9-7-4"
          d="M648.43 400.44c.22.43.63.74.06 1.54-.43-.67-.34-.7-.06-1.54Z"
          className="Bolivia_svg__cls-29"
          data-name="139-9-7-4"
        />
        <path
          id="Bolivia_svg___140-0-8-2"
          d="M648.05 401.32c.33.42.69.6.16 1.29-.21-.55-.4-.56-.16-1.29Z"
          className="Bolivia_svg__cls-29"
          data-name="140-0-8-2"
        />
        <path
          id="Bolivia_svg___141-3-6-3"
          d="M647.79 401.76c.21.42.62.73.06 1.51-.43-.66-.34-.68-.06-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="141-3-6-3"
        />
        <path
          id="Bolivia_svg___142-8-6-6"
          d="M647.38 402.41c.28.43.76.77.17 1.5-.47-.73-.12-.75-.17-1.5Z"
          className="Bolivia_svg__cls-29"
          data-name="142-8-6-6"
        />
        <path
          id="Bolivia_svg___143-8-9-4"
          d="M647.09 403.1c.25.41.74.76.18 1.48a1.38 1.38 0 0 1-.18-1.48Z"
          className="Bolivia_svg__cls-29"
          data-name="143-8-9-4"
        />
        <path
          id="Bolivia_svg___144-5-9-5"
          d="M649.7 401.26c-.31.13-.89-.07-1.19.81.85-.19.81-.07 1.19-.81Z"
          className="Bolivia_svg__cls-29"
          data-name="144-5-9-5"
        />
        <path
          id="Bolivia_svg___145-7-2-2"
          d="M649.47 401.88c-.33.1-.94-.11-1.22.71.88-.13.85-.06 1.22-.71Z"
          className="Bolivia_svg__cls-29"
          data-name="145-7-2-2"
        />
        <path
          id="Bolivia_svg___146-7-6-8"
          d="M649.2 402.42c-.34.12-1-.1-1.28.79.92-.16.89-.09 1.28-.79Z"
          className="Bolivia_svg__cls-29"
          data-name="146-7-6-8"
        />
        <path
          id="Bolivia_svg___147-0-65-3"
          d="M648.91 403.19c-.33 0-.94-.41-1.29.7.63.03.69-.32 1.29-.7Z"
          className="Bolivia_svg__cls-29"
          data-name="147-0-65-3"
        />
        <path
          id="Bolivia_svg___148-8-8-1"
          d="M648.38 403.77c-.46 0-.68-.06-1 .8.68-.21.62-.14 1-.8Z"
          className="Bolivia_svg__cls-29"
          data-name="148-8-8-1"
        />
        <path
          id="Bolivia_svg___149-9-40-7"
          d="M648.4 404.61c-1.63 2.86-1.49 5.89-.82 9.38l.25-.11a21.5 21.5 0 0 1-.46-4.2 9 9 0 0 1 1.19-4.9Z"
          className="Bolivia_svg__cls-29"
          data-name="149-9-40-7"
        />
        <path
          id="Bolivia_svg___150-3-3-0"
          d="M651.24 401.43c-.7.26-1 .13-1.11 1 .67-.07.8-.36 1.11-1Z"
          className="Bolivia_svg__cls-29"
          data-name="150-3-3-0"
        />
        <path
          id="Bolivia_svg___151-0-7-2"
          d="M650.07 401.25c.14.46.49.83-.21 1.52-.3-.77-.21-.77.21-1.52Z"
          className="Bolivia_svg__cls-29"
          data-name="151-0-7-2"
        />
        <path
          id="Bolivia_svg___152-7-83-7"
          d="M649.54 402.05c.25.47.58.71-.06 1.3-.14-.58-.3-.62.06-1.3Z"
          className="Bolivia_svg__cls-29"
          data-name="152-7-83-7"
        />
        <path
          id="Bolivia_svg___153-4-11-0"
          d="M649.2 402.44c.15.45.5.83-.19 1.5-.31-.73-.22-.74.19-1.5Z"
          className="Bolivia_svg__cls-29"
          data-name="153-4-11-0"
        />
        <path
          id="Bolivia_svg___154-7-25-9"
          d="M648.69 403c.2.48.62.89-.09 1.51-.34-.8.01-.76.09-1.51Z"
          className="Bolivia_svg__cls-29"
          data-name="154-7-25-9"
        />
        <path
          id="Bolivia_svg___155-8-7-0"
          d="M648.29 403.63c.17.45.6.88-.08 1.48a1.34 1.34 0 0 1 .08-1.48Z"
          className="Bolivia_svg__cls-29"
          data-name="155-8-7-0"
        />
        <path
          id="Bolivia_svg___156-3-6-9"
          d="M651.19 402.28c-.34.07-.87-.23-1.32.58.87-.03.82.04 1.32-.58Z"
          className="Bolivia_svg__cls-29"
          data-name="156-3-6-9"
        />
        <path
          id="Bolivia_svg___157-7-2-3"
          d="M650.85 402.84c-.34.05-.91-.27-1.33.5.89.01.85.08 1.33-.5Z"
          className="Bolivia_svg__cls-29"
          data-name="157-7-2-3"
        />
        <path
          id="Bolivia_svg___158-1-1-5"
          d="M650.49 403.33c-.36.06-1-.27-1.4.55.91 0 .91.12 1.4-.55Z"
          className="Bolivia_svg__cls-29"
          data-name="158-1-1-5"
        />
        <path
          id="Bolivia_svg___159-0-6-9"
          d="M650.07 404c-.32 0-.86-.56-1.4.47.62.17.74-.17 1.4-.47Z"
          className="Bolivia_svg__cls-29"
          data-name="159-0-6-9"
        />
        <path
          id="Bolivia_svg___160-0-1-3"
          d="M649.44 404.51c-.46 0-.66-.18-1.16.61.72-.12.72-.02 1.16-.61Z"
          className="Bolivia_svg__cls-29"
          data-name="160-0-1-3"
        />
        <path
          id="Bolivia_svg___161-8-1-9"
          d="M644.21 408.61h1.71c1 0 1.86.26 1.86.53s-.83.47-1.87.45h-1.71c-1 0-1.86-.26-1.86-.53s.83-.47 1.87-.45Z"
          className="Bolivia_svg__cls-29"
          data-name="161-8-1-9"
        />
        <path
          id="Bolivia_svg___162-3-5-0"
          d="m643 408.58-.51.86a.5.5 0 0 0 .3.12h.3l.58-1Zm1.33 0-.57 1h.66l.58-1Zm1.34 0-.58 1h.66l.58-1Zm1.33 0-.58 1h.67l.5-.84a.44.44 0 0 0-.31-.13Z"
          className="Bolivia_svg__cls-29"
          data-name="162-3-5-0"
        />
      </g>
      <g id="Bolivia_svg__g4771">
        <path
          id="Bolivia_svg__path4714-2"
          d="M633.8 403.22s.39 2.67.69 4c0 .16.23.24.28.4a1.8 1.8 0 0 1 0 .52v.06c0 .24-.2.47-.14.71s.2.2.26.33a12 12 0 0 1 .56 2.39c.09.31-.06-.07.55.83.06.09.3.09.3.09h.23l.24.24-.3.33-1 .13-.48-.3s.12-.27 0-.4-.29 0-.31-.13-.1-.78-.11-.78 0 0 0-.05a11 11 0 0 1-1.11-1.41c-.16-.27-.18-.61-.35-.87s-.32-.24-.41-.42a37 37 0 0 1-1.6-4.35"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4697-6"
          d="m621.57 402.86 2.67.63-.72 3.91c-.46 1.24-.42 1.29-.27 1.64a15 15 0 0 0 1.63 3.25c.38.4.79.44.93.6a1.35 1.35 0 0 0 .66.53h.84c.14-.2.14-.14.18-.29s-.46-.11-.74-.35c-.15-.48-.78-1.19-.87-1.69a4.1 4.1 0 0 1-.17-2.24 22 22 0 0 1 .66-2.55 6.5 6.5 0 0 0 .71-2.95l-1.16-2.56-.67-1"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4668-3"
          d="M622.72 398.11c-4.27 1.38-2.45 5.31-1.23 5.35"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4634-7-4"
          d="m635.28 391.29.63-1.43v-.52l-.06-.11-1.13 1.38v.09"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4656-6"
          d="M637.77 393.6c.27.1.62.2.68 0s.11-.35-.1-.5 0-.23-.07-.48c-.75-.53-1.26-.54-1.45-1v-.29c0-.36-1.11-.52-1.37-.69a4 4 0 0 0-.7-.28 2 2 0 0 0-.31 0c-1.09 0-1.6 1.14-1.78 1.84a23.4 23.4 0 0 1-.74 4.63 1.1 1.1 0 0 1-.22.36c-.09.09-.19.24-.32.23-3-.21-5.09-.35-6.32-.3a5.6 5.6 0 0 0-2.72 1.1 4.22 4.22 0 0 0-1.67 2.36 3.4 3.4 0 0 0 .21 1.65c1.36 3.86 2.7 0 3.19 0l.6.05c.71.07 2 2.24 4 2.67 6 1.31 7.61-1.82 7.48-8.77l.08-.1v-.24l.3-.55-.06-.77-.1-.36v-.15l1.68-.21.29-.14"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4634-8"
          d="m634.87 391.63.72-1.64v-.6l-.07-.12-1.3 1.58v.1"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4683-6"
          d="M620.86 402.29a18 18 0 0 1 1 2.7 1.78 1.78 0 0 1-.45 1c0 .06-.16.14-.2.18a1.8 1.8 0 0 0-.39.76 2.1 2.1 0 0 0-.13.88 26.5 26.5 0 0 0 .8 3.43 1.5 1.5 0 0 1 .47.42 1.23 1.23 0 0 1 0 .66 7 7 0 0 1-.2 1 .5.5 0 0 0 .06.18 2.7 2.7 0 0 0 .5.32h.81a5 5 0 0 1-.49-.55.53.53 0 0 1 0-.33 3.2 3.2 0 0 1 .36-.67 1.2 1.2 0 0 0 0-.55c0-.15-.13-.21-.13-.28a11 11 0 0 1-.12-1.3c0-.42.05-1.69.05-1.69a3 3 0 0 0 .27-.26 2 2 0 0 0 .17-.31 11 11 0 0 0 1.4-.94 15 15 0 0 0 1.3-1.56 3 3 0 0 0 .27-.7.8.8 0 0 0 0-.26 5.8 5.8 0 0 0-.5-1.35 4.6 4.6 0 0 0-.78-1.16l-.11-.08"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4691-0"
          d="M633.75 404.62c-.81.53-2.71 1-2.74 1.35a19.7 19.7 0 0 1-.33 3.37 8 8 0 0 1-.42.86c-.15.38-.14.67-.27 1a4.4 4.4 0 0 0-.41 1.47v.58l.58.35-.6.2-1-.37-.08-.89.21-.92v-.15l-.23-.55-.15-2 .16-1.49-.21-5.49"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4654-8"
          d="M635.35 394c.38.31.88.5 2 .13.21.14.45.32.93-.36"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4704-5"
          d="M637.8 393s.22.14.3.14.14-.12.09-.16-.16-.1-.21-.07a.5.5 0 0 1-.18.09Z"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path4706-2"
          d="M635.66 392.13a.17.17 0 0 1 .15.09c.14.3.47.36.73 0a.3.3 0 0 1 .12-.1s-.09 0-.13 0c-.29-.29-.59-.05-.69 0Z"
        />
      </g>
      <g id="Bolivia_svg__g5254">
        <g id="Bolivia_svg__Capa_1">
          <g id="Bolivia_svg___109262760" data-name={109262760}>
            <path
              id="Bolivia_svg___112166136"
              d="M652.7 409.36a2.8 2.8 0 0 0 0 1.11 2.9 2.9 0 0 0 0 1.13 3 3 0 0 0 0 1.07 3.1 3.1 0 0 0 0 1 2.26 2.26 0 0 0 1.89.06 3.1 3.1 0 0 0 0-1.06 2.8 2.8 0 0 0 0-1.07 3.1 3.1 0 0 0 0-1.13 3 3 0 0 0 0-1.11 3.3 3.3 0 0 0 0-1.17v-2.28a4.2 4.2 0 0 0 0-1.17 3.6 3.6 0 0 0 0-1.19 3.5 3.5 0 0 0 0-1.17 3.1 3.1 0 0 0 0-1.18 2.8 2.8 0 0 0 0-1.18 3.5 3.5 0 0 0 0-1.17 3.3 3.3 0 0 0 0-1.17 5.3 5.3 0 0 0 0-1.19 137 137 0 0 1 0-2.34 4 4 0 0 0 0-1.19 4.2 4.2 0 0 0 0-1.17 3.9 3.9 0 0 0 0-1.17 3.4 3.4 0 0 0 0-1.15 3.8 3.8 0 0 0 0-1.07 4 4 0 0 0 0-.46h-1.18a.8.8 0 0 0 0 .47 3.2 3.2 0 0 0 0 1.07 3.4 3.4 0 0 0 0 1.15 3.6 3.6 0 0 0 0 1.17 70 70 0 0 0 0 2.36 4.3 4.3 0 0 0 0 1.18 4.2 4.2 0 0 0 0 1.17 4.3 4.3 0 0 0 0 1.18 3.6 3.6 0 0 0 0 1.18 4.1 4.1 0 0 0 0 1.17 3 3 0 0 0 0 1.19 3.3 3.3 0 0 0 0 1.17 3.6 3.6 0 0 0 0 1.17 3.6 3.6 0 0 0 0 1.19 4 4 0 0 0 0 1.18 120 120 0 0 1 0 2.28 3.3 3.3 0 0 0 0 1.16Z"
              className="Bolivia_svg__cls-5"
              data-name={112166136}
            />
            <path
              id="Bolivia_svg___112703888"
              d="M652.69 410.47a3.3 3.3 0 0 0 1.81 0"
              className="Bolivia_svg__cls-19"
              data-name={112703888}
            />
            <path
              id="Bolivia_svg___105428400"
              d="M652.68 409.35a3.5 3.5 0 0 0 1.81 0"
              className="Bolivia_svg__cls-19"
              data-name={105428400}
            />
            <path
              id="Bolivia_svg___122805528"
              d="M652.73 408.18a3.25 3.25 0 0 0 1.75 0"
              className="Bolivia_svg__cls-19"
              data-name={122805528}
            />
            <path
              id="Bolivia_svg___113328848"
              d="M652.75 407.06a3.06 3.06 0 0 0 1.72 0"
              className="Bolivia_svg__cls-19"
              data-name={113328848}
            />
            <path
              id="Bolivia_svg___140461728"
              d="M652.78 405.92a3.7 3.7 0 0 0 1.69 0"
              className="Bolivia_svg__cls-19"
              data-name={140461728}
            />
            <path
              id="Bolivia_svg___111252504"
              d="M652.8 404.74a4 4 0 0 0 1.66 0"
              className="Bolivia_svg__cls-19"
              data-name={111252504}
            />
            <path
              id="Bolivia_svg___127192920"
              d="M652.82 403.55a3.9 3.9 0 0 0 1.63 0"
              className="Bolivia_svg__cls-19"
              data-name={127192920}
            />
            <path
              id="Bolivia_svg___99199072"
              d="M652.84 402.39a3.75 3.75 0 0 0 1.6 0"
              className="Bolivia_svg__cls-19"
              data-name={99199072}
            />
            <path
              id="Bolivia_svg___57974072"
              d="M652.88 401.21a3.24 3.24 0 0 0 1.55 0"
              className="Bolivia_svg__cls-19"
              data-name={57974072}
            />
            <path
              id="Bolivia_svg___139695576"
              d="M652.9 400a3.7 3.7 0 0 0 1.52 0"
              className="Bolivia_svg__cls-19"
              data-name={139695576}
            />
            <path
              id="Bolivia_svg___108876192"
              d="M652.92 398.85a4 4 0 0 0 1.49 0"
              className="Bolivia_svg__cls-19"
              data-name={108876192}
            />
            <path
              id="Bolivia_svg___104468904"
              d="M653 397.71a4.5 4.5 0 0 0 1.46 0"
              className="Bolivia_svg__cls-19"
              data-name={104468904}
            />
            <path
              id="Bolivia_svg___108959488"
              d="M653 396.49a3.4 3.4 0 0 0 1.43 0"
              className="Bolivia_svg__cls-19"
              data-name={108959488}
            />
            <path
              id="Bolivia_svg___109312288"
              d="M653 395.35a3.2 3.2 0 0 0 1.39 0"
              className="Bolivia_svg__cls-19"
              data-name={109312288}
            />
            <path
              id="Bolivia_svg___109287888"
              d="M653 394.15a4 4 0 0 0 1.34 0"
              className="Bolivia_svg__cls-19"
              data-name={109287888}
            />
            <path
              id="Bolivia_svg___85988992"
              d="M653.06 393a3.7 3.7 0 0 0 1.31 0"
              className="Bolivia_svg__cls-19"
              data-name={85988992}
            />
            <path
              id="Bolivia_svg___144371400"
              d="M653.1 391.8a4.6 4.6 0 0 0 1.24 0"
              className="Bolivia_svg__cls-19"
              data-name={144371400}
            />
            <path
              id="Bolivia_svg___142302024"
              d="M653.12 390.6a3.3 3.3 0 0 0 1.21 0"
              className="Bolivia_svg__cls-19"
              data-name={142302024}
            />
            <path
              id="Bolivia_svg___90888000"
              d="M653.15 389.46a3.8 3.8 0 0 0 1.18 0"
              className="Bolivia_svg__cls-19"
              data-name={90888000}
            />
            <path
              id="Bolivia_svg___108984096"
              d="M653.1 388.39a6.4 6.4 0 0 0 1.23 0"
              className="Bolivia_svg__cls-19"
              data-name={108984096}
            />
            <path
              id="Bolivia_svg___59547952"
              d="M652.67 411.58a3.37 3.37 0 0 0 1.83 0"
              className="Bolivia_svg__cls-19"
              data-name={59547952}
            />
            <path
              id="Bolivia_svg___109262800"
              d="M652.64 412.65a3.5 3.5 0 0 0 1.87 0"
              className="Bolivia_svg__cls-19"
              data-name={109262800}
            />
          </g>
        </g>
        <g id="Bolivia_svg__Capa_2">
          <g id="Bolivia_svg___110261640" data-name={110261640}>
            <path
              id="Bolivia_svg___109373744"
              d="M656.27 385.61a19 19 0 0 1 3.16-.22c-.34-.11-.72-.23-1.29-.38.83-.12 2.81-.09 3.31-.1a7.4 7.4 0 0 0-1.42-.59 11.2 11.2 0 0 1 3.3.14 6.1 6.1 0 0 0-1.52-.71 11.7 11.7 0 0 1 3 .18 3.9 3.9 0 0 0-1.33-.73 12.1 12.1 0 0 1 3.69-.21 12.91 12.91 0 0 0-12.09 1.17 9.3 9.3 0 0 1 1.58-1.73 3.8 3.8 0 0 0-1 .06 6.2 6.2 0 0 1 1.83-1.35 4.6 4.6 0 0 0-1.12 0 10.1 10.1 0 0 1 2.08-1.41 4.8 4.8 0 0 0-1.26 0 7.9 7.9 0 0 1 2.39-1.73 5.9 5.9 0 0 0-1.41.11 12.7 12.7 0 0 1 2.93-2c-5 .55-7.73 4.15-8 7.19-1.33-2.86-4.95-5.6-9.93-5.39a15.5 15.5 0 0 1 3.59 1.56 6.6 6.6 0 0 0-1.51.11 9.4 9.4 0 0 1 3 1.41 5.4 5.4 0 0 0-1.34.17 12 12 0 0 1 2.56 1.13 4.6 4.6 0 0 0-1.2.13 7.3 7.3 0 0 1 2.27 1.1 4 4 0 0 0-1.11.11 6.2 6.2 0 0 1 1.92 1c-3.1-.66-7.59.37-11.05 4.38a14.5 14.5 0 0 1 3.32-1.4 5.5 5.5 0 0 0-.75 1.17 12.7 12.7 0 0 1 3.06-1.59 8 8 0 0 0-.61 1.12 25 25 0 0 1 2.73-1.37 6.7 6.7 0 0 0-.61 1.07 21 21 0 0 1 2.54-1 4.8 4.8 0 0 0-.74 1l1.37-.49a9.32 9.32 0 0 0-4.19 8.66 17 17 0 0 1 1.24-2.94 5.5 5.5 0 0 0 .14 1.51 12.6 12.6 0 0 1 1.44-3 5.4 5.4 0 0 0 0 1.53 24 24 0 0 1 1.5-3.06 5.8 5.8 0 0 0 0 1.44 20.6 20.6 0 0 1 1.61-2.79 10 10 0 0 0-.07 1.15l.52-.84a10.5 10.5 0 0 1 1-1.39 2.4 2.4 0 0 1 .33.42 6.4 6.4 0 0 1 .79 2.7 4.8 4.8 0 0 0 .34-1.31 12.5 12.5 0 0 1 1 3.58 5 5 0 0 0 .29-1.52 10 10 0 0 1 .95 3.53 4 4 0 0 0 .5-1.19 12.4 12.4 0 0 1 .78 3.33c1.22-4.44-.53-7.31-2.67-9.5a8.2 8.2 0 0 1 1.88 1.61 7 7 0 0 0-.39-1.31 20 20 0 0 1 2.27 2.05 3.7 3.7 0 0 0-.35-1.24 11.5 11.5 0 0 1 2.24 2.36 9 9 0 0 0-.31-1.41 9 9 0 0 1 2.08 2.63 9 9 0 0 0-.26-1.55 8.4 8.4 0 0 1 2 2.64c0-4-4.63-7.62-8.94-8Z"
              data-name={109373744}
              style={{
                fill: "#007934",
                strokeWidth: ".5px",
                stroke: "#e7e7e7",
              }}
            />
            <g id="Bolivia_svg__g5212">
              <path
                id="Bolivia_svg___57651880"
                d="M654.48 385.65c4.7-.67 10.74 3.38 10.73 8a8.4 8.4 0 0 0-2-2.64 9 9 0 0 1 .26 1.55 9 9 0 0 0-2.08-2.63 9 9 0 0 1 .31 1.41 11.5 11.5 0 0 0-2.24-2.36 3.7 3.7 0 0 1 .35 1.24 20 20 0 0 0-2.27-2.05 7 7 0 0 1 .39 1.31 8.2 8.2 0 0 0-1.88-1.61"
                className="Bolivia_svg__cls-31"
                data-name={57651880}
              />
              <path
                id="Bolivia_svg___109373784"
                d="M653.43 385.59c-2.82-1.81-8.79-1.48-13.13 3.56a14.5 14.5 0 0 1 3.32-1.4 5.5 5.5 0 0 0-.75 1.17 12.7 12.7 0 0 1 3.06-1.59 8 8 0 0 0-.61 1.12 23.5 23.5 0 0 1 2.73-1.37 6.7 6.7 0 0 0-.61 1.07 21 21 0 0 1 2.54-1 4.8 4.8 0 0 0-.74 1l1.37-.49"
                className="Bolivia_svg__cls-31"
                data-name={109373784}
              />
              <path
                id="Bolivia_svg___59500704"
                d="M653.61 384.88c-.59-3.31-4.56-7.12-10.4-6.87a15.5 15.5 0 0 1 3.59 1.56 6.6 6.6 0 0 0-1.51.11 9.4 9.4 0 0 1 3 1.41 5.4 5.4 0 0 0-1.34.17 12.6 12.6 0 0 1 2.56 1.12 5 5 0 0 0-1.2.14 7.4 7.4 0 0 1 2.27 1.1 4 4 0 0 0-1.11.11 6.2 6.2 0 0 1 1.92 1"
                className="Bolivia_svg__cls-31"
                data-name={59500704}
              />
              <path
                id="Bolivia_svg___114147888"
                d="M653.57 386.18c-3.91 1.2-7.69 5.05-7.15 10.11a17.3 17.3 0 0 1 1.24-2.93 5.5 5.5 0 0 0 .14 1.51 12.6 12.6 0 0 1 1.44-3 5.4 5.4 0 0 0 0 1.53 24 24 0 0 1 1.5-3.06 5.8 5.8 0 0 0 0 1.44 20.6 20.6 0 0 1 1.61-2.79 10 10 0 0 0-.07 1.15 20 20 0 0 1 1.49-2.23"
                className="Bolivia_svg__cls-31"
                data-name={114147888}
              />
              <path
                id="Bolivia_svg___109396888"
                d="M651.37 388.18a13.5 13.5 0 0 0-.58 2.18"
                className="Bolivia_svg__cls-31"
                data-name={109396888}
              />
              <path
                id="Bolivia_svg___57647160"
                d="M649.94 389.16a15.4 15.4 0 0 0-.7 2.73"
                className="Bolivia_svg__cls-31"
                data-name={57647160}
              />
              <path
                id="Bolivia_svg___61202400"
                d="M648.5 390.52a13 13 0 0 0-.84 2.84"
                className="Bolivia_svg__cls-31"
                data-name={61202400}
              />
              <path
                id="Bolivia_svg___108003056"
                d="m653.8 387.93.02-.9"
                className="Bolivia_svg__cls-31"
                data-name={108003056}
              />
              <path
                id="Bolivia_svg___109350400"
                d="M657.86 391.87A8.9 8.9 0 0 1 658 394"
                className="Bolivia_svg__cls-31"
                data-name={109350400}
              />
              <path
                id="Bolivia_svg___109347792"
                d="M656.37 389.41a10.4 10.4 0 0 1 .21 2.39"
                className="Bolivia_svg__cls-31"
                data-name={109347792}
              />
              <path
                id="Bolivia_svg___137236192"
                d="M655 387.81a5.9 5.9 0 0 1 .28 1.94"
                className="Bolivia_svg__cls-31"
                data-name={137236192}
              />
              <path
                id="Bolivia_svg___137234560"
                d="M662.38 389.15a5.3 5.3 0 0 1 .88 1.81"
                className="Bolivia_svg__cls-31"
                data-name={137234560}
              />
              <path
                id="Bolivia_svg___137232928"
                d="M660.27 387.68a7.5 7.5 0 0 1 1.17 2.2"
                className="Bolivia_svg__cls-31"
                data-name={137232928}
              />
              <path
                id="Bolivia_svg___276224976"
                d="M658.49 387.09a8 8 0 0 1 1 1.84"
                className="Bolivia_svg__cls-31"
                data-name={276224976}
              />
              <path
                id="Bolivia_svg___276223488"
                d="M643.62 387.75a7 7 0 0 1 2.6-1.8"
                className="Bolivia_svg__cls-31"
                data-name={276223488}
              />
              <path
                id="Bolivia_svg___61025264"
                d="M645.93 387.33a4.84 4.84 0 0 1 2.41-1.86"
                className="Bolivia_svg__cls-31"
                data-name={61025264}
              />
              <path
                id="Bolivia_svg___61023680"
                d="M648.05 387.08a5.35 5.35 0 0 1 2.42-1.73"
                className="Bolivia_svg__cls-31"
                data-name={61023680}
              />
              <path
                id="Bolivia_svg___61022688"
                d="M650 387.12a7.5 7.5 0 0 1 2.4-1.46"
                className="Bolivia_svg__cls-31"
                data-name={61022688}
              />
              <path
                id="Bolivia_svg___60098480"
                d="M646.8 379.57a8.2 8.2 0 0 1 3.25 1"
                className="Bolivia_svg__cls-31"
                data-name={60098480}
              />
              <path
                id="Bolivia_svg___59194896"
                d="M648.25 381.09a7.3 7.3 0 0 1 2.81.64"
                className="Bolivia_svg__cls-31"
                data-name={59194896}
              />
              <path
                id="Bolivia_svg___60493792"
                d="M649.47 382.39a6.7 6.7 0 0 1 3 .92"
                className="Bolivia_svg__cls-31"
                data-name={60493792}
              />
              <path
                id="Bolivia_svg___59289568"
                d="M650.54 383.62a5.8 5.8 0 0 1 2.59.88"
                className="Bolivia_svg__cls-31"
                data-name={59289568}
              />
              <path
                id="Bolivia_svg___59437040"
                d="M654.39 384.71a12.85 12.85 0 0 1 12.82-1.71 12.1 12.1 0 0 0-3.69.21 3.8 3.8 0 0 1 1.32.73 11.6 11.6 0 0 0-3-.18 6.3 6.3 0 0 1 1.52.71 10.8 10.8 0 0 0-3.3-.14 7.4 7.4 0 0 1 1.42.59c-.5 0-2.48 0-3.31.1.57.15 1 .27 1.29.38a19.5 19.5 0 0 0-3.17.22"
                className="Bolivia_svg__cls-31"
                data-name={59437040}
              />
              <path
                id="Bolivia_svg___57583984"
                d="M663.52 383.2a9 9 0 0 0-3.22-.47"
                className="Bolivia_svg__cls-31"
                data-name={57583984}
              />
              <path
                id="Bolivia_svg___59158512"
                d="M661.81 383.75a8.7 8.7 0 0 0-3.79-.38"
                className="Bolivia_svg__cls-31"
                data-name={59158512}
              />
              <path
                id="Bolivia_svg___56459728"
                d="M660 384.32a10.5 10.5 0 0 0-3.73-.28"
                className="Bolivia_svg__cls-31"
                data-name={56459728}
              />
              <path
                id="Bolivia_svg___55106048"
                d="M658.14 385a7.3 7.3 0 0 0-3-.16"
                className="Bolivia_svg__cls-31"
                data-name={55106048}
              />
              <path
                id="Bolivia_svg___55036328"
                d="M656.38 386.45a4.3 4.3 0 0 1 1.21 1.67"
                className="Bolivia_svg__cls-31"
                data-name={55036328}
              />
              <path
                id="Bolivia_svg___57285408"
                d="M653.14 383.4c.23-3 3-6.64 8-7.19a12.7 12.7 0 0 0-2.93 2 5.9 5.9 0 0 1 1.41-.11 7.9 7.9 0 0 0-2.39 1.73 4.8 4.8 0 0 1 1.26 0 10.1 10.1 0 0 0-2.08 1.41 4.6 4.6 0 0 1 1.12 0 6.2 6.2 0 0 0-1.83 1.35 3.8 3.8 0 0 1 1-.06 9.3 9.3 0 0 0-1.58 1.73"
                className="Bolivia_svg__cls-31"
                data-name={57285408}
              />
              <path
                id="Bolivia_svg___60502904"
                d="M658.17 378.18a7.9 7.9 0 0 0-2.32 1.06"
                className="Bolivia_svg__cls-31"
                data-name={60502904}
              />
              <path
                id="Bolivia_svg___110052216"
                d="M657.19 379.8a6.9 6.9 0 0 0-2.1.77"
                className="Bolivia_svg__cls-31"
                data-name={110052216}
              />
              <path
                id="Bolivia_svg___60876664"
                d="M656.37 381.18a5.6 5.6 0 0 0-2.21 1"
                className="Bolivia_svg__cls-31"
                data-name={60876664}
              />
              <path
                id="Bolivia_svg___56253864"
                d="M655.66 382.49a4.8 4.8 0 0 0-2.17 1.19"
                className="Bolivia_svg__cls-31"
                data-name={56253864}
              />
              <path
                id="Bolivia_svg___141276520"
                d="M652.82 387.27a8.5 8.5 0 0 0-.44 1.74"
                className="Bolivia_svg__cls-31"
                data-name={141276520}
              />
              <path
                id="Bolivia_svg___56765888"
                d="M654.14 386c2.77 2.43 6.22 5.55 4.63 11.33A12.4 12.4 0 0 0 658 394a4 4 0 0 1-.46 1.34 10 10 0 0 0-.95-3.53 5 5 0 0 1-.29 1.52 12.5 12.5 0 0 0-1-3.58 4.8 4.8 0 0 1-.34 1.31 5.4 5.4 0 0 0-1.12-3.12"
                className="Bolivia_svg__cls-31"
                data-name={56765888}
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Bolivia_svg__text5512">
        <path
          id="Bolivia_svg__path7858"
          d="m599 350.27 1.89 1 .46-.84a1.32 1.32 0 0 0 .21-1 1.5 1.5 0 0 0-.76-.71 1.64 1.64 0 0 0-1.09-.28 1 1 0 0 0-.67.58 2.1 2.1 0 0 0-.33.86.45.45 0 0 0 .29.39m2.46 1.34 2.43 1.32a.48.48 0 0 0 .5 0 2 2 0 0 0 .53-.69 4 4 0 0 0 .37-.88.9.9 0 0 0 0-.61 1.2 1.2 0 0 0-.27-.38 2.7 2.7 0 0 0-.5-.33q-1.71-.92-2.49.54l-.55 1m-3.89-1.16.52-1c.21-.42.34-.67.4-.77a4.7 4.7 0 0 1 .82-1.15 2.1 2.1 0 0 1 .85-.57 1.9 1.9 0 0 1 .75-.11 1.5 1.5 0 0 1 .64.18 1.45 1.45 0 0 1 .64.78 2.55 2.55 0 0 1 .19 1.12 3.36 3.36 0 0 1 1.39-.88 1.8 1.8 0 0 1 1.46.16 2 2 0 0 1 1 1.5 3.88 3.88 0 0 1-.6 2.55c-.18.34-.38.69-.59 1.06s-.38.67-.52.92l-.47.93a16 16 0 0 0-2.1-1.31l-2.64-1.44a17 17 0 0 0-2.24-1c.22-.35.39-.65.53-.89"
          className="Bolivia_svg__cls-16"
        />
        <path
          id="Bolivia_svg__path7860"
          d="M610.84 334.21c-1.08.9-.89 2.21.56 4a4.17 4.17 0 0 0 2.19 1.56 2.24 2.24 0 0 0 2-.51 1.71 1.71 0 0 0 .68-1.61 4.73 4.73 0 0 0-1.18-2.22 5 5 0 0 0-2.22-1.73 2.11 2.11 0 0 0-2 .56m5.59-.28a4 4 0 0 1 1 3.07 4.2 4.2 0 0 1-1.66 2.89 4.33 4.33 0 0 1-3 1.1 3.65 3.65 0 0 1-2.75-1.4 4.2 4.2 0 0 1-1-3.11 4.1 4.1 0 0 1 1.56-2.9 4.37 4.37 0 0 1 3.11-1.15 3.8 3.8 0 0 1 2.79 1.5"
          className="Bolivia_svg__cls-16"
        />
        <path
          id="Bolivia_svg__path7862"
          d="M628.44 330a7.3 7.3 0 0 0 .51 1.5c.48-.13 1-.29 1.54-.49s1-.37 1.31-.51l.47-.2c0 .13.08.36.17.68 0 .11.08.28.16.49a7 7 0 0 0-.72.17l-3.6 1-1 .31a18.4 18.4 0 0 0-.54-2.41l-.81-2.9a18 18 0 0 0-.79-2.33v-.05c.36-.07.67-.15.94-.22l1-.31a18 18 0 0 0 .54 2.41l.78 2.78"
          className="Bolivia_svg__cls-16"
        />
        <path
          id="Bolivia_svg__path7864"
          d="M642.31 325.73a19 19 0 0 0 .12-2.47l1 .14 1 .08a17 17 0 0 0-.41 2.43l-.33 3a18.5 18.5 0 0 0-.12 2.47c-.39-.07-.72-.11-1-.14l-1-.08a16.4 16.4 0 0 0 .41-2.43l.33-3"
          className="Bolivia_svg__cls-16"
        />
        <path
          id="Bolivia_svg__path7866"
          d="M657.08 333.58a52 52 0 0 0 4.72-4 4 4 0 0 0 .62.37 4 4 0 0 0 .53.25q-5.16 3.9-7 5.38l-.74-.4c.06-.68.17-1.71.31-3.09l.36-3.53c.1-.98.15-1.67.17-2.08a9 9 0 0 0 1.08.62 6 6 0 0 0 .83.41 52 52 0 0 0-.87 6.09"
          className="Bolivia_svg__cls-16"
        />
        <path
          id="Bolivia_svg__path7868"
          d="M669.78 339.35a18.4 18.4 0 0 0 1.72-1.77c.24.31.46.57.65.78l.72.73a16.5 16.5 0 0 0-1.93 1.55l-2.22 2a15.5 15.5 0 0 0-1.72 1.77c-.24-.3-.46-.56-.65-.77l-.71-.73a17 17 0 0 0 1.91-1.56l2.23-2"
          className="Bolivia_svg__cls-16"
        />
        <path
          id="Bolivia_svg__path7870"
          d="M677.26 354.36c.78-.8 1.44-1.51 2-2.13v-.07l-2.92.09c.14.33.31.72.52 1.18l.45.93m-1.72-2.07a23 23 0 0 0-2.89.27 3 3 0 0 0-.2-.52 3 3 0 0 0-.33-.61c4.16 0 7.11-.06 8.85-.11l.47 1q-4.53 4.74-5.89 6.46c0-.13-.19-.48-.44-1a10 10 0 0 0-.46-.89q.84-.72 2.1-2c-.2-.46-.36-.83-.5-1.12s-.43-.91-.71-1.47"
          className="Bolivia_svg__cls-16"
        />
      </g>
      <g id="Bolivia_svg__g8752">
        <path
          id="Bolivia_svg__path6841"
          d="m646.38 420.91-1.15 3.32-3.5.07 2.79 2.12-1 3.35 2.87-2 2.88 2-1-3.35 2.73-2.12-3.5-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6843"
          d="m660.09 415.08-1.15 3.31-3.51.07 2.8 2.12-1 3.35 2.88-2 2.88 2-1-3.35 2.8-2.12-3.51-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6845"
          d="M681.25 377.63 680.1 381l-3.5.07 2.79 2.12-1 3.35 2.87-2 2.88 2-1-3.35 2.79-2.12-3.5-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6847"
          d="m671.21 404.35 1.15 3.31 3.5.07-2.79 2.12 1 3.35-2.87-2-2.88 2 1-3.35-2.79-2.12 3.5-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6849"
          d="m678.31 392.13 1.15 3.32 3.5.07-2.79 2.12 1 3.35-2.87-2-2.88 2 1-3.35-2.79-2.12 3.5-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6853"
          d="m631.62 420.91 1.15 3.32 3.5.07-2.79 2.12 1 3.35-2.87-2-2.88 2 1-3.35-2.73-2.12 3.5-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6855"
          d="m617.91 415.08 1.15 3.31 3.51.07-2.8 2.12 1 3.35-2.88-2-2.88 2 1-3.35-2.8-2.12 3.51-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6857"
          d="m596.75 377.63 1.15 3.37 3.5.07-2.79 2.12 1 3.35-2.87-2-2.88 2 1-3.35-2.77-2.19 3.5-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6859"
          d="m606.79 404.35-1.15 3.31-3.5.07 2.79 2.12-1 3.35 2.87-2 2.88 2-1-3.35 2.79-2.12-3.5-.07Z"
          className="Bolivia_svg__cls-32"
        />
        <path
          id="Bolivia_svg__path6861"
          d="m599.69 392.13-1.15 3.32-3.5.07 2.79 2.12-1 3.35 2.87-2 2.88 2-1-3.35 2.79-2.12-3.5-.07Z"
          className="Bolivia_svg__cls-32"
        />
      </g>
      <g id="Bolivia_svg__g4397">
        <g id="Bolivia_svg__g45422">
          <g id="Bolivia_svg__g4979">
            <path
              id="Bolivia_svg__path190"
              d="M640.62 372.14v-.72h.1l-1.24-.72h-1l-1.23.72h.1v.72h3.28"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path192"
              d="M640.62 372.14v-.72h.1l-1.24-.72-.09-1.08h-.81l-.1 1.08-1.23.72h.1v.72Z"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path198"
              d="M641 373.09v.23h-4v-.22h4"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path200"
              d="M641 373.09v.23h-4v-.22Z"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path202"
              d="M637.27 373.08v-.77h.17-.24v-.16h3.58v.16h-.22.17v.77"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path204"
              d="M637.27 373.08v-.77h.17-.24v-.16h3.58v.16h-.22.17v.77"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path206"
              d="M638 372.89v-.54h-.48v.54h.48"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path208"
              d="M637.68 372.47v.31h.22v-.31h-.22"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path210"
              d="M640.38 372.89v-.53h-.48v.53h.48"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path2319"
              d="M640 372.47v.31h.22v-.31H640"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path2321"
              d="M640.38 372v-.53h-.47v.53Z"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path216"
              d="M640 371.6v.31h.22v-.31H640"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path218"
              d="M638 372v-.54h-.48v.54Z"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path220"
              d="M637.68 371.6v.31h.22v-.31h-.22"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path222"
              d="M638.9 372v-.53h-.48v.53h.48"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path224"
              d="M638.55 371.6v.31h.22v-.31h-.22"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path226"
              d="M639.57 372v-.53h-.48v.53h.48"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path228"
              d="M639.22 371.6v.31h.22v-.31h-.22"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path230"
              d="M639.69 371.86v1.23h-1.39v-1.23h1.39"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path232"
              d="M639.69 371.86v1.23h-1.39v-1.23Z"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path234"
              d="M638.29 372.21h1.4"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path2333"
              d="M638.47 373.09v-.87"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path2335"
              d="M639.52 373.09v-.87"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path240"
              d="m640.19 371.33-.78-.51h-.88l-.77.51h2.43"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path2338"
              d="M638.6 370.71h.74"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path244"
              d="M638.8 370.48v.15h.34v-.15h-.34"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path252"
              d="M638.36 371.89h.11v.05a.09.09 0 0 1 0 .12h-.09v-.17"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path254"
              d="M638.57 371.89h.1v.05a.09.09 0 0 1 0 .12h-.1s-.05-.07 0-.12v-.05"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path256"
              d="M638.8 371.89h.1v.05a.09.09 0 0 1 0 .12h-.09s-.05-.07 0-.12v-.05Z"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path258"
              d="M639.05 371.89h.1v.05a.09.09 0 0 1 0 .12h-.1s-.05-.07 0-.12z"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path260"
              d="M639.27 371.89h.11v.05a.11.11 0 0 1 0 .12h-.09a.09.09 0 0 1 0-.12v-.05"
              className="Bolivia_svg__cls-5"
            />
            <path
              id="Bolivia_svg__path262"
              d="M639.5 371.89h.1v.05a.09.09 0 0 1 0 .12h-.1v-.17"
              className="Bolivia_svg__cls-5"
            />
          </g>
          <path
            id="Bolivia_svg__path13722"
            d="M638.76 369h.48v.56h-.48Z"
            className="Bolivia_svg__cls-5"
          />
          <path
            id="Bolivia_svg__path14693"
            d="M639 368.35v.72"
            className="Bolivia_svg__cls-9"
          />
          <path
            id="Bolivia_svg__path14695"
            d="M638.74 368.62h.52"
            className="Bolivia_svg__cls-9"
          />
        </g>
      </g>
      <g id="Bolivia_svg__g44354">
        <path
          id="Bolivia_svg__path4705-8-5"
          d="M634.71 315.46s-3.51 8.15-2.3 9c0 0 4.4-4.92 5.55-8.83s0-.27 0-.27l-.32-4.24-2.87 4"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4707-6-4"
          d="M634.71 315.46s-3.51 8.15-2.3 9c0 0 4.4-4.92 5.55-8.83s0-.27 0-.27l-.32-4.24-2.87 4"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4741-0-0"
          d="M635.45 311.56s-4.22 9-3.25 9.64c0 0 3.5-4 4.42-7.24s0-.22 0-.22l1.17-5.78"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4743-9-3"
          d="M635.45 311.56s-4.22 9-3.25 9.64c0 0 3.5-4 4.42-7.24s0-.22 0-.22l1.17-5.78"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path4745-4-0"
          d="M639.8 309.56s-4.22 9-3.26 9.64c0 0 3.51-4 4.42-7.24s0-.22 0-.22l1.17-5.78"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path4747-0-4"
          d="M639.8 309.56s-4.22 9-3.26 9.64c0 0 3.51-4 4.42-7.24s0-.22 0-.22l1.17-5.78"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6051-6-0"
          d="m694.26 293.41 5 2.84s1.22 1-1.46.42-8.41-2.57-19.22-9.53c-4.88-3.14-6.42-3.05-6.42-3.05l6.81.18 15.28 9.14Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6053-6-2"
          d="m694.26 293.41 5 2.84s1.22 1-1.46.42-8.41-2.57-19.22-9.53c-4.88-3.14-6.42-3.05-6.42-3.05l6.81.18 15.28 9.14Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6055-6-5"
          d="m695.91 292.17 5 2.85s1.22 1-1.46.41-8.4-2.57-19.21-9.52c-4.89-3.15-1 2.59-1 2.59l.83-3.77Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6057-6-3"
          d="m695.91 292.17 5 2.85s1.22 1-1.46.41-8.4-2.57-19.21-9.52c-4.89-3.15-1 2.59-1 2.59l.83-3.77Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6059-6-8"
          d="M704.25 294.91s-6-1.11-8.16-2.71c0 0 .38.69-2.55-.64 0 0 1.13 2.56-7.11-3.05s-5.35-2.79-5.35-2.79l2.3-.59s12.65 5.05 14 5.58a77 77 0 0 1 6.84 4.2"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6061-0-0"
          d="M704.25 294.91s-6-1.11-8.16-2.71c0 0 .38.69-2.55-.64 0 0 1.13 2.56-7.11-3.05s-5.35-2.79-5.35-2.79l2.3-.59s12.65 5.05 14 5.58a77 77 0 0 1 6.84 4.2Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6063-0-3"
          d="m673 297.15 2 2.86s-.67 2.68-7.62-2.53-6.59-4.79-6.59-4.79l3.84-.53L673 297"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6065-5-1"
          d="m673 297.15 2 2.86s-.67 2.68-7.62-2.53-6.59-4.79-6.59-4.79l3.84-.53L673 297"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6067-4-8"
          d="M663.93 298.58s3.23 4.23 2.51 4.76-4.53.3-7.26-3.84-.06-.21-.06-.21l.26-6.69 4.62 5.78"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6069-1-9"
          d="M663.93 298.58s3.23 4.23 2.51 4.76-4.53.3-7.26-3.84-.06-.21-.06-.21l.26-6.69 4.62 5.78"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6071-0-0"
          d="M667.25 296.64s3.11 4 2.77 4.62-4.73.23-8.22-3.74-.52-5.22-.52-5.22l5.91 4.13"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6073-1-0"
          d="M667.22 296.53s3.14 4.12 2.8 4.73-4.73.23-8.22-3.74-.52-5.22-.52-5.22Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6075-1-0"
          d="M685 294.27s8.86 3.81 2.29 3.56c0 0-12.88-3.47-19.55-9.18l1.89-2.49 15.26 7.89"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6077-7-9"
          d="M685 294.27s8.86 3.81 2.29 3.56c0 0-12.88-3.47-19.55-9.18l1.89-2.49 15.26 7.89"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6079-0-3"
          d="M689.63 293.17s4.8 2.91 5.16 4-14.92-2.86-23-9.56l3.59-1.77 14.22 7.31Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6081-6-2"
          d="M689.63 293.17s4.8 2.91 5.16 4-14.92-2.86-23-9.56l3.59-1.77 14.22 7.31Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6083-7-5"
          d="M675.69 295.81s3.47 2.84 3.08 3.18-7.44-.73-13-5l.66-2.54 9.29 4.2"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6085-7-7"
          d="M675.69 295.81s3.47 2.84 3.08 3.18-7.44-.73-13-5l.66-2.54 9.29 4.2"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6087-6-1"
          d="M681.63 295.56s3.42 2.37 2.71 2.61-3.39 2.36-16.14-5.1l-1.5-.83 2-3.18 12.91 6.3"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6089-0-1"
          d="M681.63 295.46s3.42 2.47 2.71 2.71-3.39 2.36-16.14-5.1l-1.5-.83 2-3.18Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6091-6-3"
          d="M668.55 288.57s4.14 3.71 3.61 4.24-5.46-.64-7.63-2.25a21.4 21.4 0 0 1-3.76-3.69l4.62-1z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6093-2-8"
          d="M668.55 288.57s4.14 3.71 3.61 4.24-5.46-.64-7.63-2.25a21.4 21.4 0 0 1-3.76-3.69l4.62-1z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6095-1-9"
          d="m663.61 282.38 7.55 4.49s6.15 4.35 5.5 4.74-5.5-1.13-8.94-3a40.7 40.7 0 0 1-7.43-5.92"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6097-2-2"
          d="m663.61 282.38 7.55 4.49s6.15 4.35 5.5 4.74-5.5-1.13-8.94-3a40.7 40.7 0 0 1-7.43-5.92"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6099-5-7"
          d="M658.85 303.65s1.4 3.6.56 3.91-2.92-.33-4.59-3.59 1.46-1.88 1.46-1.88z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6101-9-1"
          d="M658.85 303.65s1.4 3.6.56 3.91-2.92-.33-4.59-3.59 1.13-1.81 1.13-1.81Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6103-1-8"
          d="M661.35 301.32s2.11 3.49 1.65 3.89-3.24 1.6-6.27-2.9 3.11-3.55 3.11-3.55Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6105-1-0"
          d="M661.35 301.32s2.11 3.49 1.65 3.89-3.24 1.6-6.27-2.9 3.11-3.55 3.11-3.55Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6107-7-4"
          d="M655 285.59s7.2 13.9 6.6 14.64-3.44 0-5-3.68a74 74 0 0 1-2.9-8.45l1.33-2.51Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6109-7-6"
          d="M655 285.59s7.2 13.9 6.6 14.64-3.44 0-5-3.68a74 74 0 0 1-2.9-8.45l1.33-2.51Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6111-7-5"
          d="M663.43 289.12s6 5.11 4.77 5.75-3.62-.28-7.13-3.76 2.3-2.2 2.3-2.2"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6113-4-6"
          d="M663.4 289s6 5.21 4.8 5.85-3.62-.28-7.13-3.76 2.33-2.09 2.33-2.09Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6115-3-8"
          d="M660.52 289.21s4.29 7.88 3.76 8.63-3.76-2-5.35-4a24.2 24.2 0 0 1-2.79-4.93"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6117-5-1"
          d="M660.52 289.21s4.29 7.88 3.76 8.63-3.76-2-5.35-4a24.2 24.2 0 0 1-2.79-4.93"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6119-2-2"
          d="M628.35 305.4s-.26 4.65 0 5 2.61.35 2.74-3.12-.51-3.61-.51-3.61l-2.29 1.6"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6121-2-8"
          d="M628.35 305.4s-.26 4.65 0 5 2.61.35 2.74-3.12-.51-3.61-.51-3.61l-2.29 1.6"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6123-8-3"
          d="M629.76 299.8s-1.66 5.2-.06 6.24 2.86-5.13 2.93-6.52-2.87.28-2.87.28"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6125-3-7"
          d="M629.76 299.8s-1.66 5.2-.06 6.24 2.86-5.13 2.93-6.52-2.87.28-2.87.28Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6127-7-1"
          d="M630.9 306.44s.32 4.85 1.21 5.06 2.35-1.39 2.35-2.63-1.53-4.17-1.53-4.17l-2.1 1.53"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6129-2-1"
          d="M630.9 306.44s.32 4.85 1.21 5.06 2.35-1.39 2.35-2.63-1.53-4.17-1.53-4.17l-2.1 1.53"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6133-6-6"
          d="M630.94 300.62s-1.66 5.21-.06 6.25 2.86-5.14 2.93-6.52-2.87.27-2.87.27Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6135-9-1"
          d="M631.07 292.28s-2.42 2.49-2.36 3.88 3.57-1.87 3.89-2.5-1.53-1.38-1.53-1.38"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6137-6-1"
          d="M631.07 292.28s-2.42 2.49-2.36 3.88 3.57-1.87 3.89-2.5-1.53-1.38-1.53-1.38Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6139-8-7"
          d="M629.4 290.88s-1.91 3.54-1.4 4.65 2.36-.84 3.25-2.09-1.85-2.56-1.85-2.56"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6141-8-0"
          d="M629.4 290.88s-1.91 3.54-1.4 4.65 2.36-.84 3.25-2.09-1.85-2.56-1.85-2.56Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6143-6-6"
          d="M656.26 286.19s3.06 5.75 2.22 6.06-2.13-1.13-3.41-2.84 1.19-3.22 1.19-3.22"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6145-6-9"
          d="M656.26 286.19s3.06 5.75 2.22 6.06-2.13-1.13-3.41-2.84 1.19-3.22 1.19-3.22Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6149-6-7"
          d="M656.34 298s1.1 4.83.13 5.28c-1.9.87-3-3.44-3.07-5.06-.13-1.81 2.94-.22 2.94-.22Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6153-5-3"
          d="M652.53 305.61s.26 3.62-.26 3.95-1.8.41-3.22-2.63-.77-1.91-.77-1.91l3.5-1.73.76 2"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6157-2-2"
          d="M656 304.78s.41 3.84-.36 4-2.81-1.19-3.7-3.49c-1-2.64 3.57-1.86 3.57-1.86Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6161-8-8"
          d="M652.43 293s3.93 8.8 3.3 10.06c-1.24 2.45-4.81-5.37-5.89-8.42-1.21-3.41 2.59-1.64 2.59-1.64Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6165-4-8"
          d="M650.6 294.5s5.37 9.69 3.11 9.91-6.38-7-7.07-8.71 3.96-1.2 3.96-1.2Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6169-4-1"
          d="M650.28 296.51s2.64 9.29.94 8.47-3.75-7.82-4-9.33 3.06.86 3.06.86Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6173-9-9"
          d="M659.56 283.3s4.07 6.22 2.75 6.4-6.15-4.15-6.19-4.87 3.44-1.53 3.44-1.53Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6177-8-3"
          d="M657 283.56s5.19 7.09 3.63 7.45-1.68-.75-1.68-.75-4.15-3.73-4.42-4.68 2.32-2.11 2.32-2.11"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6185-2-8"
          d="M662.15 283.67s3.57 3.68 2.64 4.93-5.9-4.66-6.57-5.41 4.32.34 4.32.34"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6189-1-0"
          d="M653.5 288.79s5.75 11.19 4.69 12.33-7.44-8.39-7.66-9.78 3-2.76 3-2.76"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6193-9-1"
          d="M650.2 289.8s2.3 3.5 2.17 5.39-3.48-2.7-3.76-3.57 1.59-1.82 1.59-1.82Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6197-3-9"
          d="M654.93 288s1.78 3.61 1.23 4.7-3-2.2-3.83-3.48 2.6-1.22 2.6-1.22Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6201-8-4"
          d="M646.64 291.54s2.8 3.11 2.67 4.77-4.21-2.42-4.57-3.19 1.9-1.58 1.9-1.58Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6205-9-9"
          d="M664.76 282.56s4.25 3.81 3.59 4.41-6.4-3.52-7.27-4.32 3.68-.09 3.68-.09Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6209-2-6"
          d="m661.17 282.29 3.32 2.79s3.09 2.06 2.56 2.6-5.36-1.68-6.22-2.69a3 3 0 0 1-.76-2Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6213-4-3"
          d="M672.11 283.17s12.57 5.09 12.09 6.32S671 285.41 669 284s2.91-.92 2.91-.92"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6217-4-9"
          d="M672.57 284.78s9.44 5.32 8.34 5.83-7.86-1.3-11.35-3.66a55 55 0 0 1-5-3.68l4.3-1Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6221-9-9"
          d="M649.33 291.24s1.78 3.61 1.24 4.7-2.33-.93-3.18-2.21 1.94-2.49 1.94-2.49Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6225-7-7"
          d="M649.75 299.39s1.48 5.27-.15 6.24-2.69-5.25-2.7-6.64 2.85.4 2.85.4Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6229-6-7"
          d="M642.44 290.71s5.25-2.3 6.18-2.12a5.6 5.6 0 0 0 1.7-.73c.59-.46 1.94-1.57 1.94-1.57s-.93-6.36 5.76-5.72 15.49 1.48 17.27 1.76a68 68 0 0 1 9.82 2.85c1.52.74 11.45 5.24 13.48 6a43 43 0 0 1 5.83 3.38c1.35.88 0 .25 0 .25s-16.08-8.53-21.77-9.68c-1.42-.28.1 1.63.1 1.63s-3.7-1.45-5.22-2.1a9 9 0 0 0-4.23-.83 8.7 8.7 0 0 1-3.39-.46c-.84-.28-5.67-.46-6.52-.55a10.4 10.4 0 0 1-1.52-.28l.34.55-2.37-.36-.68 1s-2.28.46-2.45-.28-1.36 3.32-1.95 4.52-2.79 1.2-3.47 1.94a8.1 8.1 0 0 1-1.44 1.38 10.3 10.3 0 0 1-2.63 1.2c-.59 0-4.23.27-4.23.27l-.93-1.47Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6233-7-5"
          d="M649.35 305.62s.09 4.65-.18 5-2.62.24-2.63-3.23.64-3.59.64-3.59l2.23 1.69"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6257-2-4"
          d="M649.91 302.05a8.8 8.8 0 0 0-.76-2.29c-.32-.28.12-.56.12-.56a8.8 8.8 0 0 0-1.33-2.36c-.51-.35.06-.63.06-.63a8 8 0 0 0-1.53-1.8c-.64-.42 0-.49 0-.49a5.53 5.53 0 0 0-2.22-2.72 5.8 5.8 0 0 0-2.07-1.38 28.6 28.6 0 0 0-6.8-.52 5.72 5.72 0 0 0-4.73 2.36l-.21 2.66.48-.32-.7 3.32c-.11.76.59 2.08.63 3.66 0 .51 0 1 .1 1.57a14 14 0 0 0 1.13 4.33c0 .11.1.43.16.32.17-.27.53.94.86 1.38 0 0 .19 1.66.35 1 .06-.24.59.94.92 1.68.12.27.75 2.09.72 1.26s.55 1.94.55 2.34l.77-1.11.38 1.25.64-.07-.19 1.18s1.78-1.46 1.84-2 .13-1 .13-1l.57-.56.9-1.39a14 14 0 0 1 2.48 2.36c.25.63.51 1.18.51 1.18l.57-.55.51 1.25.32-.63.31.87v-.05l.2.57c.15.15.51.22 1.18-.9a6.9 6.9 0 0 0 1-3.13c.06-.27.44.49.44.49a5.5 5.5 0 0 0 .7-2.5c-.13-1 .51-.63.51-.63a26 26 0 0 0 0-3.19c-.13-.63.45-.49.45-.49a24 24 0 0 0-.39-3.4c-.19-.35.45-.42.45-.42Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6259-5-8"
          d="M645.45 295c.45.13.67.64.86 1v-.19c-.19-.39-.41-.9-.86-1v.2"
        />
        <path
          id="Bolivia_svg__path6261-2-6"
          d="M645.85 296.9a3 3 0 0 1 .86 2.71s0 .21 0 .1a3.41 3.41 0 0 0-.88-3s0 .16 0 .2"
        />
        <path
          id="Bolivia_svg__path6263-0-2"
          d="M647.58 297.88a4.5 4.5 0 0 1 .5 2.45q0 .165 0 0a4.8 4.8 0 0 0-.52-2.64s0 .15 0 .19"
        />
        <path
          id="Bolivia_svg__path6265-5-1"
          d="M648.19 301.51c-.06.54-.15 1.06-.26 1.59v.17a15 15 0 0 0 .26-1.62s0-.22 0-.14"
        />
        <path
          id="Bolivia_svg__path6267-8-0"
          d="M647.63 304.29a5.4 5.4 0 0 1 0 1.06v.14a6 6 0 0 0-.05-1.33v.13"
        />
        <path
          id="Bolivia_svg__path6269-8-9"
          d="M646.56 300.8c0 .59 0 1.19.05 1.78v-1.78q0-.165 0 0"
        />
        <path
          id="Bolivia_svg__path6271-3-4"
          d="M646.1 304.66v1.69q0 .165 0 0c0-.61 0-1.22-.06-1.83v.14"
        />
        <path
          id="Bolivia_svg__path6273-6-6"
          d="M648.65 304.17a1.6 1.6 0 0 1 .45.92.3.3 0 0 0 0-.13 1.8 1.8 0 0 0-.46-.95s0 .16 0 .2"
        />
        <path
          id="Bolivia_svg__path6275-4-1"
          d="M648.5 300.27a5 5 0 0 1 .66.73s0-.15 0-.19a5 5 0 0 0-.66-.73s0 .16 0 .19"
        />
        <path
          id="Bolivia_svg__path6277-9-3"
          d="M646.4 303.19a9 9 0 0 1-.14 1.57 1 1 0 0 0 0 .17 9.2 9.2 0 0 0 .16-1.74q0-.165 0 0"
        />
        <path
          id="Bolivia_svg__path6279-2-0"
          d="M645.29 304.35a8.4 8.4 0 0 1 0 1.42v.13a9.5 9.5 0 0 0 0-1.69z"
        />
        <path
          id="Bolivia_svg__path6281-8-3"
          d="M625.11 291.49s-1.28 4.79-.32 5.27c1.87.95 3.08-3.31 3.25-4.92.19-1.81-2.93-.35-2.93-.35"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6283-8-2"
          d="M625.11 291.49s-1.28 4.79-.32 5.27c1.87.95 3.08-3.31 3.25-4.92.19-1.84-2.93-.35-2.93-.35Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6285-8-0"
          d="M627.87 291.45s-2.43 2.5-2.36 3.89 3.57-1.88 3.88-2.5-1.52-1.39-1.52-1.39"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6287-5-4"
          d="M627.87 291.45s-2.43 2.5-2.36 3.89 3.57-1.88 3.88-2.5-1.52-1.39-1.52-1.39Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6289-9-1"
          d="M586.58 291.8s-5 2.51-5.43 3.59 15.08-1.63 23.61-7.66l-3.46-2.05Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6291-6-3"
          d="M586.58 291.8s-5 2.51-5.43 3.59 15.08-1.63 23.61-7.66l-3.46-2.05Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6293-7-5"
          d="M592.43 292.81s-9 3.29-2.47 3.43c0 0 13-2.72 20-8l-1.75-2.6-15.66 7"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6295-2-2"
          d="M592.49 292.7s-9.11 3.4-2.53 3.54c0 0 13-2.72 20-8l-1.75-2.6Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6297-7-6"
          d="M605.87 283.62s-9.62 4.93-8.54 5.48 7.9-1 11.47-3.19a55 55 0 0 0 5.09-3.47l-4.27-1.18Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6299-2-6"
          d="M605.87 283.62s-9.62 4.93-8.54 5.48 7.9-1 11.47-3.19a55 55 0 0 0 5.09-3.47l-4.27-1.18Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6301-3-8"
          d="M602.23 294.42s-3.43 2.88-3 3.21 7.42-.78 12.89-5.08l-.72-2.55-9.24 4.27"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6303-6-5"
          d="M602.23 294.42s-3.43 2.88-3 3.21 7.42-.78 12.89-5.08l-.72-2.55-9.24 4.27"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6305-4-4"
          d="M596.25 294s-3.3 2.52-2.58 2.73 3.52 2.19 15.87-5.86L611 290l-2.18-3.08-12.58 6.9"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6307-7-1"
          d="M596.24 293.87s-3.29 2.63-2.57 2.84 3.52 2.19 15.87-5.86L611 290l-2.18-3.08Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6309-1-4"
          d="M593.7 284.39c-10.39 3.63-20.81 10.87-20.81 10.87 1-.34 26.74-10.7 26.74-10.7"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6313-6-4"
          d="M616.5 300.61s-2.23 3.4-1.78 3.82 3.18 1.73 6.37-2.64-3-3.67-3-3.67Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6315-9-0"
          d="M616.5 300.61s-2.23 3.4-1.78 3.82 3.18 1.73 6.37-2.64-3-3.67-3-3.67Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6337-3-3"
          d="M618.92 303s-1.53 3.54-.7 3.88 2.93-.2 4.72-3.39-.83-1.6-.83-1.6Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6317-8-9"
          d="M614 297.77s-3.38 4.09-2.68 4.65 4.53.48 7.39-3.54.07-.21.07-.21L618 295l-4 2.56"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6339-5-4"
          d="M618.92 303s-1.53 3.54-.7 3.88 2.93-.2 4.72-3.39-.83-1.6-.83-1.6Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6319-5-1"
          d="M614 297.77s-3.38 4.09-2.68 4.65 4.53.48 7.39-3.54.07-.21.07-.21L618 295l-4 2.56"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6321-1-7"
          d="M610.77 295.69s-3.25 3.88-2.93 4.51 4.71.41 8.34-3.4.7-5.2.7-5.2l-6 3.88"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6323-0-7"
          d="M610.77 295.69s-3.25 3.88-2.93 4.51 4.71.41 8.34-3.4.7-5.2.7-5.2l-6 3.88"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6325-3-5"
          d="m605 296-2.1 2.77s.57 2.7 7.7-2.22 6.75-4.51 6.75-4.51l-3.82-.69-8.6 4.44"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6327-9-7"
          d="m605 295.86-2.07 2.88s.57 2.7 7.7-2.22 6.75-4.51 6.75-4.51l-3.82-.69Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6329-5-8"
          d="m582.28 291.72-4.52 2s-1 .9 1.64 1 8.14-.66 17.68-6.08a48.5 48.5 0 0 0 7-4.78l-3.47-1.29Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6331-1-1"
          d="m582.28 291.72-4.52 2s-1 .9 1.64 1 8.14-.66 17.68-6.08a48.5 48.5 0 0 0 7-4.78l-3.47-1.29Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6333-6-4"
          d="M574.54 294.57s6.51-.71 9.09-2.4c0 0-.53.79 2.8-.51 0 0-1.66 3 8-2.93s.08-.12.08-.12l10.78-6.17-.63-1.23s-20.59 8.82-22.15 9.31-8 4.05-8 4.05"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6335-5-1"
          d="m594.51 288.67 10.82-6.23-.63-1.23s-20.59 8.82-22.15 9.31-8 4.05-8 4.05 6.51-.71 9.09-2.4c0 0-.53.79 2.8-.51-.01 0-1.63 2.92 8.07-2.99Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6341-5-4"
          d="M621.79 302.89s-.64 5.16.13 5.35 2.93-1.43 3.82-4.59-3.5-2.76-3.5-2.76l-.64 1.81"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6343-6-6"
          d="M621.79 302.89s-.64 5.16.13 5.35 2.93-1.43 3.82-4.59-3.5-2.76-3.5-2.76l-.64 1.81"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6345-5-5"
          d="M625.16 305.26s-.38 3.61.13 3.95 1.79.49 3.31-2.49.83-1.88.83-1.88L626 303l-.83 1.94"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6347-3-6"
          d="M625.16 305.09s-.38 3.78.13 4.12 1.79.49 3.31-2.49.83-1.88.83-1.88L626 303Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6349-1-8"
          d="M626.12 298.53s-2.8 6.11-1.21 6 3.76-4.65 4.08-5.69-2.87-.35-2.87-.35"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6351-6-1"
          d="M626.12 298.53s-2.8 6.11-1.21 6 3.76-4.65 4.08-5.69-2.87-.31-2.87-.31Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6353-9-0"
          d="M625.88 298.48s-1.06 6.72.45 6.16 2.35-5.64 2.38-6.74-2.83.58-2.83.58"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6355-0-2"
          d="M625.88 298.48s-1.06 6.72.45 6.16 2.35-5.64 2.38-6.74-2.83.58-2.83.58Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6357-9-6"
          d="M628.16 299.16s-1.66 5.2-.07 6.24 2.87-5.13 2.93-6.52-2.86.28-2.86.28"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path6359-7-2"
          d="M628.16 299.16s-1.66 5.2-.07 6.24 2.87-5.13 2.93-6.52-2.86.28-2.86.28Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6363-2-0"
          d="M621.63 297.44s-1.59 4.79-.64 5.28c1.87.95 3.4-3.32 3.57-4.93.19-1.79-2.93-.35-2.93-.35Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6367-4-4"
          d="M609.75 287.57s-4.27 3.54-3.76 4.1 5.48-.42 7.71-1.95a29 29 0 0 0 3.12-2.35L613 285Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6371-5-0"
          d="M613.51 284s-2.74 2.22-2.23 2.77 5.41-1.45 6.3-2.43a2.9 2.9 0 0 0 .83-2Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6375-8-6"
          d="M616.31 283.62s-3.69 3.05-2.8 4.16 6-3.81 6.75-4.44-4.33.14-4.33.14"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6379-1-9"
          d="m614.66 282.23-7.46 3.54s-6.3 4.09-5.67 4.51 5.55-.9 9.05-2.64A57 57 0 0 0 618 283"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6383-8-4"
          d="M616.73 286.26s-8.06 6.93-6.85 7.63 6.6-2.21 10.23-5.54"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6387-4-2"
          d="M617.75 288.54s-4.56 7.7-4 8.47 3.82-1.81 5.48-3.75a24.4 24.4 0 0 0 3-4.81"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6391-0-3"
          d="M620.38 289.22s-5 9.19-4.37 9.95 3.43.14 5.15-3.46a13.4 13.4 0 0 0 1.58-5.94Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6395-8-4"
          d="M623.25 289.66s-5.5 11.34-4.41 12.45 7.16-8.6 7.44-10c.49-2.41-3.09-2.69-3.09-2.69"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6399-7-6"
          d="M611.66 282.16s-5 2.36-3.95 2.85 5.67-1.6 6.31-1.81-2.36-1.04-2.36-1.04Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6403-8-4"
          d="M612.43 282.93s-3.06 2.42-2.42 3.05 5.28-1.87 6.17-2.64-3.75-.41-3.75-.41Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6407-3-1"
          d="M618.84 283.12s-4.18 5.62-2.9 5.84 6.14-3.62 6.2-4.29-3.3-1.55-3.3-1.55Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6411-2-9"
          d="M620.71 284.38s-4.46 5.62-3.19 6 1.4-.56 1.4-.56 3.51-2.91 3.76-3.67-1.85-1.81-1.85-1.81"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6415-9-1"
          d="M622.11 285.7s-3.25 5.62-2.42 6 2.16-1 3.5-2.71-1.08-3.29-1.08-3.29Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6419-5-0"
          d="M622.94 288.27s-1.92 3.53-1.41 4.64 2.36-.83 3.25-2.08-1.84-2.56-1.84-2.56Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6423-7-4"
          d="M623.74 298.09s-1.28 4.78-.32 5.27c1.87.95 3.08-3.32 3.25-4.93.19-1.8-2.93-.34-2.93-.34Z"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6429-1-1"
          d="M632.49 291.61a9 9 0 0 0-2.23-.41s-2.8-2.22-4.33-2.43-.22-.24-.22-.24-.16-3.64-.61-3.92c0 0-.25-3.75-2.61-4s-7.64.21-8.6-.14-3.88-1.57-9.43-.07-16.83 6.54-17.4 6.68 12.82-2.94 16.58-4.6a41 41 0 0 0 4.9-.62s-4.27 2.08-.32 1.17 3.06 0 3.06 0-.38.91 1.85.42 2.23 0 2.23 0a6 6 0 0 0 4.52-.28s1 3.54 2.29 4c0 0 1.51 3.24 4.7 3.86 0 0 1.51 1.07 1.83 1.28l1.8.59 1.93-1.5"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6433-0-8"
          d="M606.37 282s-12.73 4.57-12.29 5.82 13.31-3.54 15.35-4.85-2.86-1-2.86-1"
          className="Bolivia_svg__cls-23"
        />
        <path
          id="Bolivia_svg__path6735-8-5"
          d="M641.64 291.9a2.9 2.9 0 0 1 .8.31s.12.07.14.05-.08-.12-.09-.13a2.2 2.2 0 0 0-.54-.4 3.5 3.5 0 0 0-1-.41c-.07 0 .2.25.22.26a1.26 1.26 0 0 0 .5.32"
        />
        <path
          id="Bolivia_svg__path6737-9-7"
          d="M631.72 301.51c.19.37.22.79.41 1.15v-.19c-.18-.36-.21-.78-.4-1.14v.18"
        />
        <path
          id="Bolivia_svg__path6739-7-0"
          d="M633.45 291.7a6 6 0 0 1 1.32-.2.45.45 0 0 0 0-.2 6.6 6.6 0 0 0-1.32.21s0 .19 0 .19"
        />
        <path
          id="Bolivia_svg__path6741-4-2"
          d="M636 291.5a2.9 2.9 0 0 1 1.27-.21s0-.19 0-.19a2.9 2.9 0 0 0-1.27.2s0 .19 0 .2"
        />
        <path
          id="Bolivia_svg__path6743-7-5"
          d="M631.57 293.74c-.05 0-.05.06-.06.1a.7.7 0 0 0 0 .14v-.2"
        />
        <path
          id="Bolivia_svg__path6745-4-7"
          d="M631.31 300.59a8 8 0 0 0 .05 1.07.7.7 0 0 0 0-.14 7 7 0 0 1 0-.9q0-.165 0 0"
        />
        <path
          id="Bolivia_svg__path6811-7-8"
          d="M633.88 320.84s-1.44 1.12-1.6 1.64a6 6 0 0 0-.21 1s1.29-.15 1.13.56c0 0 .42.24 1.09-1.31s1.29-2.21 1.76-2.16a2.66 2.66 0 0 1 1.37.82 1.21 1.21 0 0 0 1.25.42s-.55-.84-.2-1a2 2 0 0 1 .87-.15 2.05 2.05 0 0 0-1.38-1.19c-.94-.15-1.6-.42-1.37-.83S638 315 638 315l-1.6-2.35-.64 2s.2 1.21.21 1.52a17 17 0 0 1-1.44 3.11c-.18.15-3.61 1.48-4 1.61s-1.26 1.15-1.26 1.15l-.1.76s.58-.47.76-.19c0 0 .4-.5.76-.31s.3.26.3.26a3.7 3.7 0 0 0 .75-.63c.11-.2.14-.18.14-.18s.32-.08.79-.16"
          className="Bolivia_svg__cls-33"
        />
        <path
          id="Bolivia_svg__path6813-9-3"
          d="M633.88 320.84s-1.44 1.12-1.6 1.64a6 6 0 0 0-.21 1s1.29-.15 1.13.56c0 0 .42.24 1.09-1.31s1.29-2.21 1.76-2.16a2.66 2.66 0 0 1 1.37.82 1.21 1.21 0 0 0 1.25.42s-.55-.84-.2-1a2 2 0 0 1 .87-.15 2.05 2.05 0 0 0-1.38-1.19c-.94-.15-1.6-.42-1.37-.83S638 315 638 315l-1.6-2.35-.64 2s.2 1.21.21 1.52a17 17 0 0 1-1.44 3.11c-.18.15-3.61 1.48-4 1.61s-1.26 1.15-1.26 1.15l-.1.76s.58-.47.76-.19c0 0 .4-.5.76-.31s.3.26.3.26a3.7 3.7 0 0 0 .75-.63c.11-.2.14-.18.14-.18s.32-.08.79-.16"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6815-1-8"
          d="M643.68 313.76s.05 2.7.05 3.21a3.44 3.44 0 0 1-.34 1.7 1.21 1.21 0 0 1-1 .69c-.47 0-1.68-.06-1.91.38s-.41.69-.41.69.75-.44.87 0a1 1 0 0 1-.29.82 2.1 2.1 0 0 0 1.33-.25 2.36 2.36 0 0 1 1.27-.44.78.78 0 0 1 .52.31 7 7 0 0 1 .12 1.52c-.06.56-.17 1.7.46 1.7 0 0 .23-.57.47-.63s.86.56.75.75a6 6 0 0 0-.12-1.89 10.4 10.4 0 0 1-.35-1.45 11.8 11.8 0 0 1 2.15.95c.17.25.63.69.8.63s0-.63.35-.76a.43.43 0 0 1 .52.19 4.16 4.16 0 0 0-1.44-1.76c-.87-.44-1.45-.44-1.8-.82a2.17 2.17 0 0 1-.46-1.26c-.06-.44 0-4.25 0-4.25l-1.47-.29"
          className="Bolivia_svg__cls-33"
        />
        <path
          id="Bolivia_svg__path6817-9-8"
          d="M643.71 313.56v3.41a3.44 3.44 0 0 1-.34 1.7 1.21 1.21 0 0 1-1 .69c-.47 0-1.68-.06-1.91.38a6 6 0 0 1-.41.69s.75-.44.87 0a.93.93 0 0 1-.29.82 2.1 2.1 0 0 0 1.33-.25 2.36 2.36 0 0 1 1.27-.44.78.78 0 0 1 .52.31 7 7 0 0 1 .12 1.52c-.06.56-.17 1.7.46 1.7 0 0 .23-.57.47-.63s.86.56.75.75a6 6 0 0 0-.12-1.89 10.4 10.4 0 0 1-.35-1.45 11.8 11.8 0 0 1 2.15.95c.17.25.63.69.8.63s0-.63.35-.76a.43.43 0 0 1 .52.19 4.16 4.16 0 0 0-1.44-1.76c-.87-.44-1.45-.44-1.8-.82a2.17 2.17 0 0 1-.46-1.26c-.06-.44 0-4.25 0-4.25z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6819-9-5"
          d="M631.6 296s-.19-1.93.35-2.14c0 0 .19-1.77 2.55-1.52a1.57 1.57 0 0 1 2.07-.63s1.21-.59 1.91-.24a7.4 7.4 0 0 1 1.63 1.07 2.26 2.26 0 0 1 1.49.18c.48.38.26 1.63.26 1.63s1.14.87 1.24 1.65.09 1.09-.16 1.29a1.18 1.18 0 0 1 .41 1 3.3 3.3 0 0 1-.66 1.45c-.1 0 .06 1.53-.45 2a2.54 2.54 0 0 1-1.21.7c-.22.07-.8.9-1.34 1s-1.27-.83-1.34-1.11-.79-.59-.79-.59-1.66 1.77-2.77 1.49a2.83 2.83 0 0 1-1.75-1.38c-.1-.18-.42-1.46-.42-1.46s-1.24-.73-1.14-1.42a4.9 4.9 0 0 1 .6-1.53Z"
          className="Bolivia_svg__cls-34"
        />
        <path
          id="Bolivia_svg__path6821-2-7"
          d="M635.74 317.91a.41.41 0 0 1-.35-.06"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6823-8-2"
          d="M636.29 316.51a1 1 0 0 1-.47-.17"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6825-2-6"
          d="M635.72 317.23a.63.63 0 0 0 .36.07"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6827-6-3"
          d="M634.55 319.42a.5.5 0 0 0 .24.09"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6829-3-5"
          d="M644.43 318.1c.23 0 .45.17.69.19"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6831-2-4"
          d="M644.83 317.41a.42.42 0 0 1-.46-.13"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6833-9-2"
          d="M645 316.59a1.25 1.25 0 0 1-.64-.06"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6835-2-1"
          d="M644.14 319.36c.22 0 .42.14.64.19"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6837-6-6"
          d="M644.2 320.24a.35.35 0 0 1 .29.07"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6839-9-7"
          d="M644.37 322.64a.57.57 0 0 1 .41.06"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6841-03-7"
          d="M637.14 319.54a.51.51 0 0 0-.4.32"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6843-85-2"
          d="M638.32 319.66a.87.87 0 0 0-.51.64"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6845-5-1"
          d="M631 321c.2.18.49.29.66.45"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6847-90-8"
          d="M646.51 320a.54.54 0 0 0-.29.38"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6849-2-4"
          d="M647.32 320.24a.3.3 0 0 0-.17.26"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6851-2-5"
          d="m629.18 322.61.82-.21h.08s-.54 1.05-.39 1.3-.74-.46-.51-1.12"
          className="Bolivia_svg__cls-35"
        />
        <path
          id="Bolivia_svg__path6853-2-8"
          d="m629.18 322.61.82-.21h.08s-.54 1.05-.39 1.3-.69-.43-.51-1.09Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6855-3-8"
          d="M632.32 323.23s-.92 1.52.27 2.29c0 0-.07-1.43.85-1.73Z"
          className="Bolivia_svg__cls-35"
        />
        <path
          id="Bolivia_svg__path6857-3-8"
          d="M632.32 323.23s-.92 1.52.27 2.29c0 0-.07-1.43.85-1.73Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6859-0-9"
          d="m638.38 321.81-.28-.83.33-.43h.64l.28.13s.52 1.19.06 1.81c0 0-.19-.67-.41-.76 0 0-.48-.08-.62.09"
          className="Bolivia_svg__cls-35"
        />
        <path
          id="Bolivia_svg__path6861-7-6"
          d="m638.38 321.81-.28-.83.33-.43h.64l.28.13s.52 1.19.06 1.81c0 0-.19-.67-.41-.76 0-.01-.48-.09-.62.08Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6863-1-5"
          d="M640.41 320.06h.59l.21.51-.08.47-.47.21s-.77-.19-.58.72c0 0-.36-1.68.38-1.91"
          className="Bolivia_svg__cls-35"
        />
        <path
          id="Bolivia_svg__path6865-4-1"
          d="M640.41 320.06h.59l.21.51-.08.47-.47.21s-.77-.19-.58.72c-.08.03-.41-1.68.33-1.91Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6867-6-8"
          d="m644.24 323.84.56-.62.6.32a16 16 0 0 1-.34 1.75c-.1.13-.12.14-.12.19a2.2 2.2 0 0 0-.27-.51 11 11 0 0 1-.43-1.13"
          className="Bolivia_svg__cls-35"
        />
        <path
          id="Bolivia_svg__path6869-0-0"
          d="m644.24 323.84.56-.62.6.32a16 16 0 0 1-.34 1.75c-.1.13-.12.14-.12.19a2.2 2.2 0 0 0-.27-.51 11 11 0 0 1-.43-1.13Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6871-7-0"
          d="M647.89 322.2s.9 1.12.79 1.49c0 0 .93-.94-.27-2.27Z"
          className="Bolivia_svg__cls-35"
        />
        <path
          id="Bolivia_svg__path6873-7-8"
          d="M647.89 322.2s.9 1.12.79 1.49c0 0 .93-.94-.27-2.27Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path6875-1-3"
          d="M643.92 293.83a.56.56 0 0 1 .36.36v-.06a.5.5 0 0 0 0-.12.52.52 0 0 0-.36-.37s0 .19 0 .19"
        />
        <path
          id="Bolivia_svg__path6877-9-0"
          d="M644.13 297a2.44 2.44 0 0 1 .6 1s0-.13 0-.18a2.64 2.64 0 0 0-.61-1.05s0 .16 0 .2"
        />
        <path
          id="Bolivia_svg__path6879-5-9"
          d="M643.47 294.66c.27.24.5.52.76.78v-.19c-.26-.26-.49-.54-.76-.78z"
        />
        <path
          id="Bolivia_svg__path6881-5-1"
          d="M644.22 299.84a2.15 2.15 0 0 1-.2 1.28v.19a2.86 2.86 0 0 0 .2-1.63s0 .13 0 .16"
        />
        <path
          id="Bolivia_svg__path6883-7-7"
          d="M644.93 301.45a1.9 1.9 0 0 1 0 .72v.13s0 .07 0 0a2.9 2.9 0 0 0 0-1v.13"
        />
        <path
          id="Bolivia_svg__path6885-9-3"
          d="M647.68 307.12a7.4 7.4 0 0 1 .2 2q0 .165 0 0a8.3 8.3 0 0 0-.21-2.17s0 .13 0 .18"
        />
        <path
          id="Bolivia_svg__path6887-8-9"
          d="M647.22 308.44a12 12 0 0 1-.5 1.35s0 .16 0 .19a11 11 0 0 0 .51-1.35v-.19"
        />
        <path
          id="Bolivia_svg__path6889-7-1"
          d="M631.88 304.06a20 20 0 0 1 1 1.82s0-.15 0-.19a20 20 0 0 0-1-1.82s0 .15 0 .19"
        />
        <path
          id="Bolivia_svg__path6891-1-8"
          d="M634.57 304.13c-.39.05-.48-.51-.81-.62v.19c.33.11.42.67.81.62z"
        />
        <path
          id="Bolivia_svg__path6893-4-3"
          d="M633 306.71c.28.49.47 1 .77 1.5v-.18c-.3-.48-.48-1-.76-1.51v.19"
        />
        <path
          id="Bolivia_svg__path6895-6-5"
          d="M634.82 307.33a3.9 3.9 0 0 1 .76 1.25s0-.14 0-.19a4.1 4.1 0 0 0-.76-1.25s0 .15 0 .19"
        />
        <path
          id="Bolivia_svg__path6897-3-9"
          d="M634.67 309.2c.16.33.3.66.46 1v-.19c-.16-.33-.3-.66-.45-1v.19"
        />
        <path
          id="Bolivia_svg__path6899-8-1"
          d="M636.35 309.56a4.2 4.2 0 0 1 .14 1.05q0 .165 0 0a4.6 4.6 0 0 0-.16-1.23s0 .13 0 .18"
        />
        <path
          id="Bolivia_svg__path6901-6-3"
          d="M635.63 311.11a5 5 0 0 0 .51 1.41s0-.14 0-.18a4.9 4.9 0 0 1-.51-1.4s0 .13 0 .17"
        />
        <path
          id="Bolivia_svg__path6903-8-7"
          d="M636 304.53c.41.15.81.31 1.22.42v-.2c-.41-.11-.81-.26-1.22-.41z"
        />
        <path
          id="Bolivia_svg__path6905-5-6"
          d="M636.35 306.24c.48.27 1 .48 1.47.73v-.19c-.49-.25-1-.46-1.47-.73z"
        />
        <path
          id="Bolivia_svg__path6907-8-6"
          d="M636.81 308.16a7 7 0 0 0 .81.84s0-.17 0-.2a7 7 0 0 1-.81-.83s0 .15 0 .19"
        />
        <path
          id="Bolivia_svg__path6909-0-7"
          d="M637.31 310.55a2.56 2.56 0 0 1 .36 1.08v-.14a2.85 2.85 0 0 0-.36-1.1s0 .15 0 .19"
        />
        <path
          id="Bolivia_svg__path6911-0-0"
          d="M638.73 304.62c0 .23.1.46.16.68v-.18l-.15-.67v.13"
        />
        <path
          id="Bolivia_svg__path6913-2-3"
          d="M642.29 303.2a6 6 0 0 1-.35.72v.19a4.5 4.5 0 0 0 .36-.73v-.18"
        />
        <path
          id="Bolivia_svg__path6915-2-8"
          d="M643.76 303.13a5.5 5.5 0 0 1-.1 1.22s0 .18 0 .17a6 6 0 0 0 .11-1.39q0-.165 0 0"
        />
        <path
          id="Bolivia_svg__path6917-3-0"
          d="M644.07 305.38a4 4 0 0 1-.05 1.05.6.6 0 0 0 0 .16 5.5 5.5 0 0 0 .05-1.34z"
        />
        <path
          id="Bolivia_svg__path6919-6-1"
          d="M645.19 307.52a2 2 0 0 1-.71 1.18s0 .17 0 .19a2 2 0 0 0 .72-1.21s0-.18 0-.16"
        />
        <path
          id="Bolivia_svg__path6921-4-9"
          d="M641.58 305.43c-.1.2-.23.38-.35.57v.19c.12-.19.26-.37.36-.57a.5.5 0 0 0 0-.12v-.07"
        />
        <path
          id="Bolivia_svg__path6923-2-6"
          d="M642 308.28a2.5 2.5 0 0 1-.51.57s0 .18 0 .2a3 3 0 0 0 .51-.57.2.2 0 0 0 0-.1z"
        />
        <path
          id="Bolivia_svg__path6925-9-6"
          d="M640.72 309.79a1.73 1.73 0 0 1-.5-1.84v-.18a2.15 2.15 0 0 0 .51 2.21s0-.15 0-.19"
        />
        <path
          id="Bolivia_svg__path6927-1-0"
          d="M639 308.2a1.9 1.9 0 0 1 0 .86.6.6 0 0 0 0 .19 3.1 3.1 0 0 0 0-1.21.3.3 0 0 0 0 .13"
        />
        <path
          id="Bolivia_svg__path6929-8-6"
          d="M642.9 310.1a6 6 0 0 1-.45 1v.19a7.4 7.4 0 0 0 .46-1v-.19"
        />
        <path
          id="Bolivia_svg__path6931-1-6"
          d="M645.39 311.14a11 11 0 0 1-.71 1.09s0 .17 0 .19c.25-.36.49-.71.71-1.09z"
        />
        <path
          id="Bolivia_svg__path6933-0-2"
          d="M646.61 312.45c-.1.66-.15 1.34-.21 2v.09c.05-.64.1-1.29.2-1.93a.7.7 0 0 0 0-.17"
        />
        <path
          id="Bolivia_svg__path6935-8-7"
          d="M648.18 310.12c0 .22.05.45.05.67v-.72.05"
        />
        <path
          id="Bolivia_svg__path6937-2-2"
          d="M631.47 302.79a4 4 0 0 0 .2 1.94s0-.13 0-.18a3.2 3.2 0 0 1-.2-1.59s0-.18 0-.17"
        />
        <path
          id="Bolivia_svg__path6955-0-2"
          d="M637.23 294.52c1.07-1 2.49-2 4-1.66v-.19c-1.52-.37-2.94.67-4 1.66z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6957-3-8"
          d="M642.39 295.69c-1.08-.73-3-1-4-.1v.2a3.6 3.6 0 0 1 4 .1s0-.17 0-.2"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6959-0-5"
          d="M638.27 297.35a9.56 9.56 0 0 1 .77 4.41s0 .18 0 .16a10.4 10.4 0 0 0-.77-4.76s0 .13 0 .19"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6961-9-2"
          d="M636.55 298.21a17.2 17.2 0 0 1 0 4.36v.1a18.8 18.8 0 0 0 0-4.62.6.6 0 0 0 0 .16"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6963-2-1"
          d="M638.85 297.15a5.77 5.77 0 0 1 3.53 2.54s0-.14 0-.19a5.75 5.75 0 0 0-3.54-2.54s0 .19 0 .19"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6965-0-4"
          d="M637.6 299.11a9 9 0 0 1-.19 2.64v.18a9.5 9.5 0 0 0 .2-2.82q0-.165 0 0"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6967-6-5"
          d="M639.81 298.91a4.73 4.73 0 0 1 1.71 3v-.14a4.72 4.72 0 0 0-1.73-3s0 .16 0 .19"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6969-5-0"
          d="M633.31 301.35a2.7 2.7 0 0 1 1.15-1.07s0-.19 0-.2a2.66 2.66 0 0 0-1.15 1.08s0 .17 0 .19"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6971-4-9"
          d="M635.41 293.75a2.9 2.9 0 0 0-1.42-1.69s0 .15 0 .18a2.88 2.88 0 0 1 1.42 1.68s0-.12 0-.17"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6973-5-0"
          d="M634.17 293.74a5.16 5.16 0 0 0-2.29-.39s0 .19 0 .19a5.16 5.16 0 0 1 2.29.39s0-.17 0-.19"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6975-8-1"
          d="M636.47 293.62a1.93 1.93 0 0 0-.68-2s0 .15 0 .17a1.62 1.62 0 0 1 .67 1.64s0 .16 0 .15"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6977-4-0"
          d="M639.23 294.52a4.34 4.34 0 0 1 2.2-.29.7.7 0 0 0 0-.2 4.46 4.46 0 0 0-2.2.3s0 .18 0 .19"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6979-3-5"
          d="M640.47 296.37a3.9 3.9 0 0 1 2.58 1.47c0-.06.08-.31 0-.39a3.9 3.9 0 0 0-2.58-1.46s0 .38 0 .38"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6981-8-0"
          d="M635.79 299.31c-.25 1-.06 2.31-1.24 2.73-.06 0 0 .38 0 .38 1.19-.42 1-1.71 1.25-2.74v-.37"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6983-2-6"
          d="M638.27 298.51a6.3 6.3 0 0 1 .76 3.36 1.3 1.3 0 0 0 0 .33 7.3 7.3 0 0 0-.77-4.06v.37"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6985-3-2"
          d="M639.81 298.32a2.55 2.55 0 0 1 2.09 2.13v-.07a1.2 1.2 0 0 0 0-.27 2.56 2.56 0 0 0-2.11-2.17s0 .38 0 .38"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6987-8-8"
          d="M639.8 299.86a5.15 5.15 0 0 1 .1 2.67v.38a6.57 6.57 0 0 0-.09-3.38.9.9 0 0 0 0 .33"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6989-2-8"
          d="M639.23 296a4.16 4.16 0 0 1 3.35.39s.07-.33 0-.38a4.12 4.12 0 0 0-3.35-.4s0 .39 0 .39"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6991-6-5"
          d="M637.14 293.71a2.65 2.65 0 0 1 1.81-1.93c.06 0 0-.38 0-.38a2.65 2.65 0 0 0-1.83 2 2 2 0 0 0 0 .26v.07"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6993-3-8"
          d="M636.1 294.28a6.74 6.74 0 0 0-.94-2.81s0 .25 0 .33a6.2 6.2 0 0 1 .91 2.57v-.09"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6995-5-9"
          d="M635.13 294.84a2.93 2.93 0 0 0-1.63-2s-.07.35 0 .39a2.84 2.84 0 0 1 1.61 1.93 1 1 0 0 0 0-.34"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6997-2-7"
          d="M633.6 294.47a4.1 4.1 0 0 0-1.75-.82s0 .29 0 .3a4.3 4.3 0 0 1 1.75.82s0-.26 0-.3"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path6999-9-7"
          d="M636.93 298.85a4.93 4.93 0 0 1-.28 2.9v.37a6.1 6.1 0 0 0 .29-3.54v.27"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7001-7-7"
          d="M638.08 298.32a7.6 7.6 0 0 1 .66 2.93v.2a8.7 8.7 0 0 0-.68-3.51c0 .06-.05.27 0 .38"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7003-1-5"
          d="M638.85 297a5.4 5.4 0 0 1 2.58 1.36c0-.05.07-.3 0-.38a5.3 5.3 0 0 0-2.58-1.37s-.06.37 0 .39"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7005-0-9"
          d="M636.28 294.85a23 23 0 0 0 .2-2.48q0-.33 0 0a18 18 0 0 1-.18 2.21v.27"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7007-7-6"
          d="M634.55 294.33a8.7 8.7 0 0 1-1.91-1.27s-.08.32 0 .39a8.3 8.3 0 0 0 1.91 1.26s.07-.35 0-.38"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7009-2-4"
          d="M634.26 299.3a2.47 2.47 0 0 0-1 1.18 1 1 0 0 0 0 .24v.14a2.4 2.4 0 0 1 1-1.17c.08-.05 0-.37 0-.39"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7011-1-1"
          d="M635.49 300a2.62 2.62 0 0 1-.84 1.71c-.08.08 0 .34 0 .39a2.88 2.88 0 0 0 .87-2v-.1"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7013-5-3"
          d="M638.7 294.69c.56-.89 1.92-1 2.83-1.22.06 0 0-.38 0-.38-.92.25-2.27.32-2.84 1.22-.06.09 0 .34 0 .38"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7015-6-6"
          d="M632.43 294.67a2.5 2.5 0 0 1-.62-.29s0 .22 0 .24a3 3 0 0 0 .62.29s0-.23 0-.24"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7017-3-3"
          d="M632.55 299.23a1.16 1.16 0 0 0-.53.34s0 .14 0 .19v.19a1.2 1.2 0 0 1 .53-.33s0-.17 0-.2a1 1 0 0 0 0-.19"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7019-9-3"
          d="M633.38 299.44a2.4 2.4 0 0 0-1 .89v.29a2.5 2.5 0 0 1 1-.88s0-.29 0-.3"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7021-8-1"
          d="M634.94 299.83c-.36.86-1.32 1.81-.62 2.77 0 0 .07-.29 0-.37-.48-.67.37-1.42.62-2v-.37"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7023-4-7"
          d="M636 299.81a13.4 13.4 0 0 1-.28 2.6 1 1 0 0 0 0 .34 15.5 15.5 0 0 0 .29-3v.1"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7025-3-4"
          d="M638.86 298.78a8 8 0 0 1 1.47 2.77 2.3 2.3 0 0 0 0-.38 7.9 7.9 0 0 0-1.48-2.78c0 .06-.07.3 0 .39"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7027-8-7"
          d="M639.18 298.1a11.7 11.7 0 0 1 3 2.69s.06-.29 0-.37a11.6 11.6 0 0 0-3-2.7s-.07.32 0 .38"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7029-3-2"
          d="M639.8 296.72a2.54 2.54 0 0 1 1.13.11 6.7 6.7 0 0 1 .91.58 4.2 4.2 0 0 1 .87.62 2.9 2.9 0 0 1 .42 1.37 1 1 0 0 0 0-.29 8 8 0 0 0-.25-1.08 1.5 1.5 0 0 0-.7-.73l-1-.67a2 2 0 0 0-1.37-.24s0 .33 0 .33"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7031-1-6"
          d="M642.37 298.87c.12.34.26.67.37 1v-.24c-.12-.34-.25-.67-.37-1z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7033-3-6"
          d="M639.43 293.52c.74-.21 1.5-.34 2.23-.59.06 0 0-.39 0-.39-.73.25-1.49.38-2.23.59-.06 0 0 .38 0 .39"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7035-8-5"
          d="M636.35 293.89a3.4 3.4 0 0 1 .49-1.05c.28-.41.32-.93.66-1.3.07-.08 0-.34 0-.39a3.6 3.6 0 0 0-.54 1.09 9 9 0 0 0-.62 1.27v.38"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7037-9-0"
          d="M633.82 300.81a3.35 3.35 0 0 0 .13 1.91v-.37a2 2 0 0 1-.12-1.2 1.2 1.2 0 0 0 0-.27v-.07"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7039-9-6"
          d="M635.35 302a1.55 1.55 0 0 0-.12 1.33v-.13a1 1 0 0 0 0-.23.61.61 0 0 1 .11-.61s0-.13 0-.18V302"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7041-3-0"
          d="M636.49 301.41a2.7 2.7 0 0 1-.36 1v.27a3.1 3.1 0 0 0 .38-1.24v-.07"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7043-8-0"
          d="M636.53 299.26v.65-.85z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7045-1-5"
          d="M636 299.53a1 1 0 0 1 .07.17q0 .12 0 0v.09a.8.8 0 0 0 0 .27v.07a1.6 1.6 0 0 0-.09-1s0 .13 0 .14a.7.7 0 0 0 0 .24"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7047-7-2"
          d="M635.27 299.28a5 5 0 0 0-.17.73 1.2 1.2 0 0 0 0 .27v.07a4 4 0 0 1 .16-.7 1 1 0 0 0 0-.23 1 1 0 0 0 0-.14"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7049-8-0"
          d="M634.69 299.31a4 4 0 0 1-1.27 1c-.07 0 0 .37 0 .39a4 4 0 0 0 1.27-1s0-.14 0-.19z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7051-3-3"
          d="M633.71 299.48a2.4 2.4 0 0 1-.7.38c-.07 0 0 .39 0 .39a2.4 2.4 0 0 0 .7-.38s0-.16 0-.19z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7053-3-0"
          d="m632.31 299.14-.62.26c-.06 0 0 .3 0 .31l.62-.26c.05 0 0-.3 0-.31"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7055-3-8"
          d="M636.57 299a5 5 0 0 0 .09.75v-.07a1.2 1.2 0 0 0 0-.27 3 3 0 0 1-.07-.51s0-.15 0-.14a1 1 0 0 0 0 .24"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7057-0-2"
          d="M637.23 298.67a2.3 2.3 0 0 0 .14.86s0-.12 0-.14a1 1 0 0 0 0-.24 1.3 1.3 0 0 1-.11-.48s0-.2 0-.2v.2"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7059-7-7"
          d="M637.74 298.6a.9.9 0 0 1 .19.45 1 1 0 0 0 0 .14.7.7 0 0 0 0-.24 1.3 1.3 0 0 0-.22-.72s0 .12 0 .13v.24"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7061-3-5"
          d="M638.36 298.36a1.07 1.07 0 0 1 .58.29 1.4 1.4 0 0 1 0-.19v-.2a1.14 1.14 0 0 0-.58-.29s-.05.37 0 .39"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7063-7-2"
          d="M638.69 297.85a1.8 1.8 0 0 0 .87.42s0-.38 0-.39a1.73 1.73 0 0 1-.87-.42s0 .18 0 .2z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7065-0-2"
          d="M639.39 296.17a3.7 3.7 0 0 1 .66.08s.05-.38 0-.39a3.7 3.7 0 0 0-.66-.08.86.86 0 0 0 0 .39"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7067-5-4"
          d="M639.07 295.36a2.1 2.1 0 0 1 .53-.54s0-.16 0-.19v-.2a2.2 2.2 0 0 0-.54.56v.37"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7069-7-8"
          d="M638.45 294.58a1.5 1.5 0 0 1 .28-.69s0-.14 0-.19a1.4 1.4 0 0 1 0-.19 1.6 1.6 0 0 0-.3.74 1 1 0 0 0 0 .26v.07"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7071-4-6"
          d="M638 294.22c.26-.35.43-.76.66-1.13v-.38c-.23.37-.4.78-.66 1.14a.6.6 0 0 0 0 .24z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7073-8-7"
          d="M636.82 293a7 7 0 0 0 .13 1.3v-.07a1.2 1.2 0 0 0 0-.27 5.4 5.4 0 0 1-.12-1.06v.1"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7075-2-1"
          d="M635 293.26a5 5 0 0 0 .23.45c0 .1.09.2.13.3a.4.4 0 0 1 0 .11c0-.08 0-.06 0 0v.37a1.1 1.1 0 0 0 0-.72 6 6 0 0 0-.41-.92v.38"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7077-2-4"
          d="M634.61 294a7.5 7.5 0 0 0-.82-.67 1 1 0 0 0 0 .19v.2a7.5 7.5 0 0 1 .82.67s0-.18 0-.19z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7079-3-3"
          d="M635.82 294.42a4.2 4.2 0 0 0-.21-2.51c0 .06-.06.28 0 .38a2.9 2.9 0 0 1 .2 1.79 1.2 1.2 0 0 0 0 .27v.07"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7081-3-6"
          d="M637.62 293.31a.86.86 0 0 0 0-.39.86.86 0 0 0 0 .39"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7083-1-7"
          d="M635.58 294.45c0-.48.16-.95.21-1.43a3 3 0 0 0 0-.41q0-.15 0 0c0 .48-.17.95-.21 1.43a3 3 0 0 0 0 .41q0 .15 0 0"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7085-8-0"
          d="M640.79 297.44a1.7 1.7 0 0 1 1 .83s0-.18 0-.2a1.1 1.1 0 0 0 0-.36 1.73 1.73 0 0 0-1-.85s-.09.55 0 .58"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7087-9-0"
          d="M639.38 300.34a1.5 1.5 0 0 1 0 .73 1.3 1.3 0 0 0 0 .39v.11a4 4 0 0 0-.05-1.79s0 .17 0 .2a1.5 1.5 0 0 0 0 .36"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7089-9-4"
          d="M638.21 299.55a7 7 0 0 1-.07 1.43 1.3 1.3 0 0 0 0 .4v.1a9.5 9.5 0 0 0 .1-1.93s0-.29 0-.29v.29"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7091-3-3"
          d="M637.61 300.07c-.16.64-.33 1.28-.46 1.92a1.8 1.8 0 0 0 0 .4v.1c.13-.62.29-1.24.45-1.86a5 5 0 0 0 0-.56"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7093-0-9"
          d="M638.41 300.48a13 13 0 0 1 0 1.64 3 3 0 0 0 0 .41q0 .15 0 0a16 16 0 0 0 0-2v-.29.29"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7095-4-2"
          d="M634.56 300.77v-.1.11a1 1 0 0 1-.08.17.9.9 0 0 0 0 .36v.2a2 2 0 0 0 .14-1.24v.1a1.8 1.8 0 0 0 0 .4"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7097-1-0"
          d="M636.25 299.62a1.3 1.3 0 0 1 .11.65s0 .29 0 .29v-.29a2.5 2.5 0 0 0-.14-1.21s0 .18 0 .2a1.1 1.1 0 0 0 0 .36"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7099-9-9"
          d="M636.71 299.42a.55.55 0 0 1 .16.18v.09s0 .14 0 0a1 1 0 0 0 0 .18s0 .06 0 0a1.1 1.1 0 0 0 0-.36.86.86 0 0 0-.28-.72s0 .09 0 .08v.21a2 2 0 0 0 0 .21v.08"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7101-4-1"
          d="M637.28 298.9c.09.19.2.37.29.55s0-.11 0-.17a2 2 0 0 0 0-.23.3.3 0 0 0 0-.13c-.09-.18-.19-.36-.28-.55v.18a2 2 0 0 0 0 .22.5.5 0 0 0 0 .13"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7103-6-0"
          d="M638.56 298.44c.22.32.46.64.71.94v-.58c-.25-.3-.48-.6-.7-.92v.56"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7105-9-1"
          d="M639.22 297.35a7 7 0 0 0 .58.85s0-.26 0-.29v-.29a7 7 0 0 1-.57-.83s0 .18 0 .2a.7.7 0 0 0 0 .36"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7107-7-6"
          d="M632.8 294.42a2.8 2.8 0 0 0-.62-.38 2 2 0 0 0 0 .29v.29a2.8 2.8 0 0 1 .62.38s0-.27 0-.29z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7109-3-3"
          d="M634.81 293.73a1 1 0 0 1 0 .1v.07a1 1 0 0 0 0 .18s0 .06 0 0a1.1 1.1 0 0 0 0-.36 1.4 1.4 0 0 0-.1-.58s0 .11 0 .17a1.1 1.1 0 0 0 0 .36"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7111-0-2"
          d="M636.4 292.22a2.1 2.1 0 0 1-.23 1.12v.56a3.56 3.56 0 0 0 .26-1.83 1 1 0 0 0 0-.21.9.9 0 0 0 0 .36"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7113-3-1"
          d="M636.75 294.37a2.3 2.3 0 0 0 .75-.94.7.7 0 0 0 0-.35 1 1 0 0 0 0-.21 2.23 2.23 0 0 1-.74.92s0 .24 0 .29v.29"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7115-8-3"
          d="M637.74 294.33c.12-.12.22-.26.33-.38a.13.13 0 0 0 0-.09 1.3 1.3 0 0 0 0-.2 2 2 0 0 0 0-.21v-.08c0 .01-.21.26-.33.38a.12.12 0 0 0 0 .08v.21a1.3 1.3 0 0 0 0 .2z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7117-3-2"
          d="M639.23 294.59h-1.12s-.06.57 0 .58h1.12a1.4 1.4 0 0 0 0-.58"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7119-3-6"
          d="M638.9 295.93c.49.29 1 .61 1.48.88 0 0 .11-.52 0-.58-.51-.27-1-.59-1.48-.88 0 0-.11.51 0 .58"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7121-5-2"
          d="M638.94 296.94a10 10 0 0 1 1.32.84s0-.27 0-.29v-.29a10 10 0 0 0-1.32-.84 2 2 0 0 0 0 .29z"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7123-8-8"
          d="M636.1 294.82a2.1 2.1 0 0 0 .06-.66s0-.29 0-.29v.29a.3.3 0 0 1 0 .1 1.5 1.5 0 0 0 0 .36 1 1 0 0 0 0 .17s0 .07 0 0"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7125-1-8"
          d="M632.63 293.28a8 8 0 0 0 1.36 1.18c.35.28.61.75 1 1 0 0 .11-.52 0-.58-.34-.19-.57-.61-.87-.86a10 10 0 0 1-1.47-1.29c.07.09-.11.46 0 .59"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7127-7-4"
          d="M633.46 294.84c-.23-.24-.45-.5-.66-.76v.09a1.4 1.4 0 0 0 0 .2v.3c.21.25.43.51.66.75v-.58"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7129-6-4"
          d="M633 298.68a6 6 0 0 1-.49.83v.58a5.6 5.6 0 0 0 .5-.85.7.7 0 0 0 0-.36v-.2"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7131-8-6"
          d="M633.43 299.26c0 .33-.12.65-.16 1a3 3 0 0 0 0 .41q0 .15 0 0a10 10 0 0 0 .18-1.22 1.5 1.5 0 0 0 0-.36v.2"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7133-1-3"
          d="M635 301.93a9.6 9.6 0 0 0 .23-2.84c0-.4-.06 0-.06.16a6.9 6.9 0 0 1-.19 2.12c0 .17.05.47 0 .56"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7135-4-4"
          d="M635.84 299.7a1.9 1.9 0 0 1 .08.95 1.7 1.7 0 0 0 0 .39v.11a4.4 4.4 0 0 0-.09-2 .8.8 0 0 0 0 .21 1.4 1.4 0 0 0 0 .35"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7137-2-9"
          d="M636.71 299.38a2 2 0 0 1 .39 1.41v.3a3.24 3.24 0 0 0-.44-2.29s0 .26 0 .29v.29"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7139-4-9"
          d="M637 299a18 18 0 0 1 .44 2.53c0 .23.05-.33 0-.41a20 20 0 0 0-.46-2.68 5 5 0 0 0 0 .56"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7141-8-7"
          d="M637.78 298.78a5.5 5.5 0 0 1 .86 1.64s0-.18 0-.2a1.4 1.4 0 0 0 0-.36 5.3 5.3 0 0 0-.87-1.64s-.1.44 0 .56"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7143-6-5"
          d="M639.48 297.38a.82.82 0 0 0-.83-.31c-.06 0 0 .58 0 .58a.84.84 0 0 1 .82.29 1 1 0 0 0 0-.21v-.35"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7145-7-7"
          d="M638.61 297.15a11 11 0 0 1 1.6-.09 1.14 1.14 0 0 0 0-.58 11 11 0 0 0-1.6.09c-.07 0 0 .58 0 .58"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7147-8-9"
          d="M639.6 292.74a4.3 4.3 0 0 0-.8 1.85 1.3 1.3 0 0 0 0 .39v.11a4.15 4.15 0 0 1 .77-1.77v-.58"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7149-7-7"
          d="M637.28 293.24a11 11 0 0 0 .41 1.41s0-.17 0-.2a1.5 1.5 0 0 0 0-.36 13 13 0 0 1-.41-1.36v.11a1.8 1.8 0 0 0 0 .4"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7151-6-3"
          d="M636.84 294.08a2.2 2.2 0 0 1-.45-.79 1 1 0 0 0 0 .18.8.8 0 0 0 0 .35 2.25 2.25 0 0 0 .46.81v-.58"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7153-1-4"
          d="M636.05 294.46a6.2 6.2 0 0 1-1.81-.88c.06 0-.11.49 0 .58a6 6 0 0 0 1.81.88s.09-.55 0-.58"
          className="Bolivia_svg__cls-36"
        />
        <path
          id="Bolivia_svg__path7155-7-8"
          d="M636.77 294.3s-2.57.44-3.24.59a18 18 0 0 1-2.74.31 12 12 0 0 1-1.92-.54c-.57-.12-2.42-.31-3.1.39s-1.1.93-1.32 1.16-1.07 1-1.1 1.33.21.84.64.84 1.32.91 1.32 1.1 1.18.66 2.28.65c2 0 3-1 6-.66 1.63.19 4.63-1.09 5.16-1.86a2.12 2.12 0 0 0 .32-2.48c-.53-.9-2.13-.8-2.27-.83"
          style={{
            fill: "#dba05f",
          }}
        />
        <path
          id="Bolivia_svg__path7157-1-6"
          d="M636.77 294.3s-2.57.44-3.24.59a18 18 0 0 1-2.74.31 12 12 0 0 1-1.92-.54c-.57-.12-2.42-.31-3.1.39s-1.1.93-1.32 1.16-1.07 1-1.1 1.33.21.84.64.84 1.32.91 1.32 1.1 1.18.66 2.28.65c2 0 3-1 6-.66 1.63.19 4.63-1.09 5.16-1.86a2.12 2.12 0 0 0 .32-2.48c-.56-.9-2.16-.8-2.3-.83Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path7159-4-4"
          d="M626 297.17s0 .06 0 0V297s.06 0 .26-.19a2 2 0 0 0 .18-.26 1.26 1.26 0 0 1 .64-.42 2.6 2.6 0 0 1 .81 0s-.89 0-1 .08a2.2 2.2 0 0 1 .92 0s-.82 0-.88.08a1.9 1.9 0 0 1 .83 0h-.18.07-.17.18-.22a1 1 0 0 0-.48.06c-.38.05-.37.58-1 .91"
        />
        <path
          id="Bolivia_svg__path7161-8-9"
          d="M626 297s.29-.1.53-.55c-.07-.12.9-.5 1-.38a3 3 0 0 1 .42 0"
          className="Bolivia_svg__cls-38"
        />
        <path
          id="Bolivia_svg__path7163-7-7"
          d="M626.94 296.11c-.1 0-.6.41-.55.43a.92.92 0 0 1-.42.42"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path7165-2-5"
          d="M627 296.17a2.5 2.5 0 0 1 .8 0"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path7167-0-1"
          d="M626.85 296.35a1.6 1.6 0 0 1 .77-.12"
          className="Bolivia_svg__cls-38"
        />
        <path
          id="Bolivia_svg__path7169-4-5"
          d="m627.6 296.8-.2.16a2 2 0 0 0-.17.15s-.17.14-.36.25-.5.16-.5.21.58-.23.57-.24-.53.13-.54.25c0-.07.53-.21.55-.21s-.49.12-.5.23.07-.07.1-.07h.07s-.1 0-.1.06 0 0 .14-.06a2.1 2.1 0 0 0 1-.61"
        />
        <path
          id="Bolivia_svg__path7171-6-8"
          d="M627.51 296.68a5 5 0 0 1-.44.37 1.2 1.2 0 0 1-.57.27.6.6 0 0 0-.27.17"
          className="Bolivia_svg__cls-38"
        />
        <path
          id="Bolivia_svg__path7173-0-5"
          d="m626.83 297.22.33-.23a4 4 0 0 1 .35-.31"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path7175-9-6"
          d="M626.85 297.27s-.43.09-.5.19"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path7177-6-3"
          d="M627 297.26c0 .06-.48.19-.5.21"
          className="Bolivia_svg__cls-38"
        />
        <path
          id="Bolivia_svg__path7179-5-9"
          d="M628.31 294.73a1.34 1.34 0 0 0-.82-1.12 4.8 4.8 0 0 0-2-.31c-.32 0-.38.18-.78.24a4 4 0 0 0-.82.26s0 0-.22.35-.57.58-.39.93.06.41.28.48-.11-.12-.11-.12-1.37.44-1 1.28.67.53.77.51.78-.37.78-.37l1.11-1s1.31-.51 1.45-.55a6 6 0 0 1 .76 0Z"
          style={{
            fill: "#c6262c",
          }}
        />
        <path
          id="Bolivia_svg__path7181-3-4"
          d="M628.31 294.73a1.34 1.34 0 0 0-.82-1.12 4.8 4.8 0 0 0-2-.31c-.32 0-.38.18-.78.24a4 4 0 0 0-.82.26s0 0-.22.35-.57.58-.39.93.06.41.28.48-.11-.12-.11-.12-1.37.44-1 1.28.67.53.77.51.78-.37.78-.37l1.11-1s1.31-.51 1.45-.55a6 6 0 0 1 .76 0Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path7183-4-5"
          d="M627.31 296.64a.78.78 0 0 1-.46.59c-.25.11-.46 0-.46-.15a.78.78 0 0 1 .46-.59c.26-.12.46-.05.46.15"
        />
        <path
          id="Bolivia_svg__path7185-6-7"
          d="M621.88 300.36s-1.08-1.85 1.9-2.76a4.2 4.2 0 0 1 1.11.83 3 3 0 0 1-2.22 1.1s-.76.22-.79.83"
          className="Bolivia_svg__cls-35"
        />
        <path
          id="Bolivia_svg__path7187-6-2"
          d="M621.88 300.36s-1.08-1.85 1.9-2.76a4.2 4.2 0 0 1 1.11.83 3 3 0 0 1-2.22 1.1s-.76.22-.79.83Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path7189-1-1"
          d="M622.19 300.05a2.84 2.84 0 0 0 2-.33c.66-.49.9-.27 1.07-.23a1.56 1.56 0 0 0-.38-1.06 5.7 5.7 0 0 1-1.46.89c-.63.19-1 .12-1.24.73"
          className="Bolivia_svg__cls-35"
        />
        <path
          id="Bolivia_svg__path7191-2-4"
          d="M622.19 300.05a2.84 2.84 0 0 0 2-.33c.66-.49.9-.27 1.07-.23a1.56 1.56 0 0 0-.38-1.06 5.7 5.7 0 0 1-1.46.89c-.62.19-1.04.12-1.23.73Z"
          className="Bolivia_svg__cls-9"
        />
        <path
          id="Bolivia_svg__path7193-6-0"
          d="M625.52 299.45a3 3 0 0 0 .67-.05s0-.19 0-.19a3 3 0 0 1-.67 0 .7.7 0 0 0 0 .2"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7195-5-6"
          d="M625.1 296.35c-.18 0-.13.22-.24.31a.3.3 0 0 0 0 .1v.09c.11-.09.06-.31.24-.31z"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7197-6-0"
          d="M625.72 296.76a1 1 0 0 1 .44-.33s0-.18 0-.19a.88.88 0 0 0-.44.34s0 .08 0 .12z"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7199-8-9"
          d="M626.52 297.83a.4.4 0 0 0 .36-.17s0-.07 0-.1v-.1a.38.38 0 0 1-.36.18s0 .19 0 .19"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7201-1-6"
          d="M627.15 297.61a1.12 1.12 0 0 0 .57-.5s0-.09 0-.12v-.06a1.14 1.14 0 0 1-.56.48s0 .19 0 .2"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7203-6-7"
          d="M626.16 296.56c-.14.23-.4.35-.56.58v.18c.16-.22.42-.34.57-.57a.5.5 0 0 0 0-.12v-.07"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7205-6-6"
          d="M626.59 299.65a4.4 4.4 0 0 0 1.49-.18s0-.19 0-.19a5 5 0 0 1-1.49.18s0 .19 0 .19"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7207-8-5"
          d="M628.93 299.56a3 3 0 0 0 1.44-1.73v-.19a3.08 3.08 0 0 1-1.44 1.73s0 .18 0 .19"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7209-6-6"
          d="M629.33 298.41a2.3 2.3 0 0 0 1-1.25v-.18a2.35 2.35 0 0 1-1 1.24s0 .18 0 .19"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7211-3-6"
          d="M629.1 295.47a1.48 1.48 0 0 1 1 .49s0-.16 0-.19a1.48 1.48 0 0 0-1-.49s0 .19 0 .19"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7213-6-8"
          d="M638.5 296.94a1.93 1.93 0 0 0-.24-2.09s0 .14 0 .18a1.53 1.53 0 0 1 .24 1.72s0 .17 0 .19"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7215-9-3"
          d="M631.33 296c.41.3 1.56 1.07 1.24 1.69v.19c.43-.86-.68-1.66-1.25-2.08v.2"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7217-2-4"
          d="M634.55 299.09a2 2 0 0 0 .11-.55v-.14a1.6 1.6 0 0 1-.09.5.3.3 0 0 0 0 .12 1 1 0 0 0 0 .07"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7219-7-6"
          d="M635.79 298.79a2 2 0 0 0 .74-.34"
          className="Bolivia_svg__cls-41"
        />
        <path
          id="Bolivia_svg__path7221-5-7"
          d="M623.84 298.09c-.48.29-1.25.3-1.4 1 .15-.67.92-.67 1.41-1v-.05"
          className="Bolivia_svg__cls-41"
        />
        <path
          id="Bolivia_svg__path7223-1-6"
          d="M623.52 295.93c.21 0 .45.12.42.38a.3.3 0 0 0 0 .13 1 1 0 0 0 0-.48.41.41 0 0 0-.4-.22s0 .19 0 .19"
          className="Bolivia_svg__cls-42"
        />
        <path
          id="Bolivia_svg__path7225-6-3"
          d="M624.52 296.32a1 1 0 0 0-.09-.87s0 .15 0 .19a.52.52 0 0 1 .1.49v.19"
          className="Bolivia_svg__cls-42"
        />
        <path
          id="Bolivia_svg__path7227-8-2"
          d="M625.34 295.46a1.19 1.19 0 0 0-.49-.89s0 .17 0 .19a1.14 1.14 0 0 1 .48.87v-.13"
          className="Bolivia_svg__cls-42"
        />
        <path
          id="Bolivia_svg__path7229-1-7"
          d="M626.05 295.29a.89.89 0 0 0-.24-.87s0 .17 0 .2a.56.56 0 0 1 .23.5v.13s0 .07 0 0"
          className="Bolivia_svg__cls-42"
        />
        <path
          id="Bolivia_svg__path7231-1-8"
          d="M624.85 294.23c.7-.36 2.13-.52 2.68.19v-.19c-.55-.71-2-.55-2.68-.2z"
          className="Bolivia_svg__cls-42"
        />
        <path
          id="Bolivia_svg__path7233-6-2"
          d="M623.18 297.15a.7.7 0 0 0 0-.77v.19a.8.8 0 0 1 .11.18.23.23 0 0 1-.06.21.3.3 0 0 0 0 .12 1 1 0 0 0 0 .07"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7235-3-4"
          d="M630.34 299.2a.93.93 0 0 0 .43-.62.3.3 0 0 0 0-.14s0-.07 0 0a.93.93 0 0 1-.42.6s0 .18 0 .19"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7237-2-7"
          d="M631.41 299.12a.66.66 0 0 0 .14-.38.5.5 0 0 0 0-.12v.07a.46.46 0 0 1-.12.23s0 .08 0 .1v.1"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7239-2-5"
          d="M637.89 295.56a1.4 1.4 0 0 1 .12 1 .7.7 0 0 0 0 .17 1.93 1.93 0 0 0-.13-1.36s0 .14 0 .18"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7241-0-3"
          d="M637.24 296.22a1.9 1.9 0 0 1 .08 1s0 .21 0 .13a2.6 2.6 0 0 0-.09-1.3s0 .14 0 .19"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7243-5-1"
          d="M636.63 296.78a2 2 0 0 1-.07.7s0 .16 0 .19a2.7 2.7 0 0 0 .09-.89q0-.165 0 0"
          className="Bolivia_svg__cls-40"
        />
        <path
          id="Bolivia_svg__path7245-6-2"
          d="m645.38 315.7.14.38a.3.3 0 0 0 .09.14l-.2-.57v.05Z"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path7253-6-3"
          d="M630.68 292.42a9.63 9.63 0 0 1-5.11-1.56 4 4 0 0 1-3.37-3.5c-1.27-.49-2.37-3.76-2.37-3.76-2 1.18-4.45 0-4.45 0s0-.48-2.22 0-1.85-.41-1.85-.41.89-.9-3.06 0 .32-1.18.32-1.18a39 39 0 0 1-4.91.62 21.8 21.8 0 0 0-4.3 1.18c-1 .27-2.57.59-3.39.94-2.19.93-6.58 2.94-10.2 4.37-4.77 1.86-8.54 3.29-8.29 3.23s5.17-3.16 11.28-5.93a134 134 0 0 1 15.46-5.89 14.76 14.76 0 0 1 9.72 0c1 .34 6.23-.17 8.59.11s2.6 4.15 2.6 4.15c.44.28.6 3.92.6 3.92s-1.3 0 .23.24 4.33 2.43 4.33 2.43a8 8 0 0 0 1.06 0 3.6 3.6 0 0 1 1.32-1 8 8 0 0 1 2.33-.66 18 18 0 0 1 2.93 0c.86.1 1.87.1 3.08.33a9 9 0 0 1 1.72.43 1.4 1.4 0 0 0 .73 0c1.57-.66 4.49-1.82 5.16-1.69a5.6 5.6 0 0 0 1.7-.73c.59-.46 1.94-1.57 1.94-1.57s-.93-6.58 5.76-5.94 15.55 1.51 17.33 1.78a66 66 0 0 1 9.67 2.84c1.52.73 5.9 2.69 7.85 3.56.79.35 3.8 1.68 6 2.56a22.3 22.3 0 0 1 5.85 3.52c-2.1-.88-3.79-1.9-5.45-2.62-1.35-.58-2.75-.85-3.85-1.34-2.31-1-4.1-2-5.51-2.62-5.17-2.41-5.13-2.51-7.23-2.67-1.44-.12 1 1.76 1 1.76s-4.74-1.84-6.26-2.49a9 9 0 0 0-4.23-.83 8.7 8.7 0 0 1-3.39-.46c-.85-.28-5.67-.46-6.52-.55a10.4 10.4 0 0 1-1.52-.28l.34.55-2.3-.26-.68 1s-2.29.46-2.46-.28-1.35 3.32-1.94 4.52-3.3.8-4 1.54a8.4 8.4 0 0 1-2.46 1.41 6.3 6.3 0 0 1-1.95.1c-.89 0-.14 0-1.58.29a7 7 0 0 1-1.73-.21c-.48-.19-1.53-.5-2.06-.65a41 41 0 0 0-5.31-.26 8.2 8.2 0 0 0-2.18.59 5.4 5.4 0 0 0-1.75 1.1"
          className="Bolivia_svg__cls-34"
        />
        <path
          id="Bolivia_svg__path7255-1-6"
          d="M630.68 292.42a9.63 9.63 0 0 1-5.11-1.56 4 4 0 0 1-3.37-3.5c-1.27-.49-2.37-3.76-2.37-3.76-2 1.18-4.45 0-4.45 0s0-.48-2.22 0-1.85-.41-1.85-.41.89-.9-3.06 0 .32-1.18.32-1.18a39 39 0 0 1-4.91.62 21.8 21.8 0 0 0-4.3 1.18c-1 .27-2.57.59-3.39.94-2.19.93-6.58 2.94-10.2 4.37-4.77 1.86-8.54 3.29-8.29 3.23s5.17-3.16 11.28-5.93a134 134 0 0 1 15.46-5.89 14.76 14.76 0 0 1 9.72 0c1 .34 6.23-.17 8.59.11s2.6 4.15 2.6 4.15c.44.28.6 3.92.6 3.92s-1.3 0 .23.24 4.33 2.43 4.33 2.43a8 8 0 0 0 1.06 0 3.6 3.6 0 0 1 1.32-1 8 8 0 0 1 2.33-.66 18 18 0 0 1 2.93 0c.86.1 1.87.1 3.08.33a9 9 0 0 1 1.72.43 1.4 1.4 0 0 0 .73 0c1.57-.66 4.49-1.82 5.16-1.69a5.6 5.6 0 0 0 1.7-.73c.59-.46 1.94-1.57 1.94-1.57s-.93-6.58 5.76-5.94 15.55 1.51 17.33 1.78a66 66 0 0 1 9.67 2.84c1.52.73 5.9 2.69 7.85 3.56.79.35 3.8 1.68 6 2.56a22.3 22.3 0 0 1 5.85 3.52c-2.1-.88-3.79-1.9-5.45-2.62-1.35-.58-2.75-.85-3.85-1.34-2.31-1-4.1-2-5.51-2.62-5.17-2.41-5.13-2.51-7.23-2.67-1.44-.12 1 1.76 1 1.76s-4.74-1.84-6.26-2.49a9 9 0 0 0-4.23-.83 8.7 8.7 0 0 1-3.39-.46c-.85-.28-5.67-.46-6.52-.55a10.4 10.4 0 0 1-1.52-.28l.34.55-2.3-.26-.68 1s-2.29.46-2.46-.28-1.35 3.32-1.94 4.52-3.3.8-4 1.54a8.4 8.4 0 0 1-2.46 1.41 6.3 6.3 0 0 1-1.95.1c-.89 0-.14 0-1.58.29a7 7 0 0 1-1.73-.21c-.48-.19-1.53-.5-2.06-.65a41 41 0 0 0-5.31-.26 8.2 8.2 0 0 0-2.18.59 5.4 5.4 0 0 0-1.75 1.1"
          className="Bolivia_svg__cls-5"
        />
        <path
          id="Bolivia_svg__path7257-0-6"
          d="M630.94 291.65a1.13 1.13 0 0 0-.34.73c-.06.52 0 .31 0 .31"
          className="Bolivia_svg__cls-22"
        />
        <path
          id="Bolivia_svg__path7259-8-9"
          d="M643.94 290.9a8.5 8.5 0 0 1 1 .81s.11.1.08 0a.8.8 0 0 0-.16-.21 9.5 9.5 0 0 0-1.1-.91c-.07-.05 0 .07 0 .08a1 1 0 0 0 .18.2"
          style={{
            fill: "#574f4c",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgBolivia;
